webpackJsonp([1],{

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderIntegrativeAnalyses = exports.renderBmdByLab = exports.renderDoseResponse = exports.renderQualityControl = exports.renderDatasets = undefined;

var _DatasetsMain = __webpack_require__(1010);

var _DatasetsMain2 = _interopRequireDefault(_DatasetsMain);

var _QualityControlMain = __webpack_require__(1114);

var _QualityControlMain2 = _interopRequireDefault(_QualityControlMain);

var _DoseResponseMain = __webpack_require__(1115);

var _DoseResponseMain2 = _interopRequireDefault(_DoseResponseMain);

var _BmdByLabMain = __webpack_require__(1262);

var _BmdByLabMain2 = _interopRequireDefault(_BmdByLabMain);

var _IntegrativeAnalysesMain = __webpack_require__(1265);

var _IntegrativeAnalysesMain2 = _interopRequireDefault(_IntegrativeAnalysesMain);

var _shared = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderDatasets = function renderDatasets(el) {
    return (0, _shared.insertIntoDom)(_DatasetsMain2.default, el);
},
    renderQualityControl = function renderQualityControl(el) {
    return (0, _shared.insertIntoDom)(_QualityControlMain2.default, el);
},
    renderBmdByLab = function renderBmdByLab(el) {
    return (0, _shared.insertIntoDom)(_BmdByLabMain2.default, el);
},
    renderDoseResponse = function renderDoseResponse(el) {
    return (0, _shared.insertIntoDom)(_DoseResponseMain2.default, el);
},
    renderIntegrativeAnalyses = function renderIntegrativeAnalyses(el) {
    return (0, _shared.insertIntoDom)(_IntegrativeAnalysesMain2.default, el);
};
//renderExposureValue = (el) => insertIntoDom(ExposureValueMain, el),
//renderWidgets = (el) => insertIntoDom(WidgetsMain, el);

//import ExposureValueMain from './containers/ExposureValueMain';
//import WidgetsMain from './containers/WidgetsMain';

exports.renderDatasets = renderDatasets;
exports.renderQualityControl = renderQualityControl;
exports.renderDoseResponse = renderDoseResponse;
exports.renderBmdByLab = renderBmdByLab;
exports.renderIntegrativeAnalyses = renderIntegrativeAnalyses;

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FiveOhEight = __webpack_require__(126);

var _FiveOhEight2 = _interopRequireDefault(_FiveOhEight);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatasetsMain = function (_React$Component) {
    _inherits(DatasetsMain, _React$Component);

    function DatasetsMain(props) {
        _classCallCheck(this, DatasetsMain);

        var _this = _possibleConstructorReturn(this, (DatasetsMain.__proto__ || Object.getPrototypeOf(DatasetsMain)).call(this, props));

        _this.state = {
            // HelpButtonWidget
            showHelpText: false
        };
        return _this;
    }

    _createClass(DatasetsMain, [{
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'This page includes tabs that provide tabulated parameters of protocols (Tab name: Protocols), details of test substances (Tab name: Test Substances), the mapping of laboratory specific recording to phenotype ontology terms (Tab name: Phenotype Ontology).'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'White boxes in each table indicate search boxes.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'Tables are available to download in each tab.'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'd-flex flex-wrap mx-5 my-3' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                        'h1',
                        { className: 'label-horizontal' },
                        _react2.default.createElement('img', {
                            src: '/static_seazit/img/seazit/logo-5.png',
                            alt: 'Logo',
                            className: 'img-fluid',
                            style: { marginRight: '10px', height: '50px' }
                        }),
                        'Data',
                        _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: this,
                            headLevel: 'h1',
                            title: 'Click to toggle help-text'
                        })
                    ),
                    this._renderHelpText()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(_FiveOhEight2.default, null)
                )
            );
        }
    }]);

    return DatasetsMain;
}(_react2.default.Component);

exports.default = DatasetsMain;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pod_med_processed = exports.BMCHandleCellClick = exports.integrativeHandleCellClick = exports.svg_download_form = exports.data_exportToJsonFile = exports.renderNoSelected = exports.renderNoDataAlert = exports.exportCsv = exports.printFloat = exports.insertIntoDom = exports.renderSelectMultiOptgroupWidget = exports.renderSelectSingleWidget = exports.renderSelectMultiWidget = exports.loadBaseUrl = exports.loadMetadata = exports.getSankeyPlotUrl = exports.getIntegrativeUrl = exports.getBmdsUrl = exports.getDoseResponsesUrl = exports.URL_SANKEYDATA = exports.URL_CHEMXLSX = exports.READOUT_TYPE_CATEGORY = exports.READOUT_TYPE_READOUT = exports.BMDVIZ_SELECTIVITY = exports.BMDVIZ_ACTIVITY = exports.INTVIZ_HEATMAP = exports.INTVIZ_DevtoxHEATMAP = exports.HEATMAP_BMC = exports.HEATMAP_ACTIVITY = exports.NO_COLLAPSE = exports.COLLAPSE_WITH_Mortality120 = exports.COLLAPSE_BY_READOUT = exports.COLLAPSE_BY_CHEMICAL = exports.CHEMLIST_ALL = exports.CHEMLIST_91 = exports.CHEMLIST_80 = exports.IntegrativeAnalysesTab = exports.BMCTab = exports.ConcentrationResponseTab = exports.CHEMFILTER_CHEMICIAL = exports.CHEMFILTER_CATEGORY = exports.CATEGORY_COLORS = exports.integrative_General = exports.integrative_Granular = exports.BMD_CW = exports.BMD_HILL = exports.BMD_CURVEP = exports.AXIS_SQRT = exports.AXIS_LOG10 = exports.AXIS_LINEAR = undefined;

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(51);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Tooltip = __webpack_require__(169);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _BootstrapBodyPart = __webpack_require__(129);

var _BootstrapModal = __webpack_require__(130);

var _BootstrapModal2 = _interopRequireDefault(_BootstrapModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AXIS_LINEAR = 1,
    AXIS_LOG10 = 2,
    AXIS_SQRT = 3,
    BMD_CURVEP = 1,
    BMD_HILL = 2,
    BMD_CW = {
    1: 'curvep',
    2: 'hill'
},
    integrative_Granular = 1,
    integrative_General = 2,
    CATEGORY_COLORS = {
    Insecticide: '#d62976',
    Fungicide: '#f9d70b',
    Herbicide: '#3BD6C6',
    'Positive Control': '#ee7621',
    Preservative: '#c89f73',
    'Industrial Compound': '#31a354',
    PAH: '#756bb1',
    'Flame Retardant': '#e7ba52',
    Drug: '#3182bd',
    'Vehicle Control': '#ee7621'
},
    CHEMFILTER_CATEGORY = 1,
    CHEMFILTER_CHEMICIAL = 2,
    CHEMLIST_80 = 1,
    CHEMLIST_91 = 2,
    CHEMLIST_ALL = 3,
    ConcentrationResponseTab = 1,
    BMCTab = 2,
    IntegrativeAnalysesTab = 3,
    COLLAPSE_BY_CHEMICAL = 'COLLAPSE_BY_CHEMICAL',
    COLLAPSE_BY_READOUT = 'COLLAPSE_BY_READOUT',
    NO_COLLAPSE = 'NO_COLLAPSE',
    COLLAPSE_WITH_Mortality120 = 'COLLAPSE_WITH_Mortality120',
    URL_CHEMXLSX = '/static_seazit/resources/seazit/NTP%20Chemical%20Library.xlsx',
    URL_METADATA = '/seazit/api/seazit_metadata/metadata/?format=json',
    URL_SANKEYDATA = '/seazit/api/seazit_sankeydata/sankeydata/?format=json',

// ConcentrationResponse URL
URL_CR = '/seazit/api/seazit_result/crResult/',

// BMC by lab URL
URL_BMD = '/seazit/api/seazit_result/bmcByLabResult/',
    URL_INTEGRATIVE = '/seazit/api/seazit_result/integrativeResult/',
    INTVIZ_HEATMAP = 1,
    INTVIZ_DevtoxHEATMAP = 2,
    BMDVIZ_ACTIVITY = 1,
    BMDVIZ_SELECTIVITY = 2,
    HEATMAP_ACTIVITY = 1,
    HEATMAP_BMC = 2,
    READOUT_TYPE_READOUT = 1,
    READOUT_TYPE_CATEGORY = 2,
    loadMetadata = function loadMetadata(component) {
    d3.json(URL_METADATA, function (d) {
        // //console.log('d');
        // //console.log(d);
        component.setState({
            metadataLoaded: true,
            protocol_data: d.protocol_data,
            Seazit_chemical_info: d.Seazit_chemical_info,
            Seazit_ui_panel: d.Seazit_ui_panel,
            Seazit_ontology: d.Seazit_ontology
        });
    });
},
    loadBaseUrl = function loadBaseUrl(inputPath) {
    var currentUrl = window.location.href;

    // Extract the base URL containing just the protocol, hostname, and port
    var baseUrl = currentUrl.split('/', 3).join('/');

    // Construct the dynamic URL by appending the input path to the base URL
    // var result = baseUrl + inputPath;

    // Return the result
    return baseUrl + inputPath;
},
    data_exportToJsonFile = function data_exportToJsonFile(jsonData) {
    var filename = 'jsonData.json';

    var dataStr = JSON.stringify(jsonData);
    var dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);

    var linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', filename);
    linkElement.click();
},
    renderSelectMultiWidget = function renderSelectMultiWidget(name, label, options, values, handleChange) {
    var helpButtonWidget = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var renderHelpText = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

    var size = Math.min(options.length, 11);
    //console.log(options);
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'label',
            { className: 'label-horizontal' },
            'Select ',
            label,
            '(s):',
            helpButtonWidget && helpButtonWidget()
        ),
        renderHelpText && renderHelpText(),
        _react2.default.createElement(
            'select',
            {
                name: name,
                className: 'form-control',
                multiple: true,
                size: size,
                onChange: handleChange,
                value: values
            },
            options.map(function (d) {
                if (d.description) {
                    return _react2.default.createElement(
                        _Tooltip2.default,
                        { title: d.description, placement: 'top' },
                        _react2.default.createElement(
                            'option',
                            { key: d.key, value: d.key },
                            d.label
                        )
                    );
                } else {
                    return _react2.default.createElement(
                        'option',
                        { key: d.key, value: d.key },
                        d.label
                    );
                }
            })
        )
    );
},
    renderSelectSingleWidget = function renderSelectSingleWidget(name, label, options, values, handleChange) {
    var helpButtonWidget = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var renderHelpText = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

    var size = 10;
    //console.log(options)

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'label',
            { className: 'label-horizontal' },
            'Select one ',
            label,
            ': ',
            helpButtonWidget && helpButtonWidget()
        ),
        renderHelpText && renderHelpText(),
        _react2.default.createElement(
            'select',
            {
                name: name,
                className: 'form-control custom-select-height',
                onChange: handleChange,
                size: size,
                value: values
            },
            options.map(function (d) {
                if (d.description) {
                    return _react2.default.createElement(
                        _Tooltip2.default,
                        { key: d.key, title: d.description, placement: 'top' },
                        _react2.default.createElement(
                            'option',
                            { value: d.key },
                            d.label
                        )
                    );
                } else {
                    return _react2.default.createElement(
                        'option',
                        { key: d.key, value: d.key },
                        d.label
                    );
                }
            })
        )
    );
},
    renderSelectMultiOptgroupWidget = function renderSelectMultiOptgroupWidget(name, label, options, values, handleChange) {
    var helpButtonWidget = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var renderHelpText = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

    var size = 10;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'label',
            { className: 'label-horizontal' },
            'Select ',
            label,
            '(s):',
            helpButtonWidget && helpButtonWidget()
        ),
        renderHelpText && renderHelpText(),
        _react2.default.createElement(
            'select',
            {
                name: name,
                className: 'form-select',
                size: size,
                onChange: handleChange,
                value: values,
                multiple: true
            },
            _lodash2.default.map(options, function (value, category) {
                return _react2.default.createElement(
                    'optgroup',
                    { key: category, label: category },
                    value.map(function (d) {
                        if (d.description) {
                            return _react2.default.createElement(
                                _Tooltip2.default,
                                { title: d.description, placement: 'top' },
                                _react2.default.createElement(
                                    'option',
                                    { key: d.key, value: d.key },
                                    d.label
                                )
                            );
                        } else {
                            return _react2.default.createElement(
                                'option',
                                { key: d.key, value: d.key },
                                d.label
                            );
                        }
                    })
                );
            })
        )
    );
},
    insertIntoDom = function insertIntoDom(Component, el) {
    _reactDom2.default.render(_react2.default.createElement(Component), el);
},
    getDoseResponsesUrl = function getDoseResponsesUrl(protocol_ids, readout_ids, casrns) {
    if (protocol_ids.length === 0 || readout_ids.length === 0 || casrns.length === 0) {
        return null;
    }
    var ids = protocol_ids.join(','),
        ro = readout_ids.join(','),
        chems = casrns.join(',');
    // return url, ro is the readout_id
    // //console.log(ids, ro, chems);
    return URL_CR + '?format=json&protocol_ids=' + ids + '&readouts=' + ro + '&casrns=' + chems;
},
    getBmdsUrl = function getBmdsUrl(protocol_id, readout_ids) {
    if (protocol_id.length === 0 || readout_ids.length === 0) {
        return null;
    }
    // //console.log(protocol_id, readout_ids)
    var newReadout = 'Mortality@120' + '_' + protocol_id;
    readout_ids.push(newReadout); // Modifying the array by adding a new element
    // //console.log(protocol_id, readout_ids)

    var id = protocol_id,
        ro = readout_ids.join(',');
    // return url, ro is the readout_id
    // Mortality@120
    return URL_BMD + '?format=json&protocol_ids=' + id + '&readouts=' + ro;
},
    getIntegrativeUrl = function getIntegrativeUrl(protocol_ids, casrns) {
    if (protocol_ids.length === 0 || casrns.length === 0) {
        return null;
    }
    var ids = protocol_ids.join(','),
        chems = casrns.join(',');
    // return url, ro is the readout_id
    // //console.log(ids, ro, chems);
    return URL_INTEGRATIVE + '?format=json&protocol_ids=' + ids + '&casrns=' + chems;
},
    getSankeyPlotUrl = function getSankeyPlotUrl(protocol_ids, casrns) {
    if (protocol_ids.length === 0 || casrns.length === 0) {
        return null;
    }
    var ids = protocol_ids.join(','),
        chems = casrns.join(',');
    // return url, ro is the readout_id
    // //console.log(ids, ro, chems);
    return URL_INTEGRATIVE + '?format=json&protocol_ids=' + ids + '&casrns=' + chems;
},
    printFloat = function printFloat(v) {
    if (v <= 0) {
        return '-';
    } else if (v <= 0.01 || v >= 1000) {
        return v.toExponential(2).toUpperCase();
    } else {
        return v.toFixed(2);
    }
},
    pod_med_processed = function pod_med_processed(v) {
    if (typeof v === 'number') {
        return Math.pow(10, v) * 1000000;
    }
},
    svg_download_form = function svg_download_form(id) {
    var svg = document.getElementById(id);

    var today = new Date();
    var filename = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + '-' + today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds() + '.svg';
    var svg_xml = new XMLSerializer().serializeToString(svg);
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(svg_xml));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
},
    exportCsv = function exportCsv(jsonData, filename, headerMappings) {
    if (jsonData.length === 0) {
        return '';
    }
    //console.log(jsonData);
    var columnDelimiter = ',';
    var lineDelimiter = '\n';

    // Extract keys and sections from headerMappings
    var selectedKeys = headerMappings.map(function (mapping) {
        return {
            key: mapping.key,
            section: mapping.section,
            method: mapping.method
        };
    });

    //console.log(selectedKeys);

    var csvColumnHeader = headerMappings.map(function (mapping) {
        return mapping.title;
    }).join(columnDelimiter);
    var csvStr = csvColumnHeader + lineDelimiter;

    var extractValue = function extractValue(item, key, section, method) {
        // Handle nested properties within a specific section
        if (section) {
            var sectionKeys = section.split('.');
            var sectionData = item;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = sectionKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var sectionKey = _step.value;

                    sectionData = sectionData[sectionKey];
                    if (sectionData === undefined) {
                        return '';
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return applyMethod(sectionData[key], method);
        } else {
            // Handle flat properties
            return applyMethod(item[key], method);
        }
    };

    var applyMethod = function applyMethod(value, method) {
        // Apply the specified method to the value
        switch (method) {
            case 'processMedPodMed':
                var processedValue = pod_med_processed(value);

                if (processedValue !== undefined) {
                    return printFloat(processedValue);
                } else {
                    return processedValue;
                }

            case 'length':
                // return value.length;
                return value && value.length !== undefined ? value.length : 0;

            case 'cat':
                return Array.isArray(value) ? value.join(' | ') : value;
            case 'map':
                var mapList = [{
                    name: 'dev tox',
                    label: 'specific'
                }, {
                    name: 'general tox',
                    label: 'non-specific'
                }, {
                    name: 'inconclusive',
                    label: 'inconclusive, more tests are needed'
                }, {
                    name: 'inactive',
                    label: 'non-toxic'
                }];
                var mappedValue = mapList.find(function (item) {
                    return item.name === value;
                });
                return mappedValue ? mappedValue.label : value;
            default:
                return value;
        }
    };

    jsonData.forEach(function (item) {
        selectedKeys.forEach(function (_ref, index) {
            var key = _ref.key,
                section = _ref.section,
                method = _ref.method;

            if (index > 0 && index < selectedKeys.length) {
                csvStr += columnDelimiter;
            }
            var value = extractValue(item, key, section, method);
            csvStr += '"' + value + '"';
        });
        csvStr += lineDelimiter;
    });
    csvStr = encodeURIComponent(csvStr);

    var dataUri = 'data:text/csv;charset=utf-8,' + csvStr;
    var linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', filename);
    linkElement.click();
},
    integrativeHandleCellClick = function integrativeHandleCellClick(d) {
    //console.log(d);
    var headingHtml = '\n        ' + d.devtoxEndPointList.length + ' of ' + d.endPointList.length + ' endpoints are associated with ' + d.ontologyGroupName + '\n    ';
    if (d.endPointList) {
        if (d.endPointList && d.endPointList.length > 1) {
            new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.MultipleCurveBody, {
                title: d.title,
                // ontologyGroupName: d.ontologyGroupName,
                protocol_id: d.protocol_id,
                readout_ids: _lodash2.default.map(d.endPointList, function (x) {
                    return x + '_' + d.protocol_id;
                }),
                // if button checked, we will add mortality@120 to each plot
                casrns: [d.casrn],
                devtoxEndPointList: d.devtoxEndPointList,
                fill: d.fill,
                heading: headingHtml
            });
        } else {
            new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.SingleCurveBody, {
                title: d.title,
                // ontologyGroupName: d.ontologyGroupName,
                protocol_id: d.protocol_id,
                readout_id: d.endpoint_name + '_' + d.protocol_id,
                casrn: d.casrn,
                devtoxEndPointList: d.devtoxEndPointList,
                fill: d.fill,
                heading: headingHtml
            });
        }
    }
},
    BMCHandleCellClick = function BMCHandleCellClick(d, clickType) {
    // console.log('SingleCurveBody', d);
    var headingHtml = '\n        ' + d.endpoint_name + ' endpoint has the lowest BMC in selected endpoints\n    ';
    switch (clickType) {
        case 'nonviabilityData':
            new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.SingleCurveBody, {
                // title: d.preferred_name + `: ` + d.endpoint_name,
                title: d.endpoint_name + '+' + d.protocol_name_plot + '+' + d.preferred_name,
                protocol_id: d.protocol_id,
                readout_id: d.endpoint_name + '_' + d.protocol_id,
                casrn: d.casrn,
                final_dev_call: d.final_dev_call,
                heading: headingHtml
            });
            break;
        case 'viabilityData':
            new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.SingleCurveBody, {
                // title: d.preferred_name + `: ` + 'Mortality@120',
                title: d.endpoint_name + '+' + d.protocol_name_plot + '+' + d.preferred_name + '+ ' + 'Mortality@120',
                protocol_id: d.protocol_id,
                readout_id: 'Mortality@120' + '_' + d.protocol_id,
                casrn: d.casrn,
                CheckBoxDisable: true,
                final_dev_call: d.final_dev_call
                // heading: headingHtml,
            });
            break;
        // Add more cases if needed for different click types
        default:
            break;
    }
},
    renderNoDataAlert = function renderNoDataAlert() {
    return _react2.default.createElement(
        'div',
        { className: 'alert alert-info' },
        _react2.default.createElement(
            'p',
            null,
            'This combination of ',
            _react2.default.createElement(
                'b',
                null,
                'phenotype terms'
            ),
            ' and ',
            _react2.default.createElement(
                'b',
                null,
                'test substances'
            ),
            ' returned no data.'
        )
    );
},
    renderNoSelected = function renderNoSelected(d) {
    //console.log(d);
    return _react2.default.createElement(
        'div',
        { className: 'alert alert-info' },
        _react2.default.createElement(
            'ul',
            null,
            d.hasAssay !== undefined && !d.hasAssay ? _react2.default.createElement(
                'li',
                null,
                'No ',
                _react2.default.createElement(
                    'b',
                    null,
                    'endpoints'
                ),
                ' are selected. Please select at least one endpoint (you must first select one dataset).'
            ) : null,
            d.hasAssay && !d.hasReadouts ? _react2.default.createElement(
                'li',
                null,
                'No ',
                _react2.default.createElement(
                    'b',
                    null,
                    'endpoints'
                ),
                ' are selected. Please select at least one endpoint.'
            ) : null,
            d.hasReadoutCategories !== undefined && !d.hasReadoutCategories ? _react2.default.createElement(
                'li',
                null,
                'No ',
                _react2.default.createElement(
                    'b',
                    null,
                    'endpoint categories'
                ),
                ' are selected. Please select at least one endpoint-category.'
            ) : null,
            d.hasChems !== undefined && !d.hasChems ? _react2.default.createElement(
                'li',
                null,
                'No ',
                _react2.default.createElement(
                    'b',
                    null,
                    'chemicals'
                ),
                ' are selected. Please select at least one chemical or chemical-category.'
            ) : null
        )
    );
};

exports.AXIS_LINEAR = AXIS_LINEAR;
exports.AXIS_LOG10 = AXIS_LOG10;
exports.AXIS_SQRT = AXIS_SQRT;
exports.BMD_CURVEP = BMD_CURVEP;
exports.BMD_HILL = BMD_HILL;
exports.BMD_CW = BMD_CW;
exports.integrative_Granular = integrative_Granular;
exports.integrative_General = integrative_General;
exports.CATEGORY_COLORS = CATEGORY_COLORS;
exports.CHEMFILTER_CATEGORY = CHEMFILTER_CATEGORY;
exports.CHEMFILTER_CHEMICIAL = CHEMFILTER_CHEMICIAL;
exports.ConcentrationResponseTab = ConcentrationResponseTab;
exports.BMCTab = BMCTab;
exports.IntegrativeAnalysesTab = IntegrativeAnalysesTab;
exports.CHEMLIST_80 = CHEMLIST_80;
exports.CHEMLIST_91 = CHEMLIST_91;
exports.CHEMLIST_ALL = CHEMLIST_ALL;
exports.COLLAPSE_BY_CHEMICAL = COLLAPSE_BY_CHEMICAL;
exports.COLLAPSE_BY_READOUT = COLLAPSE_BY_READOUT;
exports.COLLAPSE_WITH_Mortality120 = COLLAPSE_WITH_Mortality120;
exports.NO_COLLAPSE = NO_COLLAPSE;
exports.HEATMAP_ACTIVITY = HEATMAP_ACTIVITY;
exports.HEATMAP_BMC = HEATMAP_BMC;
exports.INTVIZ_DevtoxHEATMAP = INTVIZ_DevtoxHEATMAP;
exports.INTVIZ_HEATMAP = INTVIZ_HEATMAP;
exports.BMDVIZ_ACTIVITY = BMDVIZ_ACTIVITY;
exports.BMDVIZ_SELECTIVITY = BMDVIZ_SELECTIVITY;
exports.READOUT_TYPE_READOUT = READOUT_TYPE_READOUT;
exports.READOUT_TYPE_CATEGORY = READOUT_TYPE_CATEGORY;
exports.URL_CHEMXLSX = URL_CHEMXLSX;
exports.URL_SANKEYDATA = URL_SANKEYDATA;
exports.getDoseResponsesUrl = getDoseResponsesUrl;
exports.getBmdsUrl = getBmdsUrl;
exports.getIntegrativeUrl = getIntegrativeUrl;
exports.getSankeyPlotUrl = getSankeyPlotUrl;
exports.loadMetadata = loadMetadata;
exports.loadBaseUrl = loadBaseUrl;
exports.renderSelectMultiWidget = renderSelectMultiWidget;
exports.renderSelectSingleWidget = renderSelectSingleWidget;
exports.renderSelectMultiOptgroupWidget = renderSelectMultiOptgroupWidget;
exports.insertIntoDom = insertIntoDom;
exports.printFloat = printFloat;
exports.exportCsv = exportCsv;
exports.renderNoDataAlert = renderNoDataAlert;
exports.renderNoSelected = renderNoSelected;
exports.data_exportToJsonFile = data_exportToJsonFile;
exports.svg_download_form = svg_download_form;
exports.integrativeHandleCellClick = integrativeHandleCellClick;
exports.BMCHandleCellClick = BMCHandleCellClick;
exports.pod_med_processed = pod_med_processed;

/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FiveOhEight = __webpack_require__(126);

var _FiveOhEight2 = _interopRequireDefault(_FiveOhEight);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QualityControlMain = function (_React$Component) {
    _inherits(QualityControlMain, _React$Component);

    function QualityControlMain(props) {
        _classCallCheck(this, QualityControlMain);

        var _this = _possibleConstructorReturn(this, (QualityControlMain.__proto__ || Object.getPrototypeOf(QualityControlMain)).call(this, props));

        _this.state = {
            // HelpButtonWidget
            showHelpText: false
        };
        return _this;
    }

    _createClass(QualityControlMain, [{
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'The page allows for data comparison of vehicle control (VC), positive control (PC, add in chemical name), and duplicated test substances (aldicarb, bisphenol A, and valproic acid) across datasets. Particularly, the data from the three endpoints are compared:'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'ol',
                    { style: { paddingLeft: '40px' } },
                    _react2.default.createElement(
                        'li',
                        null,
                        'MalformedAny+Mort@120 (i.e., percent of affected embryo [the embryo is either dead or with altered phenotypes] at 120 hour-post-fertilization (hpf))'
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        'Mortality@120 (i.e., percent of dead embryos at 120 hpf)'
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        'Mortality@24 (i.e., percent of dead embryos at 24 hpf)'
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    'Dataset information can be viewed and downloaded in tabular form underneath each figure. Tabular results can be resorted by selecting any of the table headings. White blank boxes indicate search boxes.'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    'Options for editing or saving images are provided by hovering over the upper right side of each image.'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'd-flex flex-wrap mx-5 my-3' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                        'h1',
                        { className: 'label-horizontal' },
                        _react2.default.createElement('img', {
                            src: '/static_seazit/img/seazit/logo-5.png',
                            alt: 'Logo',
                            className: 'img-fluid',
                            style: { marginRight: '10px', height: '50px' }
                        }),
                        'Quality Check',
                        _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: this,
                            headLevel: 'h1',
                            title: 'Click to toggle help-text'
                        })
                    ),
                    this._renderHelpText()
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(_FiveOhEight2.default, null)
                )
            );
        }
    }]);

    return QualityControlMain;
}(_react2.default.Component);

exports.default = QualityControlMain;

/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Loading = __webpack_require__(86);

var _Loading2 = _interopRequireDefault(_Loading);

var _DoseResponse = __webpack_require__(176);

var _DoseResponse2 = _interopRequireDefault(_DoseResponse);

var _FiveOhEight = __webpack_require__(126);

var _FiveOhEight2 = _interopRequireDefault(_FiveOhEight);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

var _ChemicalWidget = __webpack_require__(509);

var _ChemicalWidget2 = _interopRequireDefault(_ChemicalWidget);

var _ReadoutWidget = __webpack_require__(295);

var _ReadoutWidget2 = _interopRequireDefault(_ReadoutWidget);

var _DoseResponseGridWidget = __webpack_require__(272);

var _DoseResponseGridWidget2 = _interopRequireDefault(_DoseResponseGridWidget);

var _PlotCollapseWidget = __webpack_require__(1261);

var _PlotCollapseWidget2 = _interopRequireDefault(_PlotCollapseWidget);

var _shared = __webpack_require__(11);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DoseResponseMain = function (_React$Component) {
    _inherits(DoseResponseMain, _React$Component);

    // lifecycle
    function DoseResponseMain(props) {
        _classCallCheck(this, DoseResponseMain);

        var _this = _possibleConstructorReturn(this, (DoseResponseMain.__proto__ || Object.getPrototypeOf(DoseResponseMain)).call(this, props));

        var initialCols = Math.max(1, Math.floor(0.75 * window.innerWidth / 400));
        _this.state = {
            metadataLoaded: false,
            metadata: null,
            showHelpText: false,
            chemList: _shared.CHEMLIST_80,
            chemicalFilterBy: _shared.CHEMFILTER_CATEGORY,
            chemicals: [],
            categories: [],
            ontologyType: _shared.integrative_Granular,
            assays: [],
            readouts: [],
            plotCollapse: _shared.NO_COLLAPSE,
            vizColumns: initialCols,
            vizHeight: 350,
            tabFlag: _shared.ConcentrationResponseTab
        };
        return _this;
    }

    _createClass(DoseResponseMain, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            (0, _shared.loadMetadata)(this);
        }
    }, {
        key: 'renderNoSelection',
        value: function renderNoSelection() {
            return (0, _shared.renderNoSelected)({
                hasReadouts: this.state.readouts.length > 0,
                hasChems: this.state.chemicals.length > 0
            });
        }
    }, {
        key: 'renderSelection',
        value: function renderSelection(url) {
            var title = void 0;
            switch (this.state.plotCollapse) {
                case _shared.COLLAPSE_BY_READOUT:
                    title = 'Endpoint: response of all test substances selected per endpoint and dataset';
                    break;
                case _shared.COLLAPSE_BY_CHEMICAL:
                    title = 'Test substance: response for all datasets and endpoints selected per substance';
                    break;
                case _shared.NO_COLLAPSE:
                    title = 'Test substance + Endpoint: response for each dataset, test substance, and endpoint selected';
                    break;
                default:
                    title = '';
            }
            return _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                    'h3',
                    { className: 'text-center' },
                    title
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(_DoseResponse2.default, {
                    cols: this.state.vizColumns,
                    collapse: this.state.plotCollapse,
                    height: this.state.vizHeight,
                    url: url
                })
            );
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info ' },
                _react2.default.createElement(
                    'p',
                    null,
                    'This page allows for the visualization of concentration-response curves. Panels on the left provide the options to select data of user\u2019s interests.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'Concentration response curves can be visualized in different ways to focus on (1) a single test substance and endpoint, (2) all endpoints per test substance, and (3) all test substances per endpoint selected. Selection of endpoints will appear after a dataset(s) has been selected since these terms are dataset specific. For figures including a gray dashed horizontal line, this represents the benchmark response (BMR), and is available if one of the concentration-response curves is considered active in the analysis. By mousing over a concentration-response curve, the associated data (plate or endpoint or substance, depending on the view) will appear. Additionally, the benchmark concentration (BMC) will appear if the respective curve is considered active in the analysis. Some selections may result in an overlap of data point or plot.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    ' ',
                    'These concentration response curves have been integrated into other SEAZIT-DIVER tools including the',
                    ' ',
                    _react2.default.createElement(
                        'a',
                        { href: (0, _shared.loadBaseUrl)('/seazit/seazit_integrative/') },
                        'Integrative Analyses'
                    ),
                    ' ',
                    'and',
                    ' ',
                    _react2.default.createElement(
                        'a',
                        { href: (0, _shared.loadBaseUrl)('/seazit/seazit_bmcByLab/') },
                        'BMC by dataset'
                    ),
                    '.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'Options for editing or saving charts are provided by toggling over the upper right side of each chart. A maximum of 40 charts can be viewed at once.'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.metadataLoaded) {
                return _react2.default.createElement(_Loading2.default, null);
            }
            var url = (0, _shared.getDoseResponsesUrl)(this.state.assays, this.state.readouts, this.state.chemicals);

            return _react2.default.createElement(
                'div',
                { className: 'd-flex flex-wrap mx-5 my-3' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                        'h1',
                        { className: 'label-horizontal' },
                        _react2.default.createElement('img', {
                            src: '/static_seazit/img/seazit/logo-5.png',
                            alt: 'Logo',
                            className: 'img-fluid',
                            style: { marginRight: '10px', height: '50px' }
                        }),
                        'Concentration Response',
                        _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: this,
                            headLevel: 'h1',
                            title: 'Click to toggle help-text'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(_FiveOhEight2.default, null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-3 pe-3' },
                    _react2.default.createElement(_ReadoutWidget2.default, {
                        stateHolder: this,
                        hideViability: false,
                        hideNonViability: false,
                        multiAssaySelector: true,
                        multiReadoutSelector: true
                    }),
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(_ChemicalWidget2.default, { stateHolder: this }),
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(_PlotCollapseWidget2.default, { stateHolder: this }),
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(_DoseResponseGridWidget2.default, { stateHolder: this })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-9' },
                    this._renderHelpText(),
                    url ? this.renderSelection(url) : this.renderNoSelection()
                )
            );
        }
    }]);

    return DoseResponseMain;
}(_react2.default.Component);

exports.default = DoseResponseMain;

/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

__webpack_require__(1118);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shared = __webpack_require__(11);

var _SankeyPlot = __webpack_require__(451);

var _SankeyPlot2 = _interopRequireDefault(_SankeyPlot);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntegrativeCheckBoxWidget = function (_BaseWidget) {
    _inherits(IntegrativeCheckBoxWidget, _BaseWidget);

    /*
    IntegrativeCheckBoxWidget requires the following state properties:
        - stateHolder.state.IntegrativeCheckBoxWidget
    */
    function IntegrativeCheckBoxWidget(props) {
        _classCallCheck(this, IntegrativeCheckBoxWidget);

        return _possibleConstructorReturn(this, (IntegrativeCheckBoxWidget.__proto__ || Object.getPrototypeOf(IntegrativeCheckBoxWidget)).call(this, props));
    }

    _createClass(IntegrativeCheckBoxWidget, [{
        key: 'render',
        value: function render() {
            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', {
                    type: 'checkbox',
                    name: 'mortalityCheck',
                    onChange: this.handleToggleChange,
                    value: state.mortalityCheck
                }),
                _react2.default.createElement(
                    'span',
                    null,
                    ' \xA0 Add mortality@120 responses'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('div', { className: 'magentaBox' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        ' \xA0Specific developmental toxicity effect'
                    )
                )
            );
        }
    }]);

    return IntegrativeCheckBoxWidget;
}(_BaseWidget3.default);

IntegrativeCheckBoxWidget.propTypes = {
    fill: _propTypes2.default.string
};

exports.default = IntegrativeCheckBoxWidget;

/***/ }),

/***/ 1118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"react-switch-checkbox":"Switch__react-switch-checkbox___2tgED","react-switch-label":"Switch__react-switch-label___2IdRs","react-switch-button":"Switch__react-switch-button___15b5h","slider":"Switch__slider___1-yi7","round":"Switch__round___2_1jB","switch":"Switch__switch___2q0Rq"};

/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BootstrapModal = __webpack_require__(130);

var _BootstrapModal2 = _interopRequireDefault(_BootstrapModal);

var _BootstrapBodyPart = __webpack_require__(129);

var _shared = __webpack_require__(11);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BmdTable = function (_React$Component) {
    _inherits(BmdTable, _React$Component);

    function BmdTable(props) {
        _classCallCheck(this, BmdTable);

        var _this = _possibleConstructorReturn(this, (BmdTable.__proto__ || Object.getPrototypeOf(BmdTable)).call(this, props));

        _this.tableStyle = function () {
            return {
                width: '20%',
                textAlign: 'center',
                verticalAlign: 'middle'
            };
        };

        _this.renderMortalityModal = function (jsonData, flag) {
            if (!jsonData) {
                // match button padding-left
                return _react2.default.createElement(
                    'span',
                    { style: { paddingLeft: 12 } },
                    '-'
                );
            }
            // console.log( jsonData,jsonData.minimimumNonViability, jsonData.minimimumViability)
            var showModal = function showModal() {
                // console.log( jsonData)
                new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.SingleCurveBody, {
                    // title: `${d.preferred_name} (${d.chemical_casrn}): ${d.readout_endpoint}`,
                    title: flag == 'NonMortality' ? jsonData.preferred_name + ': ' + jsonData.minimimumNonViability.endpoint_name : jsonData.preferred_name + ': ' + 'Mortality@120',
                    protocol_id: jsonData.protocol_id,
                    readout_id: flag == 'NonMortality' ? jsonData.minimimumNonViability.endpoint_name + '_' + jsonData.protocol_id : 'Mortality@120' + '_' + jsonData.protocol_id,
                    casrn: jsonData.casrn,
                    CheckBoxDisable: flag == 'NonMortality' ? false : true
                });
            };
            var med_result = void 0,
                min_med_result = void 0,
                max_med_result = void 0,
                d = void 0;

            if (flag == 'NonMortality') {
                d = jsonData.minimimumNonViability;
                med_result = d.med_pod_med ? (0, _shared.printFloat)((0, _shared.pod_med_processed)(d.med_pod_med)) : '-', min_med_result = d.min_pod_med ? (0, _shared.printFloat)((0, _shared.pod_med_processed)(d.min_pod_med)) : '', max_med_result = d.max_pod_med ? (0, _shared.printFloat)((0, _shared.pod_med_processed)(d.max_pod_med)) : '';
            } else {
                d = jsonData.minimimumViability;
                med_result = d.mort_med_pod_med ? (0, _shared.printFloat)((0, _shared.pod_med_processed)(d.mort_med_pod_med)) : '-', min_med_result = d.mort_min_pod_med ? (0, _shared.printFloat)((0, _shared.pod_med_processed)(d.mort_min_pod_med)) : '', max_med_result = d.mort_max_pod_med ? (0, _shared.printFloat)((0, _shared.pod_med_processed)(d.mort_max_pod_med)) : '';
            }
            return _react2.default.createElement(
                'button',
                { className: 'btn btn-link', onClick: showModal, style: { textAlign: 'left' } },
                med_result,
                _react2.default.createElement('br', null),
                '(',
                min_med_result,
                ' \u2013 ',
                max_med_result,
                ')'
            );
        };

        _this.renderRow = _this.renderRow.bind(_this);
        return _this;
    }

    _createClass(BmdTable, [{
        key: 'renderRow',
        value: function renderRow(d) {
            switch (this.props.visualization) {
                case _shared.BMDVIZ_ACTIVITY:
                    return _react2.default.createElement(
                        'tr',
                        { key: d.casrn },
                        _react2.default.createElement(
                            'td',
                            null,
                            d.preferred_name
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            d.casrn
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            d.use_category1
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            this.renderMortalityModal(d, 'NonMortality')
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            this.renderMortalityModal(d, 'Mortality')
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            d.n_values
                        )
                    );

                case _shared.BMDVIZ_SELECTIVITY:
                    return _react2.default.createElement(
                        'tr',
                        { key: d.casrn },
                        _react2.default.createElement(
                            'td',
                            null,
                            d.preferred_name
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            d.casrn
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            d.use_category1
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            d.malformation
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            _react2.default.createElement(
                                'ul',
                                null,
                                Array.isArray(d.combin_ontology) && !d.combin_ontology.includes(null) ? d.combin_ontology.map(function (value, index) {
                                    return _react2.default.createElement(
                                        'li',
                                        { key: 'index-' + index },
                                        value
                                    );
                                }) : '-'
                            )
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            _react2.default.createElement(
                                'ul',
                                null,
                                Array.isArray(d.combin_ontology_id) && !d.combin_ontology_id.includes(null) ? d.combin_ontology_id.map(function (value, index) {
                                    return _react2.default.createElement(
                                        'li',
                                        { key: index },
                                        _react2.default.createElement(
                                            'a',
                                            {
                                                href: 'https://www.ebi.ac.uk/ols/ontologies/zp/terms?iri=http%3A%2F%2Fpurl.obolibrary.org%2Fobo%2F' + value.toString().split(':').join('_'),
                                                target: '_blank'
                                            },
                                            value
                                        )
                                    );
                                }) : '-'
                            )
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            d.n_values
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            (0, _shared.printFloat)((0, _shared.pod_med_processed)(d.mean_pod))
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            this.renderMortalityModal(d, 'Mortality')
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            (0, _shared.printFloat)(d.mean_selectivity)
                        )
                    );

                default:
                    return null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.data.length === 0) {
                return null;
            }
            var medData = this.props.data;

            switch (this.props.visualization) {
                case _shared.BMDVIZ_ACTIVITY:
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'table',
                            { id: 'IA_table01', ref: 'table', className: ' table-condensed table-hover' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Test substance'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'CASRN'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Use category'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Non-Mortality median BMC',
                                        _react2.default.createElement('br', null),
                                        '(Min \u2013 Max)'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Mortality median BMC',
                                        _react2.default.createElement('br', null),
                                        '(Min \u2013 Max)'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Number of concentration response curves evaluated'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                { className: 'centered-table-body' },
                                medData.map(this.renderRow)
                            )
                        )
                    );

                case _shared.BMDVIZ_SELECTIVITY:
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'table',
                            { id: 'IA_table01', ref: 'table', className: 'table-condensed table-hover' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Test substance'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'CASRN'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Use category'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Laboratory specific term'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Ontology term'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Ontology ID'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Number of concentration response curves evaluated'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Non-Mortality summarized BMC'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Mortality BMC',
                                        _react2.default.createElement('br', null),
                                        '(Min \u2013 Max)'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { style: this.tableStyle() },
                                        'Specificity'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                { className: 'centered-table-body' },
                                medData.map(this.renderRow)
                            )
                        )
                    );

                default:
                    return null;
            }
        }
    }]);

    return BmdTable;
}(_react2.default.Component);

BmdTable.propTypes = {
    data: _propTypes2.default.array.isRequired,
    visualization: _propTypes2.default.number.isRequired
};

exports.default = BmdTable;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FiveOhEight = function (_React$Component) {
    _inherits(FiveOhEight, _React$Component);

    function FiveOhEight() {
        _classCallCheck(this, FiveOhEight);

        return _possibleConstructorReturn(this, (FiveOhEight.__proto__ || Object.getPrototypeOf(FiveOhEight)).apply(this, arguments));
    }

    _createClass(FiveOhEight, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'p',
                { className: 'form-text' },
                _react2.default.createElement(
                    'b',
                    null,
                    'Note on Accessibility:'
                ),
                ' Persons with disabilities or using assistive\xA0 technology may find parts of this page are not fully accessible. The datasets that\xA0 underlie these graphics are available on the',
                ' ',
                _react2.default.createElement(
                    'a',
                    { href: '/seazit/resources/' },
                    'Resources'
                ),
                '\xA0 tab. For assistance, email us (ntpwebrequest@niehs.nih.gov) or use our',
                ' ',
                _react2.default.createElement(
                    'a',
                    { href: 'https://tools.niehs.nih.gov/webforms/index.cfm/main/formViewer/form_id/521/to/cdm' },
                    'contact form'
                ),
                '\xA0 and identify the content for which access is required. NIEHS has',
                ' ',
                _react2.default.createElement(
                    'a',
                    { href: 'https://www.niehs.nih.gov/about/od/ocpl/policies/#a6581' },
                    'helpful information'
                ),
                '\xA0 on accessibility.'
            );
        }
    }]);

    return FiveOhEight;
}(_react2.default.Component);

exports.default = FiveOhEight;

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _shared = __webpack_require__(11);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlotCollapseWidget = function (_BaseWidget) {
    _inherits(PlotCollapseWidget, _BaseWidget);

    function PlotCollapseWidget(props) {
        _classCallCheck(this, PlotCollapseWidget);

        var _this = _possibleConstructorReturn(this, (PlotCollapseWidget.__proto__ || Object.getPrototypeOf(PlotCollapseWidget)).call(this, props));

        _this.state = {
            showHelpText: false
        };
        _this.handleCollapseChange = _this.handleCollapseChange.bind(_this);
        return _this;
    }

    _createClass(PlotCollapseWidget, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _$2.default)(this.refs.buttons).find('[data-toggle="tooltip"]').tooltip();
        }
    }, {
        key: 'handleCollapseChange',
        value: function handleCollapseChange(e) {
            var d = {};
            if (e.target.value !== _shared.NO_COLLAPSE && this.props.stateHolder.state.vizColumns > 2) {
                d.vizColumns = 2;
            }
            d[e.target.name] = e.target.value;
            this.props.stateHolder.setState(d);
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'Chart by Test substance + Endpoint visualizes the response for each dataset, test substance, and endpoint selected. Chart by Test substance combines all datasets and endpoints selected. Chart by Endpoint combines all test substances selected per endpoint and dataset.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'Hover over each chart line for additional information.'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var state = this.props.stateHolder.state;

            return _react2.default.createElement(
                'div',
                { ref: 'buttons' },
                _react2.default.createElement(
                    'label',
                    { className: 'label-horizontal' },
                    'Select chart display:',
                    _react2.default.createElement(_HelpButtonWidget2.default, {
                        stateHolder: this,
                        headLevel: 'label',
                        title: 'More information on chart displays'
                    })
                ),
                this._renderHelpText(),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        {
                            'data-toggle': 'tooltip',
                            'data-title': 'One chart for each chemical + endpoint combination'
                        },
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'plotCollapse',
                            id: _shared.NO_COLLAPSE,
                            onChange: this.handleCollapseChange,
                            value: _shared.NO_COLLAPSE,
                            checked: state.plotCollapse === _shared.NO_COLLAPSE
                        }),
                        'Test substance + Endpoint'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        {
                            htmlFor: _shared.COLLAPSE_BY_CHEMICAL,
                            'data-toggle': 'tooltip',
                            'data-title': 'One chart for each chemical (multiple endpoints on chart)'
                        },
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'plotCollapse',
                            id: _shared.COLLAPSE_BY_CHEMICAL,
                            onChange: this.handleCollapseChange,
                            value: _shared.COLLAPSE_BY_CHEMICAL,
                            checked: state.plotCollapse === _shared.COLLAPSE_BY_CHEMICAL
                        }),
                        'Test substance'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        {
                            htmlFor: _shared.COLLAPSE_BY_READOUT,
                            'data-toggle': 'tooltip',
                            'data-title': 'One chart for each endpoint (multiple chemicals on chart)'
                        },
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'plotCollapse',
                            id: _shared.COLLAPSE_BY_READOUT,
                            onChange: this.handleCollapseChange,
                            value: _shared.COLLAPSE_BY_READOUT,
                            checked: state.plotCollapse === _shared.COLLAPSE_BY_READOUT
                        }),
                        'Endpoint'
                    )
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'form-text' },
                    'Hover for more details on each option.'
                )
            );
        }
    }]);

    return PlotCollapseWidget;
}(_BaseWidget3.default);

PlotCollapseWidget.propTypes = {
    stateHolder: _propTypes2.default.shape({
        state: _propTypes2.default.shape({
            plotCollapse: _propTypes2.default.string.isRequired
        }).isRequired
    }).isRequired
};

exports.default = PlotCollapseWidget;

/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Loading = __webpack_require__(86);

var _Loading2 = _interopRequireDefault(_Loading);

var _FiveOhEight = __webpack_require__(126);

var _FiveOhEight2 = _interopRequireDefault(_FiveOhEight);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

var _BmdByLabPlotWidget = __webpack_require__(1263);

var _BmdByLabPlotWidget2 = _interopRequireDefault(_BmdByLabPlotWidget);

var _ReadoutWidget = __webpack_require__(295);

var _ReadoutWidget2 = _interopRequireDefault(_ReadoutWidget);

var _SelectorSliderWidget = __webpack_require__(1264);

var _SelectorSliderWidget2 = _interopRequireDefault(_SelectorSliderWidget);

var _BmdCheckBoxWidget = __webpack_require__(273);

var _BmdCheckBoxWidget2 = _interopRequireDefault(_BmdCheckBoxWidget);

var _OntologyTypeWidget = __webpack_require__(296);

var _OntologyTypeWidget2 = _interopRequireDefault(_OntologyTypeWidget);

var _RankedBarchartHandler = __webpack_require__(274);

var _RankedBarchartHandler2 = _interopRequireDefault(_RankedBarchartHandler);

var _shared = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BmdByLabMain = function (_React$Component) {
    _inherits(BmdByLabMain, _React$Component);

    function BmdByLabMain(props) {
        _classCallCheck(this, BmdByLabMain);

        var _this = _possibleConstructorReturn(this, (BmdByLabMain.__proto__ || Object.getPrototypeOf(BmdByLabMain)).call(this, props));

        _this.state = {
            metadataLoaded: false,
            metadata: null,
            showHelpText: false,

            chemList: _shared.CHEMLIST_80,
            chemicalFilterBy: _shared.CHEMFILTER_CATEGORY,
            chemicals: [],
            categories: [],
            ontologyType: _shared.integrative_General,
            ontologyGroup: [],

            selectivityCutoff: 0.5,
            selectivityList: [{ id: 1, name: 'dev tox', isChecked: true, label: 'specific' }, { id: 2, name: 'general tox', isChecked: false, label: 'non-specific' }, {
                id: 3,
                name: 'inconclusive',
                isChecked: false,
                label: 'inconclusive, more tests are needed'
            }, { id: 4, name: 'inactive', isChecked: false, label: 'non-toxic' }],

            selectedAxis: _shared.AXIS_LOG10,

            assays: [],
            readouts: [],

            visualization: _shared.BMDVIZ_ACTIVITY,
            tabFlag: _shared.BMCTab
        };
        return _this;
    }

    _createClass(BmdByLabMain, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            (0, _shared.loadMetadata)(this);
        }
    }, {
        key: 'renderNoSelection',
        value: function renderNoSelection() {
            return (0, _shared.renderNoSelected)({
                hasAssay: this.state.assays.length > 0,
                hasReadouts: this.state.readouts.length > 0
            });
        }
    }, {
        key: 'renderSelection',
        value: function renderSelection(url) {
            return _react2.default.createElement(_RankedBarchartHandler2.default, {
                visualization: this.state.visualization,
                selectivityCutoff: this.state.selectivityCutoff,
                selectivityList: this.state.selectivityList,
                selectedAxis: this.state.selectedAxis,
                url: url
            });
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'The page allows for the visualization of test substance ranking based on either the Activity or Specificity of selected altered laboratory defined phenotype(s) within a single dataset.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'The Use Categories of test substances are color coded next to substance name. More information on Use Category can be viewed on the',
                    ' ',
                    _react2.default.createElement(
                        'a',
                        { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                        'Datasets tool page'
                    ),
                    '.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'A table will appear underneath each visual with additional information.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'Options for editing or saving images are provided by toggling over the upper right side of each image. If the edit/save toolbar is not available, it was a custom visualization created specifically for this application. Please take a screenshot to save, or if you need a higher resolution image, please contact us.'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.metadataLoaded) {
                return _react2.default.createElement(_Loading2.default, null);
            }

            var url = (0, _shared.getBmdsUrl)(this.state.assays, this.state.readouts);

            return _react2.default.createElement(
                'div',
                { className: 'd-flex flex-wrap mx-5 my-3' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                        'h1',
                        { className: 'label-horizontal' },
                        _react2.default.createElement('img', {
                            src: '/static_seazit/img/seazit/logo-5.png',
                            alt: 'Logo',
                            className: 'img-fluid',
                            style: { marginRight: '10px', height: '50px' }
                        }),
                        'Benchmark concentration (BMC) summary by dataset',
                        _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: this,
                            headLevel: 'h1',
                            title: 'Click to toggle help-text'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(_FiveOhEight2.default, null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-3 pe-3' },
                    _react2.default.createElement(_ReadoutWidget2.default, {
                        stateHolder: this,
                        hideViability: true,
                        hideNonViability: false,
                        multiAssaySelector: false,
                        multiReadoutSelector: false
                    }),
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(_BmdByLabPlotWidget2.default, { stateHolder: this }),
                    this.state.visualization === _shared.BMDVIZ_SELECTIVITY ? _react2.default.createElement(_BmdCheckBoxWidget2.default, { stateHolder: this }) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-9' },
                    this._renderHelpText(),
                    url ? this.renderSelection(url) : this.renderNoSelection()
                )
            );
        }
    }]);

    return BmdByLabMain;
}(_react2.default.Component);

exports.default = BmdByLabMain;

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _shared = __webpack_require__(11);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BmdByLabPlotWidget = function (_BaseWidget) {
    _inherits(BmdByLabPlotWidget, _BaseWidget);

    /*
    BmdByLabPlotWidget requires the following state properties:
        - stateHolder.state.visualization is one of the enumerations above
    */
    function BmdByLabPlotWidget(props) {
        _classCallCheck(this, BmdByLabPlotWidget);

        var _this = _possibleConstructorReturn(this, (BmdByLabPlotWidget.__proto__ || Object.getPrototypeOf(BmdByLabPlotWidget)).call(this, props));

        _this.state = {
            showHelpText: false
        };
        // console.log(this.props);
        // console.log(this.props.stateHolder.state);
        return _this;
    }

    _createClass(BmdByLabPlotWidget, [{
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'Activity: the potency value of the benchmark concentration (BMC) of a selected endpoint; lower BMC value represents a more potent effect.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'Specificity: the fold change of the BMC values between the mortality endpoint and the selected endpoint. The fold change value is log10-transformed; higher specificity represents a more specific effect of the selected endpoint compared to the mortality effect'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'label-horizontal' },
                    'Select visual:',
                    _react2.default.createElement(_HelpButtonWidget2.default, {
                        stateHolder: this,
                        headLevel: 'label',
                        title: 'More information on developmental toxicity classifications'
                    })
                ),
                this._renderHelpText(),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'visualization',
                            onChange: this.handleRadioChange,
                            value: _shared.BMDVIZ_ACTIVITY,
                            checked: state.visualization === _shared.BMDVIZ_ACTIVITY
                        }),
                        'Activity'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'visualization',
                            onChange: this.handleRadioChange,
                            value: _shared.BMDVIZ_SELECTIVITY,
                            checked: state.visualization === _shared.BMDVIZ_SELECTIVITY
                        }),
                        'Specificity'
                    )
                )
            );
        }
    }]);

    return BmdByLabPlotWidget;
}(_BaseWidget3.default);

exports.default = BmdByLabPlotWidget;

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectivitySliderWidget = function (_BaseWidget) {
    _inherits(SelectivitySliderWidget, _BaseWidget);

    function SelectivitySliderWidget() {
        _classCallCheck(this, SelectivitySliderWidget);

        return _possibleConstructorReturn(this, (SelectivitySliderWidget.__proto__ || Object.getPrototypeOf(SelectivitySliderWidget)).apply(this, arguments));
    }

    _createClass(SelectivitySliderWidget, [{
        key: 'render',

        /*
        SelectivitySliderWidget requires the following state properties:
            - stateHolder.state.selectivityCutoff
        */

        value: function render() {
            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    'Selectivity cutoff:'
                ),
                _react2.default.createElement('input', {
                    className: 'form-control',
                    type: 'range',
                    name: 'selectivityCutoff',
                    min: '0',
                    max: '2',
                    step: '0.1',
                    onChange: this.handleFloatInputChange,
                    value: state.selectivityCutoff
                }),
                _react2.default.createElement(
                    'span',
                    null,
                    '>',
                    state.selectivityCutoff,
                    ' is selective'
                )
            );
        }
    }]);

    return SelectivitySliderWidget;
}(_BaseWidget3.default);

exports.default = SelectivitySliderWidget;

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(503);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _BmdBoxplot = __webpack_require__(1266);

var _BmdBoxplot2 = _interopRequireDefault(_BmdBoxplot);

var _BmdAssayPca = __webpack_require__(1267);

var _BmdAssayPca2 = _interopRequireDefault(_BmdAssayPca);

var _BmdChemicalPca = __webpack_require__(511);

var _BmdChemicalPca2 = _interopRequireDefault(_BmdChemicalPca);

var _FiveOhEight = __webpack_require__(126);

var _FiveOhEight2 = _interopRequireDefault(_FiveOhEight);

var _RankedBarchart = __webpack_require__(452);

var _RankedBarchart2 = _interopRequireDefault(_RankedBarchart);

var _HeatmapHandler = __webpack_require__(502);

var _HeatmapHandler2 = _interopRequireDefault(_HeatmapHandler);

var _Loading = __webpack_require__(86);

var _Loading2 = _interopRequireDefault(_Loading);

var _HeatmapDisplaySelector = __webpack_require__(1268);

var _HeatmapDisplaySelector2 = _interopRequireDefault(_HeatmapDisplaySelector);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

var _IntegrativePlotWidget = __webpack_require__(1269);

var _IntegrativePlotWidget2 = _interopRequireDefault(_IntegrativePlotWidget);

var _BmdWidget = __webpack_require__(1270);

var _BmdWidget2 = _interopRequireDefault(_BmdWidget);

var _ChemicalWidget = __webpack_require__(509);

var _ChemicalWidget2 = _interopRequireDefault(_ChemicalWidget);

var _OntologyWidget = __webpack_require__(1271);

var _OntologyWidget2 = _interopRequireDefault(_OntologyWidget);

var _OntologyTypeWidget = __webpack_require__(296);

var _OntologyTypeWidget2 = _interopRequireDefault(_OntologyTypeWidget);

var _ReadoutWidget = __webpack_require__(295);

var _ReadoutWidget2 = _interopRequireDefault(_ReadoutWidget);

var _shared = __webpack_require__(11);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BmdCheckBoxWidget = __webpack_require__(273);

var _BmdCheckBoxWidget2 = _interopRequireDefault(_BmdCheckBoxWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntegrativeAnalysesMain = function (_React$Component) {
    _inherits(IntegrativeAnalysesMain, _React$Component);

    function IntegrativeAnalysesMain(props) {
        _classCallCheck(this, IntegrativeAnalysesMain);

        var _this = _possibleConstructorReturn(this, (IntegrativeAnalysesMain.__proto__ || Object.getPrototypeOf(IntegrativeAnalysesMain)).call(this, props));

        _this.state = {
            // loadMetadata

            metadataLoaded: false,
            metadata: null,

            // HelpButtonWidget
            showHelpText: false,
            assays: [],
            // assays:['1', '2'],

            labDataset: [],
            url: null,
            // ontologyWidget
            ontologyType: _shared.integrative_General,
            // ontologyType: integrative_Granular,

            ontologyGroup: [],

            // ChemicalSelectorWidget
            chemicalFilterBy: _shared.CHEMFILTER_CATEGORY,
            // chemicalFilterBy: CHEMFILTER_CHEMICIAL,

            chemicals: [],
            // chemicals: ['115-86-6', '13674-87-8', '79-94-7'],

            // ReadoutSelectorWidget
            readoutType: _shared.READOUT_TYPE_CATEGORY,

            readouts: [],

            // mortalityCheck: false,

            // IntegrativePlotWidget
            visualization: _shared.INTVIZ_HEATMAP,
            // visualization: INTVIZ_DevtoxHEATMAP,

            // HeatmapDisplaySelector
            heatmapDisplay: _shared.HEATMAP_ACTIVITY,
            tabFlag: _shared.IntegrativeAnalysesTab
        };
        return _this;
    }

    _createClass(IntegrativeAnalysesMain, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            (0, _shared.loadMetadata)(this);
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'This page allows for the cross-dataset comparison of developmental toxicity results determined by alteration of zebrafish larva phenotypes after test substance exposure.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'The developmental toxicity results include three main elements: test substance classification, activity, and specificity related to the associated developmental phenotype group.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'Multiple features can be selected at once. Once the user has selected at least one item within each feature, interactive heatmaps will appear if data are available. More information on each dataset can be viewed on the',
                    ' ',
                    _react2.default.createElement(
                        'a',
                        { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                        'Datasets tool page'
                    ),
                    '.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    'Options for editing or saving images are provided by toggling over the upper right side of each image. If the edit/save toolbar is not available, it was a custom visualization created specifically for this application. Please take a screenshot to save, or if you need a higher resolution image, please contact us.'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'i',
                        null,
                        'Disclaimer: The use of two different methods of analysis will be reflected as different benchmark concentrations.\u201D'
                    )
                )
            );
        }
    }, {
        key: '_renderMainBody',
        value: function _renderMainBody() {
            // console.log(this.state.ontologyType);
            // console.log(this.state.ontologyGroup);

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_HeatmapHandler2.default, {
                    assays: this.state.assays,
                    casrns: this.state.chemicals,
                    visualization: this.state.visualization,
                    ontologyType: this.state.ontologyType,
                    ontologyGroup: this.state.ontologyGroup,
                    url: this.state.url,
                    labDataset: this.state.labDataset
                }),
                _react2.default.createElement(
                    'p',
                    { className: ' form-text' },
                    _react2.default.createElement(
                        'b',
                        null,
                        'Interactivity note:'
                    ),
                    ' This heatmap is interactive. Click a cell to view individual concentration response curves associated with it. Select x-axis label to learn more about selected phenotype.'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.state.metadataLoaded) {
                return _react2.default.createElement(_Loading2.default, null);
            }
            this.state.labDataset = _lodash2.default.chain(this.state.protocol_data).filter(function (i) {
                return _this2.state.assays.includes(i.seazit_protocol_id.toString());
            })
            // .map('protocol_name_plot')
            .value();
            this.state.url = (0, _shared.getIntegrativeUrl)(this.state.assays, this.state.chemicals);
            //heatmap test
            return _react2.default.createElement(
                'div',
                { className: 'd-flex flex-wrap mx-5 my-3' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'd-flex align-items-center' },
                        _react2.default.createElement(
                            'h1',
                            { className: 'label-horizontal' },
                            _react2.default.createElement('img', {
                                src: '/static_seazit/img/seazit/logo-5.png',
                                alt: 'Logo',
                                className: 'img-fluid',
                                style: { marginRight: '10px', height: '50px' }
                            }),
                            'Integrative Analyses',
                            _react2.default.createElement(_HelpButtonWidget2.default, {
                                stateHolder: this,
                                headLevel: 'h1',
                                title: 'Click to toggle help-text'
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-12' },
                    _react2.default.createElement(_FiveOhEight2.default, null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-3 pe-3' },
                    _react2.default.createElement(_IntegrativePlotWidget2.default, { stateHolder: this }),
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(_ReadoutWidget2.default, {
                        stateHolder: this,
                        hideViability: false,
                        hideNonViability: false,
                        multiAssaySelector: true,
                        multiReadoutSelector: true
                    }),
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_OntologyWidget2.default, { stateHolder: this }),
                        _react2.default.createElement('hr', null)
                    ),
                    _react2.default.createElement(_ChemicalWidget2.default, { stateHolder: this })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-9' },
                    this._renderHelpText(),
                    this._renderMainBody()
                )
            );
        }
    }]);

    return IntegrativeAnalysesMain;
}(_react2.default.Component);

exports.default = IntegrativeAnalysesMain;

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Plotly = __webpack_require__(128);

var _Plotly2 = _interopRequireDefault(_Plotly);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _PlotlyWrapper2 = __webpack_require__(510);

var _PlotlyWrapper3 = _interopRequireDefault(_PlotlyWrapper2);

var _shared = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getBoxplotData = function getBoxplotData(data, props) {
    var casrns = props.casrns,
        readouts = props.readouts,
        readoutCategories = props.readoutCategories,
        readoutType = props.readoutType,
        readout_ids = readouts.map(function (d) {
        return parseInt(d);
    }),
        boxes = void 0,
        layout = void 0,
        title = void 0;


    switch (readoutType) {
        case _shared.READOUT_TYPE_READOUT:
            {
                title = 'BMC distribution by readout';
                boxes = _lodash2.default.chain(data).filter(function (d) {
                    return d.bmd > 0;
                }).filter(function (d) {
                    return _lodash2.default.includes(casrns, d.chemical_casrn);
                }).filter(function (d) {
                    return _lodash2.default.includes(readout_ids, d.readout_id);
                }).groupBy('readout_id').values().map(function (d) {
                    return {
                        boxmean: true,
                        boxpoints: 'all',
                        jitter: 0.35,
                        name: d[0].readout_endpoint,
                        pointpos: 0,
                        type: 'box',
                        y: _lodash2.default.map(d, 'bmd')
                    };
                }).value();
                break;
            }
        case _shared.READOUT_TYPE_CATEGORY:
            {
                title = 'BMC distribution by endpoint category';
                boxes = _lodash2.default.chain(data).filter(function (d) {
                    return d.bmd > 0;
                }).filter(function (d) {
                    return _lodash2.default.includes(casrns, d.chemical_casrn);
                }).filter(function (d) {
                    return _lodash2.default.includes(readoutCategories, d.provider_category);
                }).groupBy('provider_category').values().map(function (d) {
                    return {
                        boxmean: true,
                        boxpoints: 'all',
                        jitter: 0.35,
                        name: d[0].provider_category,
                        pointpos: 0,
                        type: 'box',
                        y: _lodash2.default.map(d, 'bmd')
                    };
                }).value();
                break;
            }
        default:
            {
                throw 'Unknown readoutType';
            }
    }

    layout = {
        title: title,
        yaxis: {
            title: 'BMC (µM)',
            autorange: true,
            showgrid: true,
            type: 'log',
            nticks: 100
        },
        margin: {
            l: 50,
            r: 100,
            b: 150,
            t: 30
        },
        showlegend: false,
        height: 800
    };

    return {
        data: boxes,
        layout: layout
    };
};

var BmdBoxplot = function (_PlotlyWrapper) {
    _inherits(BmdBoxplot, _PlotlyWrapper);

    function BmdBoxplot(props) {
        _classCallCheck(this, BmdBoxplot);

        var _this = _possibleConstructorReturn(this, (BmdBoxplot.__proto__ || Object.getPrototypeOf(BmdBoxplot)).call(this, props));

        _this.state = {
            data: null,
            noDataSelected: true
        };
        return _this;
    }

    _createClass(BmdBoxplot, [{
        key: '_updateData',
        value: function _updateData(bmdType) {
            var _this2 = this;

            var url = '/neurotox/api/' + bmdType + '/bmcByLabResult/?format=tsv',
                cleanRow = function cleanRow(row) {
                return {
                    id: +row.id,
                    bmd: +row.bmd,
                    substance_id: +row.substance_id,
                    chemical_casrn: row.chemical_casrn,
                    chemical_name: row.chemical_name,
                    provider_category: row.protocol_provider + ': ' + row.readout_category,
                    readout_endpoint: row.readout_endpoint,
                    readout_id: +row.readout_id
                };
            },
                formatData = function formatData(error, data) {
                _this2.setState({
                    data: data
                });
            };

            d3.tsv(url, cleanRow, formatData);
        }
    }, {
        key: 'renderPlot',
        value: function renderPlot() {
            var d = getBoxplotData(this.state.data, this.props);

            if (this.refs.plot) {
                _Plotly2.default.purge(this.refs.plot);
            }

            if (d.data.length > 0 && this.state.noDataSelected === true || d.data.length === 0 && this.state.noDataSelected === false) {
                this.setState({ noDataSelected: !this.state.noDataSelected });
                return;
            } else if (d.data.length > 0) {
                this.renderPlotly(d.data, d.layout);
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._updateData(this.props.bmdType);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.renderPlot();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (nextProps.bmdType !== this.props.bmdType) {
                this._updateData(nextProps.bmdType);
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.noDataSelected) {
                return (0, _shared.renderNoDataAlert)();
            }
            return _react2.default.createElement('div', { id: 'IA_Boxplot01', ref: 'plot' });
        }
    }]);

    return BmdBoxplot;
}(_PlotlyWrapper3.default);

BmdBoxplot.propTypes = {
    casrns: _propTypes2.default.array.isRequired,
    readouts: _propTypes2.default.array.isRequired,
    readoutType: _propTypes2.default.number.isRequired,
    bmdType: _propTypes2.default.string.isRequired,
    readoutCategories: _propTypes2.default.array.isRequired
};

exports.default = BmdBoxplot;

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BmdChemicalPca2 = __webpack_require__(511);

var _BmdChemicalPca3 = _interopRequireDefault(_BmdChemicalPca2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BmdAssayPca = function (_BmdChemicalPca) {
    _inherits(BmdAssayPca, _BmdChemicalPca);

    function BmdAssayPca() {
        _classCallCheck(this, BmdAssayPca);

        return _possibleConstructorReturn(this, (BmdAssayPca.__proto__ || Object.getPrototypeOf(BmdAssayPca)).apply(this, arguments));
    }

    _createClass(BmdAssayPca, [{
        key: '_getUrl',
        value: function _getUrl(bmdType) {
            return '/neurotox/api/' + bmdType + '/pca_assay/?format=json';
        }
    }]);

    return BmdAssayPca;
}(_BmdChemicalPca3.default);

exports.default = BmdAssayPca;

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _shared = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeatmapDisplaySelector = function (_BaseWidget) {
    _inherits(HeatmapDisplaySelector, _BaseWidget);

    function HeatmapDisplaySelector() {
        _classCallCheck(this, HeatmapDisplaySelector);

        return _possibleConstructorReturn(this, (HeatmapDisplaySelector.__proto__ || Object.getPrototypeOf(HeatmapDisplaySelector)).apply(this, arguments));
    }

    _createClass(HeatmapDisplaySelector, [{
        key: 'render',

        /*
        HeatmapDisplaySelector requires the following state properties:
            - stateHolder.state.heatmapDisplay is one of the enumerations above
        */

        value: function render() {
            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    'Select heatmap display type: '
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'heatmapDisplay',
                            onChange: this.handleRadioChange,
                            value: _shared.HEATMAP_ACTIVITY,
                            checked: state.heatmapDisplay === _shared.HEATMAP_ACTIVITY
                        }),
                        'Activity'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'heatmapDisplay',
                            onChange: this.handleRadioChange,
                            value: _shared.HEATMAP_BMC,
                            checked: state.heatmapDisplay === _shared.HEATMAP_BMC
                        }),
                        'BMC'
                    )
                )
            );
        }
    }]);

    return HeatmapDisplaySelector;
}(_BaseWidget3.default);

exports.default = HeatmapDisplaySelector;

/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _shared = __webpack_require__(11);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntegrativePlotWidget = function (_BaseWidget) {
    _inherits(IntegrativePlotWidget, _BaseWidget);

    /*
    IntegrativePlotWidget requires the following state properties:
        - stateHolder.state.visualization is one of the enumerations above
    */
    function IntegrativePlotWidget(props) {
        _classCallCheck(this, IntegrativePlotWidget);

        var _this = _possibleConstructorReturn(this, (IntegrativePlotWidget.__proto__ || Object.getPrototypeOf(IntegrativePlotWidget)).call(this, props));

        _this.state = {
            // HelpButtonWidget
            showHelpText: false,
            helpButtonContentId: null
        };
        return _this;
    }

    _createClass(IntegrativePlotWidget, [{
        key: '_renderHelpText',
        value: function _renderHelpText() {
            // console.log(this.props.stateHolder.state)
            // console.log(this.state)
            var state = this.props.stateHolder.state;
            var contentId = this.state.helpButtonContentId;
            if (!this.state.showHelpText) {
                return null;
            }
            if (contentId === 'A') {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert alert-info' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'Activity calls are the potency value of the benchmark concentration (BMC) of a certain altered phenotype; lower BMC value represents a more potent effect.'
                    )
                );
            } else if (contentId === 'B') {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert alert-info' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'Potency values are determined by the benchmark concentration (BMC). Specificity is the fold change of the BMC values between the mortality and a certain altered phenotype. The fold change value is log10-transformed; higher specificity represents a more specific phenotypic effect compared to mortality.'
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    'Select visual:'
                ),
                [{
                    value: _shared.INTVIZ_HEATMAP,
                    label: 'Developmental toxicity classification',
                    title: 'Heatmap with activity calls',
                    contentId: 'A'
                }, {
                    value: _shared.INTVIZ_DevtoxHEATMAP,
                    label: 'Potency and specificity for developmental toxicity',
                    title: 'Heatmap with BMC and specificity',
                    contentId: 'B'
                }].map(function (option) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'radio label-horizontal', key: option.value },
                        _react2.default.createElement(
                            'label',
                            { className: 'label-horizontal' },
                            _react2.default.createElement('input', {
                                type: 'radio',
                                name: 'visualization',
                                onChange: _this2.handleRadioChange,
                                value: option.value,
                                checked: state.visualization === option.value
                            }),
                            option.label,
                            _react2.default.createElement(_HelpButtonWidget2.default, {
                                stateHolder: _this2,
                                headLevel: 'label',
                                title: option.title,
                                contentId: option.contentId
                            })
                        )
                    );
                }),
                this._renderHelpText()
            );
        }
    }]);

    return IntegrativePlotWidget;
}(_BaseWidget3.default);

exports.default = IntegrativePlotWidget;

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _shared = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BmdWidget = function (_BaseWidget) {
    _inherits(BmdWidget, _BaseWidget);

    function BmdWidget() {
        _classCallCheck(this, BmdWidget);

        return _possibleConstructorReturn(this, (BmdWidget.__proto__ || Object.getPrototypeOf(BmdWidget)).apply(this, arguments));
    }

    _createClass(BmdWidget, [{
        key: 'render',

        /*
        BmdWidget requires the following state properties:
            - stateHolder.state.bmdType is one of the enumerations above
        */

        value: function render() {
            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    'Select BMC model:'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'bmdType',
                            onChange: this.handleRadioChange,
                            value: _shared.BMD_HILL,
                            checked: state.bmdType === _shared.BMD_HILL
                        }),
                        'Hill'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'bmdType',
                            onChange: this.handleRadioChange,
                            value: _shared.BMD_CURVEP,
                            checked: state.bmdType === _shared.BMD_CURVEP
                        }),
                        'CurveP'
                    )
                )
            );
        }
    }]);

    return BmdWidget;
}(_BaseWidget3.default);

exports.default = BmdWidget;

/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _shared = __webpack_require__(11);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OntologyWidget = function (_BaseWidget) {
    _inherits(OntologyWidget, _BaseWidget);

    function OntologyWidget(props) {
        _classCallCheck(this, OntologyWidget);

        var _this = _possibleConstructorReturn(this, (OntologyWidget.__proto__ || Object.getPrototypeOf(OntologyWidget)).call(this, props));

        _this.state = {
            showHelpText: false
        };
        return _this;
    }

    _createClass(OntologyWidget, [{
        key: '_renderFilterBy',
        value: function _renderFilterBy(state) {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'label-horizontal' },
                    'Select developmental phenotype group:',
                    _react2.default.createElement(_HelpButtonWidget2.default, {
                        stateHolder: this,
                        headLevel: 'label',
                        title: 'More information on developmental phenotype groups'
                    })
                ),
                this._renderHelpText(),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'ontologyType',
                            onChange: this.handleRadioChange,
                            value: _shared.integrative_General,
                            checked: state.ontologyType === _shared.integrative_General
                        }),
                        'General'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'ontologyType',
                            onChange: this.handleRadioChange,
                            value: _shared.integrative_Granular,
                            checked: state.ontologyType === _shared.integrative_Granular
                        }),
                        'Granular'
                    )
                )
            );
        }
    }, {
        key: '_renderSelector',
        value: function _renderSelector(state) {
            var customGroupOrder = ['General', 'Head', 'Appendage', 'Torso'];
            var groupingKey = state.ontologyType === _shared.integrative_Granular ? 'developmental_defect_grouping_granular' : 'developmental_defect_grouping_general';
            // console.log(state.Seazit_ontology)
            var opts = _lodash2.default.chain(state.Seazit_ontology).filter(function (r) {
                return r[groupingKey] !== 'dead';
            }) // Filter out items where groupingKey is 'dead'

            .map(function (r) {
                return _extends({ key: r[groupingKey], label: r[groupingKey] }, r);
            }).reject(function (r) {
                return r.key === null;
            }).uniqBy(groupingKey).groupBy('developmental_defect_catergories').thru(function (groupedData) {
                return _lodash2.default.fromPairs(_lodash2.default.sortBy(Object.entries(groupedData), function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 1),
                        group = _ref2[0];

                    return customGroupOrder.indexOf(group);
                }));
            }).value();

            if (_lodash2.default.isEmpty(opts)) {
                return null;
            }
            // console.log(opts)

            return (0, _shared.renderSelectMultiOptgroupWidget)('ontologyGroup', state.ontologyType === _shared.integrative_Granular ? 'Granular phenotype term' : 'General phenotype term', opts, state.ontologyGroup, this.handleSelectMultiChange);
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'Detailed recordings of each laboratory are grouped into corresponding higher level developmental defect phenotype groups. We created two types of developmental defect phenotypes, the general grouping (n = 10) and the granular grouping (n = 18). See',
                    ' ',
                    _react2.default.createElement(
                        'a',
                        { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                        'Datasets page'
                    ),
                    ' for more information.'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            // loadBaseUrl(this);

            var state = this.props.stateHolder.state;
            // console.log(state)
            return _react2.default.createElement(
                'div',
                { className: 'clearfix' },
                this._renderFilterBy(state),
                this._renderSelector(state)
            );
        }
    }]);

    return OntologyWidget;
}(_BaseWidget3.default);

OntologyWidget.propTypes = {
    stateHolder: _propTypes2.default.instanceOf(_react2.default.Component).isRequired
};

exports.default = OntologyWidget;

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

module.exports = Plotly;

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sankeyPlotGraphBody = exports.molecularGraphBody = exports.MultipleCurveBody = exports.SingleCurveBody = exports.Header = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DoseResponse = __webpack_require__(176);

var _DoseResponse2 = _interopRequireDefault(_DoseResponse);

var _SankeyPlot = __webpack_require__(451);

var _SankeyPlot2 = _interopRequireDefault(_SankeyPlot);

var _DoseResponseGridWidget = __webpack_require__(272);

var _DoseResponseGridWidget2 = _interopRequireDefault(_DoseResponseGridWidget);

var _Plotly = __webpack_require__(128);

var _Plotly2 = _interopRequireDefault(_Plotly);

var _shared = __webpack_require__(11);

var _IntegrativeCheckBoxWidget = __webpack_require__(1117);

var _IntegrativeCheckBoxWidget2 = _interopRequireDefault(_IntegrativeCheckBoxWidget);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _BmdCheckBoxWidget = __webpack_require__(273);

var _BmdCheckBoxWidget2 = _interopRequireDefault(_BmdCheckBoxWidget);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _renderHelpText(state) {
    if (!state.showHelpText) {
        return null;
    }
    return _react2.default.createElement(
        'div',
        { className: 'alert alert-info' },
        _react2.default.createElement(
            'p',
            null,
            'Detailed view of each developmental phenotype incorporated into the selected phenotype group. Specific phenotype terms used per laboratory are included in each figure title. Click an x-axis label of the heatmap to learn more about selected phenotype.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'p',
            null,
            'Percent mortality at 120 hours post fertilization alone can be visualized in each figure by selecting the \u201Cadd mortality@120\u201D box. Effects that were driven by altered morphological phenotypes and not mortality (i.e., specific developmental toxicity effect) have backgrounds highlighted using a magenta box. Dotted line is the benchmark response (BMR) visualized when looking at altered phenotype data.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'p',
            null,
            'Figures are interactive: the user can zoom in and out using curser and hover over each line for information per plate.'
        )
    );
}

var Header = function (_React$Component) {
    _inherits(Header, _React$Component);

    function Header() {
        _classCallCheck(this, Header);

        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
    }

    _createClass(Header, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'h4',
                { className: 'd-flex flex-wrap mx-5 my-3' },
                this.props.title
            );
        }
    }]);

    return Header;
}(_react2.default.Component);

Header.propTypes = {
    title: _propTypes2.default.string.isRequired
};

var SingleCurveBody = function (_React$Component2) {
    _inherits(SingleCurveBody, _React$Component2);

    function SingleCurveBody(props) {
        _classCallCheck(this, SingleCurveBody);

        // take 75% of the screen width since main body is col-9 size; assume
        // each plot is ~400px for a reasonable start, make sure it's at least 1
        var _this2 = _possibleConstructorReturn(this, (SingleCurveBody.__proto__ || Object.getPrototypeOf(SingleCurveBody)).call(this, props));

        _this2.state = {
            mortalityCheck: false,
            showHelpText: false,
            vizHeight: 350,
            collapse: _shared.NO_COLLAPSE // Set initial collapse state
        };
        return _this2;
    }

    _createClass(SingleCurveBody, [{
        key: '_renderDoseResponse',
        value: function _renderDoseResponse(state) {
            var commonHeader = _react2.default.createElement(
                'div',
                { className: 'col-10' },
                _react2.default.createElement(
                    'h4',
                    { className: 'label-horizontal' },
                    'Developmental Toxicity Concentration Response Figures',
                    _react2.default.createElement(_HelpButtonWidget2.default, {
                        stateHolder: this,
                        headLevel: 'h4',
                        title: 'Click to toggle help-text'
                    })
                ),
                _renderHelpText(this.state),
                this.props.heading && _react2.default.createElement(
                    'h5',
                    null,
                    this.props.heading
                )
            );

            return _react2.default.createElement(
                'div',
                { className: 'col-10' },
                commonHeader,
                _react2.default.createElement(_DoseResponse2.default, {
                    stateHolder: this,
                    url: state.url,
                    cols: 3,
                    height: state.vizHeight,
                    collapse: state.collapse,
                    devtoxEndPointList: this.props.devtoxEndPointList,
                    final_dev_call: this.props.final_dev_call
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            this.state.collapse = this.state.mortalityCheck ? _shared.COLLAPSE_WITH_Mortality120 : _shared.NO_COLLAPSE;

            var readout_ids = this.state.mortalityCheck ? [this.props.readout_id].concat(['Mortality@120' + '_' + this.props.protocol_id]) : [this.props.readout_id];
            this.state.url = (0, _shared.getDoseResponsesUrl)([this.props.protocol_id], [readout_ids], [this.props.casrn]);

            return (
                // <div className="row  ">
                _react2.default.createElement(
                    'div',
                    { className: 'd-flex flex-wrap mx-5 my-3' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-2  pe-3' },
                        this.props.CheckBoxDisable ? null : _react2.default.createElement(_IntegrativeCheckBoxWidget2.default, { stateHolder: this })
                    ),
                    this._renderDoseResponse(this.state)
                )
            );
        }
    }]);

    return SingleCurveBody;
}(_react2.default.Component);

SingleCurveBody.propTypes = {
    protocol_id: _propTypes2.default.number.isRequired,
    readout_id: _propTypes2.default.string.isRequired,
    casrn: _propTypes2.default.array.isRequired,
    devtoxEndPointList: _propTypes2.default.string,
    CheckBoxDisable: false,
    heading: _propTypes2.default.string,
    final_dev_call: _propTypes2.default.string
};

var MultipleCurveBody = function (_React$Component3) {
    _inherits(MultipleCurveBody, _React$Component3);

    function MultipleCurveBody(props) {
        _classCallCheck(this, MultipleCurveBody);

        // take 75% of the screen width since main body is col-9 size; assume
        // each plot is ~400px for a reasonable start, make sure it's at least 1
        var _this3 = _possibleConstructorReturn(this, (MultipleCurveBody.__proto__ || Object.getPrototypeOf(MultipleCurveBody)).call(this, props));

        var initialCols = Math.max(1, Math.floor(0.75 * window.innerWidth / 400));
        _this3.state = {
            vizColumns: initialCols,
            vizHeight: 350,
            mortalityCheck: false,
            showHelpText: false,
            collapse: _shared.NO_COLLAPSE // Set initial collapse state
        };
        return _this3;
    }

    _createClass(MultipleCurveBody, [{
        key: '_renderDoseResponse',
        value: function _renderDoseResponse(state) {
            // console.log(state)

            var commonHeader = _react2.default.createElement(
                'div',
                { className: 'col-10' },
                _react2.default.createElement(
                    'h4',
                    { className: 'label-horizontal' },
                    'Developmental Toxicity Concentration Response Figures',
                    _react2.default.createElement(_HelpButtonWidget2.default, {
                        stateHolder: this,
                        headLevel: 'h4',
                        title: 'Click to toggle help-text'
                    })
                ),
                this.props.heading && _react2.default.createElement(
                    'h5',
                    null,
                    this.props.heading
                ),
                _renderHelpText(this.state)
            );

            return _react2.default.createElement(
                'div',
                { className: 'col-10' },
                commonHeader,
                _react2.default.createElement(_DoseResponse2.default, {
                    stateHolder: this,
                    url: state.url,
                    cols: state.vizColumns,
                    height: state.vizHeight,
                    collapse: state.collapse,
                    devtoxEndPointList: this.props.devtoxEndPointList
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            this.state.collapse = this.state.mortalityCheck ? _shared.COLLAPSE_WITH_Mortality120 : _shared.NO_COLLAPSE;
            var readout_ids = this.state.mortalityCheck ? this.props.readout_ids.concat(['Mortality@120' + '_' + this.props.protocol_id]) : [this.props.readout_ids];
            this.state.url = (0, _shared.getDoseResponsesUrl)([this.props.protocol_id], [readout_ids], [this.props.casrns]);
            return (
                // <div className="row">
                _react2.default.createElement(
                    'div',
                    { className: 'd-flex flex-wrap mx-5 my-3' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-2  pe-3' },
                        _react2.default.createElement(_DoseResponseGridWidget2.default, { stateHolder: this }),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(_IntegrativeCheckBoxWidget2.default, { stateHolder: this })
                    ),
                    this._renderDoseResponse(this.state)
                )
            );
        }
    }]);

    return MultipleCurveBody;
}(_react2.default.Component);

MultipleCurveBody.propTypes = {
    protocol_id: _propTypes2.default.number.isRequired,
    readout_ids: _propTypes2.default.array.isRequired,
    casrns: _propTypes2.default.array.isRequired,
    devtoxEndPointList: _propTypes2.default.array.isRequired,
    heading: _propTypes2.default.string
};

var molecularGraphBody = function (_React$Component4) {
    _inherits(molecularGraphBody, _React$Component4);

    function molecularGraphBody(props) {
        _classCallCheck(this, molecularGraphBody);

        return _possibleConstructorReturn(this, (molecularGraphBody.__proto__ || Object.getPrototypeOf(molecularGraphBody)).call(this, props));
        // take 75% of the screen width since main body is col-9 size; assume
        // each plot is ~400px for a reasonable start, make sure it's at least 1
    }

    _createClass(molecularGraphBody, [{
        key: 'render',
        value: function render() {
            var srcUrl = 'https://comptox.epa.gov/dashboard-api/ccdapp1/chemical-files/image/by-dtxsid/' + this.props.dtxsid;
            return _react2.default.createElement(
                'div',
                { className: 'col-10' },
                _react2.default.createElement('iframe', { src: srcUrl, width: '400', height: '400' })
            );
        }
    }]);

    return molecularGraphBody;
}(_react2.default.Component);

molecularGraphBody.propTypes = {
    dtxsid: _propTypes2.default.string.isRequired
};

var sankeyPlotGraphBody = function (_React$Component5) {
    _inherits(sankeyPlotGraphBody, _React$Component5);

    function sankeyPlotGraphBody(props) {
        _classCallCheck(this, sankeyPlotGraphBody);

        return _possibleConstructorReturn(this, (sankeyPlotGraphBody.__proto__ || Object.getPrototypeOf(sankeyPlotGraphBody)).call(this, props));
    }

    _createClass(sankeyPlotGraphBody, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'col-10' },
                _react2.default.createElement(_SankeyPlot2.default, { cells: this.props.cells })
            );
        }
    }]);

    return sankeyPlotGraphBody;
}(_react2.default.Component);

sankeyPlotGraphBody.propTypes = {
    title: _propTypes2.default.string.isRequired,
    cells: _propTypes2.default.array.isRequired
};

exports.Header = Header;
exports.SingleCurveBody = SingleCurveBody;
exports.MultipleCurveBody = MultipleCurveBody;
exports.molecularGraphBody = molecularGraphBody;
exports.sankeyPlotGraphBody = sankeyPlotGraphBody;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(51);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BootstrapModal = function () {
    function BootstrapModal(headerComponent, bodyComponent, args) {
        _classCallCheck(this, BootstrapModal);

        this.headerComponent = headerComponent;
        this.bodyComponent = bodyComponent;
        this.args = args || {};
        this.modal = this._getModalContainer();
        this.header = this.modal.querySelector('.modal-title');
        this.body = this.modal.querySelector('.modal-body');

        // Use the global bootstrap object for Modal
        this.bootstrapModalInstance = new bootstrap.Modal(this.modal); // Bootstrap Modal instance from the global `bootstrap`
        this.render();
    }

    _createClass(BootstrapModal, [{
        key: 'render',
        value: function render() {
            var _this = this;

            // Show the modal
            // Remove existing event listener to prevent duplicates
            this.modal.removeEventListener('shown.bs.modal', this._renderContent);

            // Add the new event listener
            this._renderContent = function () {
                _reactDom2.default.render(_react2.default.createElement(_this.headerComponent, _this.args, null), _this.header);
                _reactDom2.default.render(_react2.default.createElement(_this.bodyComponent, _this.args, null), _this.body);
            };
            this.modal.addEventListener('shown.bs.modal', this._renderContent);

            // Unmount the React components when the modal is hidden
            this.modal.addEventListener('hide.bs.modal', function () {
                _reactDom2.default.unmountComponentAtNode(_this.header);
                _reactDom2.default.unmountComponentAtNode(_this.body);
            });

            // Show the modal using Bootstrap's JavaScript API
            this.bootstrapModalInstance.show();
        }
    }, {
        key: '_getModalContainer',
        value: function _getModalContainer() {
            var modalId = 'modal-' + Date.now(); // Unique ID for each modal
            var modalHTML = '\n        <div id="' + modalId + '" class="modal fade" tabindex="-1" role="dialog">\n            <div class="modal-dialog modal-dialog-centered" role="document">\n                <div class="modal-content">\n                    <div class="modal-header">\n                        <h5 class="modal-title">Modal Title</h5>\n                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>\n                    </div>\n                    <div class="modal-body">\n                    </div>\n                </div>\n            </div>\n        </div>\n    ';
            document.body.insertAdjacentHTML('beforeend', modalHTML);
            return document.getElementById(modalId);
        }
    }]);

    return BootstrapModal;
}();

exports.default = BootstrapModal;

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Loading = __webpack_require__(86);

var _Loading2 = _interopRequireDefault(_Loading);

var _Plotly = __webpack_require__(128);

var _Plotly2 = _interopRequireDefault(_Plotly);

var _shared = __webpack_require__(11);

var _HeatmapHandler = __webpack_require__(502);

var _HeatmapHandler2 = _interopRequireDefault(_HeatmapHandler);

var _Heatmap = __webpack_require__(507);

var _Heatmap2 = _interopRequireDefault(_Heatmap);

var _DevtoxHeatmap = __webpack_require__(508);

var _DevtoxHeatmap2 = _interopRequireDefault(_DevtoxHeatmap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// const NO_COLLAPSE_COLORS = {
//     responses: '#76B425',
//     bmcoutput: '#1451a5',
// };

var DoseResponse = function (_React$Component) {
    _inherits(DoseResponse, _React$Component);

    function DoseResponse(props) {
        _classCallCheck(this, DoseResponse);

        var _this = _possibleConstructorReturn(this, (DoseResponse.__proto__ || Object.getPrototypeOf(DoseResponse)).call(this, props));

        _this.colorScale = d3.scaleOrdinal(d3.schemeCategory10);
        _this.state = {
            data: null,
            scale: null,
            collapsedData: null,
            error: null,
            labelsDict: {}
        };
        return _this;
    }

    _createClass(DoseResponse, [{
        key: 'collapseData',
        value: function collapseData(data, collapse) {
            var _this2 = this;

            if (_lodash2.default.isEmpty(data)) {
                return '';
            }
            var keys = void 0,
                groupKeys = void 0,
                collapsedData = void 0,
                responses = void 0,
                yrange = void 0,
                offset = void 0;
            if (collapse == _shared.COLLAPSE_WITH_Mortality120) {
                keys = _lodash2.default.chain(data.dose_response).reject(function (r) {
                    return r.endpoint_name == 'Mortality@120';
                }).map('key').uniq().value(), groupKeys = _lodash2.default.chain(data.dose_response).map('groupKey').uniq().value(), collapsedData = _lodash2.default.chain(keys).map(function (k) {
                    return {
                        key: k,
                        groupKeys: groupKeys,
                        final_dev_call: null,
                        dose_response: _lodash2.default.filter(data.dose_response, { key: k }),
                        bmcoutput: _lodash2.default.filter(data.bmcoutput, { key: k }),
                        mortality120dose_response: _lodash2.default.filter(data.dose_response, {
                            endpoint_name: 'Mortality@120'
                        }),
                        mortality120bmcoutput: _lodash2.default.filter(data.bmcoutput, {
                            endpoint_name: 'Mortality@120'
                        })
                    };
                }).each(function (d, k) {
                    // console.log(this.props.final_dev_call, this.props.devtoxEndPointList, d.endpoint_name)
                    var dr = d.dose_response[0];
                    d.title = _this2.getPlotTitle(dr, collapse), d.casrn = dr.casrn, d.endpoint_name = dr.endpoint_name, d.outline = _this2.props.devtoxEndPointList && _this2.props.devtoxEndPointList.includes(d.endpoint_name) || _this2.props.final_dev_call === 'dev tox', d.input_ids = _lodash2.default.chain(d.bmcoutput).map('input_id').uniq().value(), d.mortality120input_ids = _lodash2.default.chain(d.mortality120bmcoutput).map('input_id').uniq().value(),
                    // filter with input_ids to filter bmcout into different case
                    d.bmcoutput = d.bmcoutput.filter(function (i) {
                        return d.input_ids.includes(i.input_id);
                    }), d.substance_code_input_ids = _lodash2.default.chain(d.dose_response.filter(function (i) {
                        return d.input_ids.includes(i.input_id);
                    })).map('substance_code_input_id').uniq().value(), d.substance_code_input_ids_120 = _lodash2.default.chain(d.mortality120dose_response.filter(function (i) {
                        return d.mortality120input_ids.includes(i.input_id);
                    })).map('substance_code_input_id').uniq().value();
                }).sortBy('endpoint_name').sortBy('casrn').sortBy('title').value();
            } else {
                keys = _lodash2.default.chain(data.dose_response).map('key').uniq().value(), groupKeys = _lodash2.default.chain(data.dose_response).map('groupKey').uniq().value(), collapsedData = _lodash2.default.chain(keys).map(function (k) {
                    return {
                        key: k,
                        groupKeys: groupKeys,
                        dose_response: _lodash2.default.filter(data.dose_response, { key: k }),
                        bmcoutput: _lodash2.default.filter(data.bmcoutput, { key: k })
                    };
                }).each(function (d, k) {
                    // console.log(this.props.final_dev_call, this.props.devtoxEndPointList, d.endpoint_name)

                    var dr = d.dose_response[0];
                    d.title = _this2.getPlotTitle(dr, collapse), d.casrn = dr.casrn, d.endpoint_name = dr.endpoint_name, d.input_ids = _lodash2.default.chain(d.bmcoutput).map('input_id').uniq().value(), d.outline = _this2.props.devtoxEndPointList && _this2.props.devtoxEndPointList.includes(d.endpoint_name) || _this2.props.final_dev_call === 'dev tox', d.bmcoutput = d.bmcoutput.filter(function (i) {
                        return d.input_ids.includes(i.input_id);
                    }), d.substance_code_input_ids = _lodash2.default.chain(d.dose_response.filter(function (i) {
                        return d.input_ids.includes(i.input_id);
                    })).map('substance_code_input_id').uniq().value();
                }).sortBy('endpoint_name').sortBy('casrn').sortBy('title').value();
            }
            // responses = _.map(data.dose_response, 'normalized_response');
            // responses.push(0);
            // yrange = d3.extent(responses);
            // offset = (yrange[1] - yrange[0]) * 0.15 * 0.5;
            // yrange = [yrange[0] - offset, yrange[1] + offset];
            //console.log(collapsedData);
            return {
                data: data,
                collapsedData: collapsedData,
                yrange: yrange,
                error: null
            };
        }
    }, {
        key: 'fetchDoseResponseData',
        value: function fetchDoseResponseData(url) {
            var _this3 = this;

            d3.json(url, function (error, data) {
                if (error) {
                    var err = error.target.responseText.replace('["', '').replace('"]', '');
                    _this3.setState({
                        data: [],
                        error: err
                    });
                    return;
                }
                //console.log('zw');
                _this3.updateData(data, _this3.props.collapse);
            });
        }
    }, {
        key: 'getColorScale',
        value: function getColorScale(data, collapse) {
            if (_lodash2.default.isEmpty(data)) {
                return _lodash2.default.noop;
            }
            switch (collapse) {
                case _shared.COLLAPSE_BY_READOUT:
                    return this.colorScale.domain(_lodash2.default.map(data[0].dose_response, 'casrn'));
                case _shared.COLLAPSE_BY_CHEMICAL:
                    return this.colorScale.domain(_lodash2.default.map(data[0].dose_response, 'endpoint_name'));
                case _shared.COLLAPSE_WITH_Mortality120:
                    return this.colorScale.domain(_lodash2.default.map(data[0].dose_response.concat(data[0].mortality120dose_response), 'endpoint_name'));
                case _shared.NO_COLLAPSE:
                    return _lodash2.default.noop;
                default:
                    throw 'Unknown collapse type.';
            }
        }
    }, {
        key: 'getMarkerColor',
        value: function getMarkerColor(d) {
            var marker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return this.state.scale(d);
        }
    }, {
        key: 'getPlotTitle',
        value: function getPlotTitle(data, collapse) {
            switch (collapse) {
                case _shared.COLLAPSE_BY_READOUT:
                    return data.protocol_name_plot + '<br>' + data.endpoint_name;
                case _shared.COLLAPSE_BY_CHEMICAL:
                    return data.preferred_name + '|' + data.casrn;
                case _shared.COLLAPSE_WITH_Mortality120:
                    return data.protocol_name_plot + '<br>' + data.preferred_name + '<br>' + data.casrn + '|' + data.dtxsid + ':<br>' + data.endpoint_name;
                case _shared.NO_COLLAPSE:
                    return data.protocol_name_plot + '<br>' + data.preferred_name + '<br>' + data.casrn + '|' + data.dtxsid + ':<br>' + data.endpoint_name;
                default:
                    throw 'Unknown collapse type.';
            }
        }
    }, {
        key: 'getResponseLabels',
        value: function getResponseLabels(data, collapse, labelCase) {
            if (_lodash2.default.isEmpty(data)) {
                return '';
            }

            switch (collapse) {
                case _shared.COLLAPSE_BY_READOUT:
                    return data.preferred_name + '|' + data.casrn + '|' + data.dtxsid;
                case _shared.COLLAPSE_BY_CHEMICAL:
                    return data.protocol_name_plot + '|' + data.endpoint_name;
                case _shared.COLLAPSE_WITH_Mortality120:
                    return data.protocol_name_plot + '|' + data.endpoint_name;
                case _shared.NO_COLLAPSE:
                    var index1 = data.substance_code,
                        index2 = data.input_id;
                    if (!this.state.labelsDict[index1]) {
                        this.state.labelsDict[index1] = [];
                        this.state.labelsDict[index1].push(index2);
                    } else {
                        if (!this.state.labelsDict[index1].includes(index2)) {
                            this.state.labelsDict[index1].push(index2);
                        }
                    }
                    if (labelCase == 'PC') {
                        return 'PC| ' + Object.values(this.state.labelsDict[index1]).length;
                    } else if (labelCase.length == 1) {
                        return 'plate| ' + Object.values(this.state.labelsDict[index1]).length;
                    } else {
                        return 'dup ' + Object.keys(this.state.labelsDict).length + '| plate ' + Object.values(this.state.labelsDict[index1]).length;
                    }
                default:
                    throw 'Unknown collapse type.';
            }
        }
    }, {
        key: 'getTextLabels',
        value: function getTextLabels(drs_split, d) {
            if (drs_split.length > 0) {
                var bmcData = d.bmcoutput.filter(function (r) {
                    return r.input_id == drs_split[0].input_id;
                });
                bmcData = bmcData[0];
                if (bmcData.hit_confidence < 0.5) {
                    return ' ';
                } else {
                    return 'BMC:' + (0, _shared.printFloat)((0, _shared.pod_med_processed)(bmcData.pod_med)) + ' \xB5M';
                }
            }
        }
    }, {
        key: 'setDatasetKey',
        value: function setDatasetKey(data, collapse) {
            switch (collapse) {
                case _shared.COLLAPSE_BY_READOUT:
                    data.key = data.protocol_id + '|' + data.endpoint_name;
                    data.groupKey = data.casrn;
                    data.substance_code_input_id = data.substance_code + '|' + data.input_id;

                    break;
                case _shared.COLLAPSE_BY_CHEMICAL:
                    data.key = data.casrn;
                    data.groupKey = data.protocol_id + '|' + data.endpoint_name;
                    data.substance_code_input_id = data.substance_code + '|' + data.input_id;
                    break;
                case _shared.COLLAPSE_WITH_Mortality120:
                    data.key = data.protocol_id + '|' + data.endpoint_name + '|' + data.casrn;
                    data.groupKey = null;
                    data.substance_code_input_id = data.substance_code + '|' + data.input_id;
                    break;
                case _shared.NO_COLLAPSE:
                    data.key = data.protocol_id + '|' + data.endpoint_name + '|' + data.casrn;
                    // data.key = `${data.endpoint_name}|${data.casrn}`;
                    data.groupKey = null;
                    data.substance_code_input_id = data.substance_code + '|' + data.input_id;
                    break;

                default:
                    throw 'Unknown collapse type.';
            }
        }
    }, {
        key: 'setKeys',
        value: function setKeys(data, collapse) {
            var _this4 = this;

            _lodash2.default.each(data.dose_response, function (d) {
                return _this4.setDatasetKey(d, collapse);
            });
            _lodash2.default.each(data.bmcoutput, function (d) {
                return _this4.setDatasetKey(d, collapse);
            });
            if (collapse === _shared.COLLAPSE_WITH_Mortality120) {
                _lodash2.default.each(data.mortality120dose_response, function (d) {
                    return _this4.setDatasetKey(d, collapse);
                });
            }
        }
    }, {
        key: 'updateData',
        value: function updateData(data, collapse) {
            //console.log('updateData');
            //console.log(data);
            this.setKeys(data, collapse);
            var update = this.collapseData(data, collapse);
            var scale = this.getColorScale(update.collapsedData, collapse);
            this.setState(_extends({}, update, {
                scale: scale
            }));
            this.loadDoseResponse();
        }
    }, {
        key: '_renderPlot',
        value: function _renderPlot(d, yrange) {
            var _this5 = this;

            //console.log('_renderPlot');
            if (this.refs[d.key] === undefined) {
                return;
            }
            //console.log(d);

            var data = [],
                dose_range = [0, 1],

            // dose_range = d3.extent(_.map(d.dose_response, 'n')),
            trsh = null,
                annotations = [];

            var svgConfig = {
                modeBarButtonsToRemove: ['toImage', // Remove "Download plot as PNG" button
                'hoverClosest3d', // Remove "Show closest data on hover" button
                'hoverCompareCartesian', // Remove "Compare data on hover" button
                'toggleSpikelines'],
                modeBarButtonsToAdd: [{
                    name: 'Download plot as a SVG',
                    icon: _Plotly2.default.Icons.camera,
                    click: function click(gd) {
                        _Plotly2.default.downloadImage(gd, { format: 'svg' });
                    }
                }]
            };
            var layout = {
                title: d.title,
                titlefont: {
                    size: 12
                },
                shapes: [],

                xaxis: _extends({
                    type: 'log',
                    autorange: true,
                    title: 'Concentration (µM)',
                    dtick: 1
                }, d.outline ? {
                    linecolor: '#d62976',
                    linewidth: 3,
                    mirror: true
                } : {}),
                yaxis: _extends({
                    type: 'linear',
                    title: 'response (%)',
                    autorange: false,
                    range: [-10, 110]
                }, d.outline ? {
                    linecolor: '#d62976',
                    linewidth: 3,
                    mirror: true
                } : {}),
                showlegend: false,
                // add room for collapsed plot legends
                height: this.props.height + d.groupKeys.length * 19 + 20,
                // width: this.props.height + d.groupKeys.length * 19 + 50,
                autosize: true
            };
            if (this.props.collapse == _shared.COLLAPSE_WITH_Mortality120) {
                d.groupKeys.map(function (gk) {
                    var drs = d.dose_response.filter(function (r) {
                        return r.groupKey == gk;
                    }),
                        mor120drs = d.mortality120dose_response.filter(function (r) {
                        return r.groupKey == gk;
                    }),
                        substance_codeCase = _lodash2.default.chain(drs).map('substance_code').uniq().value();
                    _this5.state.labelsDict = [];
                    d.substance_code_input_ids.map(function (id_flag, index) {
                        var drs_split = _lodash2.default.chain(drs).filter(function (r) {
                            return r.substance_code_input_id === id_flag;
                        }).sortBy('dose').value();

                        data.push({
                            x: _lodash2.default.map(drs_split, 'dose'),
                            y: drs_split.map(function (obj) {
                                return (obj.n_in / obj.n * 100).toFixed(2);
                            }),
                            legendgroup: 'plot',
                            mode: 'line',
                            type: 'scatter',
                            text: _this5.getResponseLabels(drs_split[0], _this5.props.collapse, substance_codeCase) + '<br>' + _this5.getTextLabels(drs_split, d),
                            marker: {
                                color: _this5.getMarkerColor(gk, 'responses')
                            },
                            opacity: 0.8
                        });
                    });

                    d.substance_code_input_ids_120.map(function (id_flag, index) {
                        var drs_split = _lodash2.default.chain(mor120drs).filter(function (r) {
                            return r.substance_code_input_id == id_flag;
                        }).sortBy('dose').value();
                        data.push({
                            x: _lodash2.default.map(drs_split, 'dose'),
                            y: drs_split.map(function (obj) {
                                return obj.n_in / obj.n * 100;
                            }),
                            legendgroup: 'plot',
                            mode: 'line',
                            type: 'scatter',
                            text: '' + _this5.getResponseLabels(drs_split[0], _this5.props.collapse, substance_codeCase),
                            marker: {
                                color: _this5.getMarkerColor(drs_split[0].endpoint_name, 'responses')
                            },
                            opacity: 0.8
                        });
                    });
                    // add trsh if exists
                    if (d.bmcoutput.length > 0) {
                        d.bmcoutput.filter(function (r) {
                            return r.groupKey == gk;
                        }).forEach(function (el) {
                            if (el.trsh === null || el.hit_confidence < 0.5) {
                                return;
                            }
                            trsh = el.trsh;
                            var dash = gk ? { dash: 'dot' } : null;
                        });
                    }
                });
            } else {
                d.groupKeys.map(function (gk) {
                    var drs = d.dose_response.filter(function (r) {
                        return r.groupKey == gk;
                    }),
                        substance_codeCase = _lodash2.default.chain(drs).map('substance_code').uniq().value();

                    _this5.state.labelsDict = [];
                    d.substance_code_input_ids.map(function (id_flag, index) {
                        var drs_split = drs.filter(function (r) {
                            return r.substance_code_input_id == id_flag;
                        });
                        drs_split = _lodash2.default.sortBy(drs_split, 'dose');
                        data.push({
                            x: _lodash2.default.map(drs_split, 'dose'),
                            y: drs_split.map(function (obj) {
                                return (obj.n_in / obj.n * 100).toFixed(2);
                            }),
                            legendgroup: 'plot',
                            mode: 'line',
                            type: 'scatter',
                            text: _this5.getResponseLabels(drs_split[0], _this5.props.collapse, substance_codeCase) + '<br>' + _this5.getTextLabels(drs_split, d),
                            marker: {
                                color: _this5.getMarkerColor(gk, 'responses')
                            },
                            opacity: 0.8
                        });
                    });
                    if (d.bmcoutput.length > 0) {
                        d.bmcoutput.filter(function (r) {
                            return r.groupKey == gk;
                        }).forEach(function (el) {
                            if (el.trsh === null || el.hit_confidence < 0.5) {
                                return;
                            }
                            trsh = el.trsh;
                            var dash = gk ? { dash: 'dot' } : null;
                        });
                    }
                });
            }
            if (this.props.collapse === _shared.NO_COLLAPSE && trsh) {
                layout.shapes.push({
                    type: 'line',
                    xref: 'paper',
                    x0: 0,
                    y0: trsh,
                    x1: 1,
                    y1: trsh,
                    line: {
                        color: 'grey',
                        width: 2,
                        dash: 'dot'
                    }
                });
            }

            // add grouped hill and bmcoutput legends if plot is collapsed
            if (this.props.collapse !== _shared.NO_COLLAPSE) {
                // move legend to bottom of plot
                layout.legend = { orientation: 'h', y: -0.3 };
            }
            // //console.log(d)

            _Plotly2.default.newPlot(this.refs[d.key], data, layout, svgConfig);
        }
    }, {
        key: 'loadDoseResponse',
        value: function loadDoseResponse() {
            var _this6 = this;

            //console.log('loadDoseResponse');
            this.state.collapsedData.map(function (d) {
                return _this6._renderPlot(d, _this6.state.yrange);
            });
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return this.fetchDoseResponseData(this.props.url);

                            case 3:
                                _context.next = 8;
                                break;

                            case 5:
                                _context.prev = 5;
                                _context.t0 = _context['catch'](0);

                                //console.error(error);
                                // Handle error if needed
                                this.setState({ error: 'Failed to fetch data.' });

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 5]]);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'componentDidUpdate',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(prevProps) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(prevProps.url !== this.props.url)) {
                                    _context2.next = 4;
                                    break;
                                }

                                _context2.next = 3;
                                return this.fetchDoseResponseData(this.props.url);

                            case 3:
                                return _context2.abrupt('return');

                            case 4:
                                if (!(prevProps.collapse !== this.props.collapse)) {
                                    _context2.next = 8;
                                    break;
                                }

                                _context2.next = 7;
                                return this.fetchDoseResponseData(this.props.url);

                            case 7:
                                this.updateData(this.state.data, this.props.collapse);

                            case 8:
                                if (prevProps.cols !== this.props.cols || prevProps.height !== this.props.height) {
                                    this.loadDoseResponse();
                                }

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function componentDidUpdate(_x2) {
                return _ref2.apply(this, arguments);
            }

            return componentDidUpdate;
        }()
    }, {
        key: 'render',
        value: function render() {
            if (this.state.error) {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert alert-warning' },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            this.state.error
                        )
                    )
                );
            }
            if (!this.state.data) {
                return _react2.default.createElement(_Loading2.default, null);
            }

            var colNum = Math.ceil(12 / this.props.cols);
            return (
                // <div className="row">
                _react2.default.createElement(
                    'div',
                    { className: 'd-flex flex-wrap' },
                    this.state.collapsedData.map(function (item) {
                        return _react2.default.createElement('div', { className: 'col-' + colNum, key: item.key, ref: item.key });
                    })
                )
            );
        }
    }]);

    return DoseResponse;
}(_react2.default.Component);

DoseResponse.propTypes = {
    cols: _propTypes2.default.number.isRequired,
    collapse: _propTypes2.default.string.isRequired,
    height: _propTypes2.default.number.isRequired,
    url: _propTypes2.default.string.isRequired,
    devtoxEndPointList: _propTypes2.default.array,
    final_dev_call: _propTypes2.default.string
};

exports.default = DoseResponse;

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tooltip = __webpack_require__(169);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _styles = __webpack_require__(1106);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StylesTooltip3 = (0, _styles.withStyles)({
    tooltip: {
        // tooltip default color: rgba(97, 97, 97, 0.9)
        // font     color: "#fff",
        //
        // border: "2px solid black", // Add this line for the border
        // backgroundColor: "white"
    }
})(_Tooltip2.default);

var HelpButtonWidget = function (_BaseWidget) {
    _inherits(HelpButtonWidget, _BaseWidget);

    /*
    HelpButtonWidget requires the following state properties:
        - stateHolder.state.showHelpText is one of the enumerations above
    */

    function HelpButtonWidget(props) {
        _classCallCheck(this, HelpButtonWidget);

        var _this = _possibleConstructorReturn(this, (HelpButtonWidget.__proto__ || Object.getPrototypeOf(HelpButtonWidget)).call(this, props));

        _this.handleHelpTextToggle = _this.handleHelpTextToggle.bind(_this);
        return _this;
    }

    _createClass(HelpButtonWidget, [{
        key: 'handleHelpTextToggle',
        value: function handleHelpTextToggle() {
            var stateHolder = this.props.stateHolder;
            var contentId = this.props.contentId;
            // const { stateHolder, contentId } = {this.props.stateHolder, this.props.contentId};
            if (contentId === 'datasetHelp') {
                stateHolder.setState({
                    showDatasetHelpText: !stateHolder.state.showDatasetHelpText
                });
            } else if (contentId === 'endpointHelp') {
                stateHolder.setState({
                    showEndpointHelpText: !stateHolder.state.showEndpointHelpText
                });
            }

            if (this.props.contentId !== stateHolder.state.helpButtonContentId) {
                stateHolder.setState({
                    showHelpText: true,
                    helpButtonContentId: this.props.contentId
                });
            } else {
                stateHolder.setState({
                    showHelpText: !stateHolder.state.showHelpText
                });
            }
        }
    }, {
        key: 'calculatePixelSize',
        value: function calculatePixelSize(headingLevel) {
            var fontSizeMapping = {
                h1: 1.6,
                h2: 1.5,
                h3: 1.3,
                h4: 1.2,
                label: 1.1
            };
            var defaultFontSize = 16; // Default font size in pixels
            var headingFontSize = fontSizeMapping[headingLevel] || 1.0; // Default to 1.0 if not found
            return headingFontSize * defaultFontSize;
        }
    }, {
        key: 'render',
        value: function render() {
            var pixelSize = this.calculatePixelSize(this.props.headLevel);
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    StylesTooltip3,
                    { title: this.props.title, arrow: true, placement: 'right-end' },
                    _react2.default.createElement(
                        'button',
                        {
                            style: {
                                paddingLeft: 15,
                                cursor: 'pointer' // Add cursor style here
                            },
                            onClick: this.handleHelpTextToggle
                        },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'svg',
                                {
                                    xmlns: 'http://www.w3.org/2000/svg',
                                    width: pixelSize,
                                    height: pixelSize,
                                    fill: '#31708f',
                                    className: 'bi bi-info-circle',
                                    viewBox: '0 0 16 16'
                                },
                                _react2.default.createElement('path', { d: 'M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' }),
                                _react2.default.createElement('path', { d: 'm8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return HelpButtonWidget;
}(_BaseWidget3.default);

HelpButtonWidget.propTypes = {
    headLevel: _propTypes2.default.string,
    title: _propTypes2.default.string,
    stateHolder: _propTypes2.default.object,
    contentId: _propTypes2.default.string
};

exports.default = HelpButtonWidget;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*

BaseWidget writes state into props.stateHolder react component; a naive
solution for a data-store.

*/

var BaseWidget = function (_React$Component) {
    _inherits(BaseWidget, _React$Component);

    function BaseWidget(props) {
        _classCallCheck(this, BaseWidget);

        var _this = _possibleConstructorReturn(this, (BaseWidget.__proto__ || Object.getPrototypeOf(BaseWidget)).call(this, props));

        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.handleSelectMultiChange = _this.handleSelectMultiChange.bind(_this);
        _this.handleRadioChange = _this.handleRadioChange.bind(_this);
        _this.handleIntegerInputChange = _this.handleIntegerInputChange.bind(_this);
        _this.handleFloatInputChange = _this.handleFloatInputChange.bind(_this);
        _this.handleCheckboxInputChange = _this.handleCheckboxInputChange.bind(_this);
        _this.handleToggleChange = _this.handleToggleChange.bind(_this);
        return _this;
    }

    _createClass(BaseWidget, [{
        key: 'handleRadioChange',
        value: function handleRadioChange(e) {
            var d = {};
            d[e.target.name] = parseInt(e.target.value);
            this.props.stateHolder.setState(d);
        }
    }, {
        key: 'handleSelectChange',
        value: function handleSelectChange(e) {
            var d = {};
            d[e.target.name] = (0, _$2.default)(e.target).val();
            this.props.stateHolder.setState(d);
        }
    }, {
        key: 'handleSelectMultiChange',
        value: function handleSelectMultiChange(e) {
            var d = {};
            d[e.target.name] = (0, _$2.default)(e.target).val();
            this.props.stateHolder.setState(d);
        }
    }, {
        key: 'handleIntegerInputChange',
        value: function handleIntegerInputChange(e) {
            var d = {};
            d[e.target.name] = parseInt(e.target.value);
            this.props.stateHolder.setState(d);
        }
    }, {
        key: 'handleFloatInputChange',
        value: function handleFloatInputChange(e) {
            var d = {};
            d[e.target.name] = parseFloat(e.target.value);
            this.props.stateHolder.setState(d);
        }
    }, {
        key: 'handleToggleChange',
        value: function handleToggleChange(e) {
            var d = {};
            d[e.target.name] = e.target.checked;
            this.props.stateHolder.setState(d);
        }
    }, {
        key: 'handleCheckboxInputChange',
        value: function handleCheckboxInputChange(e) {
            var _e$target = e.target,
                name = _e$target.name,
                checked = _e$target.checked;

            var list = this.props.stateHolder.state.selectivityList;
            list.map(function (i) {
                if (i.name === name) {
                    i.isChecked = checked;
                }
            });
            this.props.stateHolder.setState(list);
        }
    }]);

    return BaseWidget;
}(_react2.default.Component);

BaseWidget.propTypes = {
    stateHolder: _propTypes2.default.instanceOf(_react2.default.Component).isRequired
};

exports.default = BaseWidget;

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DoseResponseGridWidget = function (_BaseWidget) {
    _inherits(DoseResponseGridWidget, _BaseWidget);

    /*
    DoseResponseGridWidget requires the following state properties:
        - stateHolder.state.vizColumns
        - stateHolder.state.vizHeight
    */
    function DoseResponseGridWidget(props) {
        _classCallCheck(this, DoseResponseGridWidget);

        return _possibleConstructorReturn(this, (DoseResponseGridWidget.__proto__ || Object.getPrototypeOf(DoseResponseGridWidget)).call(this, props));
    }

    _createClass(DoseResponseGridWidget, [{
        key: 'render',
        value: function render() {
            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'mb-3' },
                    _react2.default.createElement(
                        'label',
                        { className: 'form-label' },
                        'Number of columns [1-4] to view:'
                    ),
                    _react2.default.createElement('input', {
                        className: 'form-range' // Updated for Bootstrap 5 range input style
                        , type: 'range',
                        name: 'vizColumns',
                        min: '1',
                        max: '4',
                        onChange: this.handleIntegerInputChange,
                        value: state.vizColumns
                    }),
                    _react2.default.createElement(
                        'span',
                        null,
                        state.vizColumns,
                        ' columns selected'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'mb-3' },
                    _react2.default.createElement(
                        'label',
                        { className: 'form-label' },
                        'Image height [350-700px]:'
                    ),
                    _react2.default.createElement('input', {
                        className: 'form-range' // Updated for Bootstrap 5 range input style
                        , type: 'range',
                        name: 'vizHeight',
                        min: '350',
                        max: '700',
                        step: '50',
                        onChange: this.handleIntegerInputChange,
                        value: state.vizHeight
                    }),
                    _react2.default.createElement(
                        'span',
                        null,
                        state.vizHeight,
                        ' px selected'
                    )
                )
            );
        }
    }]);

    return DoseResponseGridWidget;
}(_BaseWidget3.default);

exports.default = DoseResponseGridWidget;

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RankedBarchartHandler = __webpack_require__(274);

var _RankedBarchartHandler2 = _interopRequireDefault(_RankedBarchartHandler);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BmdCheckBoxWidget = function (_BaseWidget) {
    _inherits(BmdCheckBoxWidget, _BaseWidget);

    /*
    BmdCheckBoxWidget requires the following state properties:
        - stateHolder.state.BmdCheckBoxWidget
    */
    function BmdCheckBoxWidget(props) {
        _classCallCheck(this, BmdCheckBoxWidget);

        var _this = _possibleConstructorReturn(this, (BmdCheckBoxWidget.__proto__ || Object.getPrototypeOf(BmdCheckBoxWidget)).call(this, props));

        _this.state = {
            showHelpText: false
        };
        return _this;
    }

    _createClass(BmdCheckBoxWidget, [{
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'Text box: \u201CBy default, only the test substances eliciting specific effects will appear.'
                ),
                _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                        'li',
                        null,
                        'specific = a test substance produces quantifiable alteration(s) in phenotypes at a concentration lower than that which causes overt toxicity (i.e., mortality)'
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        'non-specific = a test substance produces both altered phenotypes and mortality at similar concentrations'
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        'non-toxic = no changes to phenotype or survival occurred at the concentrations evaluated'
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        'inconclusive = specificity couldn\u2019t be determined based on differences among plate replicates and requires more testing'
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        'not evaluated = a phenotype that was not assessed in a particular laboratory'
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'label-horizontal' },
                    'Developmental Toxicity Classification:',
                    _react2.default.createElement(_HelpButtonWidget2.default, {
                        stateHolder: this,
                        headLevel: 'label',
                        title: 'More information on developmental toxicity classifications'
                    })
                ),
                this._renderHelpText(),
                state.selectivityList.map(function (d, index) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'checkbox', key: index },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                type: 'checkbox',
                                name: d.name,
                                defaultChecked: d.isChecked,
                                onChange: _this2.handleCheckboxInputChange
                            }),
                            d.label
                        )
                    );
                })
            );
        }
    }]);

    return BmdCheckBoxWidget;
}(_BaseWidget3.default);

exports.default = BmdCheckBoxWidget;

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(51);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _Loading = __webpack_require__(86);

var _Loading2 = _interopRequireDefault(_Loading);

var _BmdTable = __webpack_require__(1119);

var _BmdTable2 = _interopRequireDefault(_BmdTable);

var _RankedBarchart = __webpack_require__(452);

var _RankedBarchart2 = _interopRequireDefault(_RankedBarchart);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

var _shared = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RankedBarchartHandler = function (_React$Component) {
    _inherits(RankedBarchartHandler, _React$Component);

    function RankedBarchartHandler(props) {
        _classCallCheck(this, RankedBarchartHandler);

        // console.log(props.stateHolder.state)
        // this.parseJSONToCSVStr = this.parseJSONToCSVStr.bind(this);
        var _this = _possibleConstructorReturn(this, (RankedBarchartHandler.__proto__ || Object.getPrototypeOf(RankedBarchartHandler)).call(this, props));

        _this.state = { data: null };
        return _this;
    }

    _createClass(RankedBarchartHandler, [{
        key: 'fetchBmdData',
        value: function fetchBmdData(url) {
            var _this2 = this;

            d3.json(url, function (error, data) {
                if (error) {
                    var err = error.target.responseText.replace('["', '').replace('"]', '');
                    _this2.setState({
                        data: [],
                        error: err
                    });
                    return;
                }
                _this2.setState({ data: data });
            });
        }
    }, {
        key: 'setDatasetKey',
        value: function setDatasetKey(data) {
            data.key = data.endpoint_name + '|' + data.protocol_id;
            data.chemicalKey = data.casrn + '|' + data.dtxsid;
        }
    }, {
        key: '_getFilteredData',
        value: function _getFilteredData() {
            var selectivityCheckedArray = void 0,
                data = void 0,
                plotData = void 0;

            if (this.props.visualization === _shared.BMDVIZ_ACTIVITY) {
                data = _lodash2.default.chain(this.state.data.bmd_activity_selectivity).map(function (d) {
                    return _extends({}, d, {
                        y: d.casrn
                    });
                }).sortBy('med_pod_med').value();
            } else {
                selectivityCheckedArray = _lodash2.default.chain(this.props.selectivityList).filter(function (r) {
                    return r.isChecked === true;
                }).map('name').uniq().value();
                data = _lodash2.default.chain(this.state.data.bmd_activity_selectivity).filter(function (i) {
                    return selectivityCheckedArray.includes(i.final_dev_call);
                }).map(function (d) {
                    return _extends({}, d, {
                        y: d.casrn
                        // ontologyGroupName: d[ontologyGroupType],
                        // title:
                        //     d[ontologyGroupType] + '+' + d.protocol_name_plot + '+' + d.preferred_name,
                    });
                }).sortBy('mean_selectivity').reverse().value();
            }
            //
            plotData = _lodash2.default.chain(data).groupBy('casrn').map(function (k) {
                var endpoint_names = _lodash2.default.chain(k).map('endpoint_name').uniq().value(),
                    minimimumNonViability = _lodash2.default.chain(k).min(function (d) {
                    return (0, _shared.pod_med_processed)(d.med_pod_med);
                }).value(),
                    minimimumViability = _lodash2.default.chain(k).min(function (d) {
                    return (0, _shared.pod_med_processed)(d.mort_med_pod_med);
                }).value();
                var devtoxEndpoints = _lodash2.default.chain(k).filter(function (i) {
                    return i.final_dev_call === 'dev tox';
                }).map('endpoint_name').uniq().value();

                return {
                    casrn: k[0].casrn,
                    data: k,
                    endpoint_name: endpoint_names,
                    minimimumNonViability: _extends({}, minimimumNonViability, {
                        endpoint_names_list: endpoint_names
                    }),
                    minimimumViability: _extends({}, minimimumViability, {
                        endpoint_names_list: endpoint_names
                    }),
                    related_endpoint_names: endpoint_names,
                    related_devtoxEndpoints: devtoxEndpoints,
                    protocol_id: minimimumNonViability.protocol_id,
                    preferred_name: minimimumNonViability.preferred_name,
                    use_category1: minimimumNonViability.use_category1,
                    malformation: minimimumNonViability.malformation,
                    combin_ontology: minimimumNonViability.combin_ontology,
                    combin_ontology_id: minimimumNonViability.combin_ontology_id,
                    mean_pod: minimimumNonViability.mean_pod,
                    mean_selectivity: minimimumNonViability.mean_selectivity,
                    n_values: minimimumNonViability.n_values
                };
            }).value();
            // console.log('data');
            //
            //console.log('data',data);
            // console.log('plotData',plotData);
            // console.log(plotData);
            return plotData;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.fetchBmdData(this.props.url);
        }
    }, {
        key: 'UNSAFE_componentWillUpdate',
        value: function UNSAFE_componentWillUpdate(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.fetchBmdData(nextProps.url);
            }
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            if (this.props.visualization === _shared.INTVIZ_HEATMAP) {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert alert-info' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'Test substances are ranked from top to bottom (y-axis of the chart) by lowest BMC (most active) to highest. The Use categories of test substances are color coded next to each test substance name. If more than one non-mortality endpoint was selected, the endpoint with the lowest BMC is included. Each BMC for ranking is the median value of the BMC from the triplicate testing and is shown as the colored dot. The range of lowest BMC and the highest BMC is shown as the colored bar.'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Additionally, the BMC values of the corresponding mortality (median, min and max) are shown as the black dot and the black dashed line, respectively. If the substance is inactive in either the non-mortality endpoints or the mortality endpoint, no dots or bars will be shown.'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The BMC values of all substances of the endpoint with the lowest median BMC are listed below in tabular form (\u201C-\u201C for inactive).'
                    )
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert alert-info' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'Specificity values for each test substance appear on the right-side of the chart and are ranked by most to least specific. The use categories of test substances are color coded next to each test substance name. The user can select more than one non-mortality endpoint.'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        null,
                        'BMC value of the altered phenotype with the lowest summarized BMC among the selected non-mortality endpoints is shown as the colored dot, and the corresponding mortality (if active) is shown as the black dot (median) and the black bar (min-max BMC). If the substance is inactive in either the non-mortality endpoints or the mortality endpoint, no dots or bars will be shown.'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The BMC values of test substances with specific effect (default, but other types can be toggled) listed below in tabular form (\u201C-\u201C for inactive).'
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.data) {
                return _react2.default.createElement(_Loading2.default, null);
            }
            // let url = getBmdsUrl(this.state.assays, this.state.readouts);
            var chartName = this.props.visualization === _shared.BMDVIZ_ACTIVITY ? 'activity' : 'specificity',
                tableName = this.props.visualization === _shared.BMDVIZ_ACTIVITY ? 'all chemicals' : 'selected chemicals',
                title = this.props.visualization === _shared.BMDVIZ_ACTIVITY ? 'More information on BMC by activity' : 'More information on BMC by specificity',
                csvfileName = this.props.visualization === _shared.BMDVIZ_ACTIVITY ? 'ActivityBMCData.csv' : 'SpecificityBMCData.csv',
                csvfileHeader = this.props.visualization === _shared.BMDVIZ_ACTIVITY ? [{
                title: 'dataset name (long)',
                section: 'minimimumNonViability',
                key: 'protocol_name_long'
            }, {
                title: 'dataset name (short)',
                section: 'minimimumNonViability',
                key: 'protocol_name_plot'
            }, {
                title: 'dtxsid',
                section: 'minimimumNonViability',
                key: 'dtxsid'
            }, {
                title: 'casrn',
                key: 'casrn'
            }, {
                title: 'test substance',
                key: 'preferred_name'
            }, {
                title: 'use category',
                key: 'use_category1'
            }, {
                title: 'endpoint',
                section: 'minimimumNonViability',
                key: 'endpoint_name'
            }, {
                title: 'endpoint bmc (microM)',
                method: 'processMedPodMed', // Function for processing med_pod_med
                section: 'minimimumNonViability',
                key: 'med_pod_med'
            }, {
                title: 'mortality bmc (microM)',
                method: 'processMedPodMed', // Function for processing mort_med_pod_med
                section: 'minimimumNonViability',
                key: 'mort_med_pod_med'
            }, {
                title: 'lowest tested conc (microM)',
                method: 'processMedPodMed', // Function for processing mort_med_pod_med
                section: 'minimimumNonViability',
                key: 'min_lowest_conc'
            }, {
                title: 'highest tested conc (microM)',
                method: 'processMedPodMed', // Function for processing mort_med_pod_med

                section: 'minimimumNonViability',
                key: 'max_highest_conc'
            }, {
                title: 'n curves evaluated',
                key: 'n_values'
            }, {
                title: 'n endpoints selected',
                method: 'length', // Function for getting length of endpoint_names_list
                section: 'minimimumNonViability',
                key: 'endpoint_names_list'
            }] : [{
                title: 'dataset name (long)',
                section: 'minimimumNonViability',
                key: 'protocol_name_long'
            }, {
                title: 'dataset name (short)',
                section: 'minimimumNonViability',
                key: 'protocol_name_plot'
            }, {
                title: 'dtxsid',
                section: 'minimimumNonViability',
                key: 'dtxsid'
            }, {
                title: 'casrn',
                key: 'casrn'
            }, {
                title: 'test substance',
                key: 'preferred_name'
            }, {
                title: 'use category',
                key: 'use_category1'
            }, {
                title: 'laboratory specific term',
                section: 'minimimumNonViability',
                key: 'malformation'
            }, {
                title: 'ontology term',
                method: 'cat', // Function for getting length of endpoint_names_list
                key: 'combin_ontology'
            }, {
                title: 'ontology id',
                method: 'cat', // Function for getting length of endpoint_names_list
                key: 'combin_ontology_id'
            }, {
                title: 'ontology term bmc (microM)',
                method: 'processMedPodMed', // Function for getting length of endpoint_names_list
                key: 'mean_pod'
            }, {
                title: 'developmental toxicity classification',
                method: 'map', // Function for getting length of endpoint_names_list
                section: 'minimimumNonViability',

                key: 'final_dev_call'
            }, {
                title: 'mortality bmc (microM)',
                method: 'processMedPodMed', // Function for processing mort_med_pod_med
                section: 'minimimumNonViability',
                key: 'mort_med_pod_med'
            }, {
                title: 'specificity',
                key: 'mean_selectivity'
            }, {
                title: 'lowest tested conc (microM)',
                method: 'processMedPodMed', // Function for processing mort_med_pod_med
                section: 'minimimumNonViability',
                key: 'min_lowest_conc'
            }, {
                title: 'highest tested conc (microM)',
                method: 'processMedPodMed', // Function for processing mort_med_pod_med
                section: 'minimimumNonViability',
                key: 'max_highest_conc'
            }, {
                title: 'n curves evaluated',
                key: 'n_values'
            }, {
                title: 'n endpoints selected',
                method: 'length',
                section: 'minimimumNonViability',
                key: 'endpoint_names_list'
            }],
                plotData = this._getFilteredData();
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    { className: 'label-horizontal label-normal' },
                    'BMC values: sorted by ',
                    chartName,
                    _react2.default.createElement(_HelpButtonWidget2.default, { stateHolder: this, headLevel: 'h2', title: title })
                ),
                this._renderHelpText(),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'h4',
                        { className: 'label-normal' },
                        _react2.default.createElement('button', {
                            onClick: function onClick() {
                                return (0, _shared.svg_download_form)('BMC_heatmap01');
                            },
                            className: 'fa fa-camera pointer-button'
                        }),
                        _react2.default.createElement(
                            'span',
                            null,
                            ' Image'
                        )
                    )
                ),
                _react2.default.createElement(_RankedBarchart2.default, {
                    data: plotData,
                    visualization: this.props.visualization,
                    selectedAxis: this.props.selectedAxis,
                    selectivityList: this.props.selectivityList
                }),
                _react2.default.createElement(
                    'p',
                    { className: ' form-text' },
                    _react2.default.createElement(
                        'b',
                        null,
                        'Interactivity note:'
                    ),
                    ' This chart is interactive. Click an item to view the concentration-response curves from which the BMC was derived.'
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'h4',
                        { className: 'label-horizontal  label-normal' },
                        'BMC for ',
                        tableName,
                        _react2.default.createElement(_HelpButtonWidget2.default, { stateHolder: this, headLevel: 'h2', title: title })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'h4',
                            { className: 'label-normal' },
                            _react2.default.createElement('button', {
                                onClick: function onClick() {
                                    return (0, _shared.exportCsv)(plotData, csvfileName, csvfileHeader);
                                },
                                className: 'fa fa-download pointer-button'
                            }),
                            _react2.default.createElement(
                                'span',
                                null,
                                ' Data'
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BmdTable2.default, { data: plotData, visualization: this.props.visualization })
            );
        }
    }]);

    return RankedBarchartHandler;
}(_react2.default.Component);

RankedBarchartHandler.propTypes = {
    // selectedArray: PropTypes.string.isRequired,
    // selectedReadouts: PropTypes.array.isRequired,
    visualization: _propTypes2.default.number.isRequired,
    selectivityCutoff: _propTypes2.default.number.isRequired,
    selectivityList: _propTypes2.default.array.isRequired,
    selectedAxis: _propTypes2.default.number.isRequired,
    url: _propTypes2.default.string.isRequired
};

exports.default = RankedBarchartHandler;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLog10AxisFunction = undefined;

var _d = __webpack_require__(21);

var getLog10AxisFunction = function getLog10AxisFunction(axisFunction, scale) {
    /*
    The default d3.log scale axis can contain minor scale ticks which is
    distracting; this helper function returns a scale w/ only base10
    text presented.
     https://github.com/d3/d3-axis/blob/master/README.md#axis_ticks
     */
    var orderOfMagnitude = Math.ceil(Math.log10(scale.domain()[1])) - Math.floor(Math.log10(scale.domain()[0]));

    if (orderOfMagnitude % 10 === 0) {
        orderOfMagnitude = orderOfMagnitude / 2;
    }

    return axisFunction(scale).ticks(orderOfMagnitude * 1.1, function (d) {
        if (parseInt(Math.log10(d)) === Math.log10(d)) {
            var formatter = d > 1 ? (0, _d.format)(',.0f') : (0, _d.format)(',.0g');
            return formatter(d);
        } else {
            return null;
        }
    });
};

exports.getLog10AxisFunction = getLog10AxisFunction;

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _OntologyTypeWidget = __webpack_require__(296);

var _OntologyTypeWidget2 = _interopRequireDefault(_OntologyTypeWidget);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

var _shared = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReadoutWidget = function (_BaseWidget) {
    _inherits(ReadoutWidget, _BaseWidget);

    /*
    ReadoutWidget requires the following state properties:
    */

    function ReadoutWidget(props) {
        _classCallCheck(this, ReadoutWidget);

        var _this = _possibleConstructorReturn(this, (ReadoutWidget.__proto__ || Object.getPrototypeOf(ReadoutWidget)).call(this, props));

        _this.mapFun = function (r) {
            return _extends({}, r, {
                key: r.seazit_protocol_id,
                label: r.protocol_name_long,
                description: r.protocol_name_plot
            });
        };

        _this.state = {
            showHelpText: false,
            showCategoryHelpText: null,
            showDatasetHelpText: false,
            showEndpointHelpText: false
        };
        return _this;
    }

    _createClass(ReadoutWidget, [{
        key: '_renderSingleDatasetSelector',
        value: function _renderSingleDatasetSelector(state, renderHelpButtonWidget, renderHelpText) {
            var options = _lodash2.default.chain(state.protocol_data).map(this.mapFun).sortBy('seazit_protocol_id').value();

            return (0, _shared.renderSelectSingleWidget)('assays', 'dataset', options, state.assays, this.handleSelectChange, renderHelpButtonWidget, renderHelpText);
        }
    }, {
        key: '_renderMultipleDatasetSelector',
        value: function _renderMultipleDatasetSelector(state, renderHelpButtonWidget, renderHelpText) {
            var options = _lodash2.default.chain(state.protocol_data).map(this.mapFun).sortBy('seazit_protocol_id').value();

            return _react2.default.createElement(
                'div',
                null,
                (0, _shared.renderSelectMultiWidget)('assays', 'dataset', options, state.assays, this.handleSelectMultiChange, renderHelpButtonWidget, renderHelpText)
            );
        }
    }, {
        key: '_renderFilterBy',
        value: function _renderFilterBy(state, renderHelpButtonWidget, renderHelpText) {
            if (state.assays.length === 0) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'label-horizontal' },
                    'Filter endpoints by:',
                    renderHelpButtonWidget && renderHelpButtonWidget()
                ),
                renderHelpText && renderHelpText(),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'ontologyType',
                            onChange: this.handleRadioChange,
                            value: _shared.integrative_General,
                            checked: state.ontologyType === _shared.integrative_General
                        }),
                        'General'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'ontologyType',
                            onChange: this.handleRadioChange,
                            value: _shared.integrative_Granular,
                            checked: state.ontologyType === _shared.integrative_Granular
                        }),
                        'Granular'
                    )
                )
            );
        }
    }, {
        key: '_renderMultipleEndpointSelector',
        value: function _renderMultipleEndpointSelector(state, renderHelpButtonWidget, renderHelpText) {
            //console.log(state.assays);
            var assays = Array.isArray(state.assays) ? state.assays.map(function (item) {
                return Number(item);
            }) : [Number(state.assays)];
            var opts = null;
            var endPointFilterFun = null;
            var endPointSortFun = null;
            var keyFunction = null;
            var groupBy = null;
            switch (state.tabFlag) {
                case _shared.ConcentrationResponseTab:
                    // group by category,
                    // no endpoint filter function,
                    //   Sort endpoint, put 'Mortality@24',      'Mortality@120',  'MalformedAny+Mort@120' be first 3 endpoints.
                    groupBy = 'category';
                    endPointSortFun = function endPointSortFun(e) {
                        return !['Mortality@24', 'Mortality@120', 'MalformedAny+Mort@120'].includes(e.label);
                    };
                    break;
                case _shared.BMCTab:
                    // group by 'developmental_defect_grouping_granular' or 'developmental_defect_grouping_general',
                    //  endpoint filter out, 'Mortality@24', 'Mortality@120', endpoint contains @24
                    //  no sort function.
                    endPointFilterFun = function endPointFilterFun(r) {
                        return !['Mortality@120', 'Mortality@24', '@24'].some(function (term) {
                            return r.endpoint_name.includes(term);
                        });
                    };
                    groupBy = state.ontologyType === _shared.integrative_Granular ? 'developmental_defect_grouping_granular' : 'developmental_defect_grouping_general';
                    keyFunction = function keyFunction(key) {
                        return key === 'null' ? '(no labels)' : key;
                    };
                    break;
                case _shared.IntegrativeAnalysesTab:
                    break;
                default:
                    return null;
            }
            opts = _lodash2.default.chain(state.Seazit_ui_panel).filter(function (r) {
                // I used to use _.includes(). I found this is wrong. if assays is double digits ex: 10,
                // it will includes  [1, 10]
                return _lodash2.default.includes(assays, r.seazit_protocol_id);
            }).filter(endPointFilterFun).map(function (r) {
                return _extends({}, r, {
                    key: r.endpoint_name_protocol,
                    category: r.protocol_name_plot,
                    label: r.endpoint_name,
                    description: r.endpoint_description
                    // description: 'zw2',
                });
            }).sortBy('label').sortBy(endPointSortFun).groupBy(groupBy).mapValues(function (group) {
                return _lodash2.default.uniqBy(group, 'key');
            }).thru(function (result) {
                return keyFunction ? _lodash2.default.mapKeys(result, function (value, key) {
                    return keyFunction(key);
                }) : result;
            }).toPairs().orderBy(0) // Sort by the group key (the first element in each pair)
            .fromPairs().value();

            if (_lodash2.default.keys(opts).length === 0) {
                return null;
            }
            return (0, _shared.renderSelectMultiOptgroupWidget)('readouts', 'endpoint', opts, state.readouts, this.handleSelectMultiChange, renderHelpButtonWidget, renderHelpText);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            // loadBaseUrl(this);

            var state = this.props.stateHolder.state;
            var DatasetHelpText = null;
            var EndpointHelpText = null;
            var DatasetHelpButtonWidget = null;
            var EndpointHelpButtonWidget = null;

            switch (state.tabFlag) {
                case _shared.ConcentrationResponseTab:
                    DatasetHelpButtonWidget = function DatasetHelpButtonWidget() {
                        return _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: _this2,
                            headLevel: 'label',
                            title: 'Information on datasets which can be selected for comparison',
                            contentId: 'datasetHelp'
                        });
                    };

                    DatasetHelpText = function DatasetHelpText() {
                        if (!_this2.state.showDatasetHelpText) {
                            return null;
                        }
                        return _react2.default.createElement(
                            'div',
                            { className: 'alert alert-info' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'The short name of the dataset will appear by hovering over the text. Study abbreviations: Dose range finding study = DRF and Definitive study = Def. Note that there is no limit to the number of datasets you can select. More information can be found on the',
                                _react2.default.createElement(
                                    'a',
                                    { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                                    ' Datasets page'
                                ),
                                '.'
                            )
                        );
                    };

                    EndpointHelpButtonWidget = function EndpointHelpButtonWidget() {
                        return _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: _this2,
                            headLevel: 'label',
                            title: 'More information on endpoints',
                            contentId: 'endpointHelp'
                        });
                    };

                    EndpointHelpText = function EndpointHelpText() {
                        if (!_this2.state.showEndpointHelpText) {
                            return null;
                        }
                        return _react2.default.createElement(
                            'div',
                            { className: 'alert alert-info' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Hover over each endpoint for a description (including the associated ontology terms). Each endpoint is derived from mortality score at two time points (24 and 120 hours post fertilization (hpf)) or in combination with each laboratory specific recording term. MalformedAny refers to the percent of affected embryo (either mortality or malformation). See',
                                _react2.default.createElement(
                                    'a',
                                    { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                                    ' Datasets page'
                                ),
                                ' for more information.'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'p',
                                null,
                                'All endpoints must be selected individually and are organized by dataset name.'
                            )
                        );
                    };
                    return _react2.default.createElement(
                        'div',
                        null,
                        this._renderMultipleDatasetSelector(state, DatasetHelpButtonWidget, DatasetHelpText),
                        _react2.default.createElement('br', null),
                        this._renderMultipleEndpointSelector(state, EndpointHelpButtonWidget, EndpointHelpText)
                    );
                case _shared.BMCTab:
                    // stateholder

                    DatasetHelpButtonWidget = function DatasetHelpButtonWidget() {
                        return _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: _this2,
                            headLevel: 'label',
                            title: 'Information on datasets',
                            contentId: 'datasetHelp'
                        });
                    };
                    DatasetHelpText = function DatasetHelpText() {
                        if (!_this2.state.showDatasetHelpText) {
                            return null;
                        }
                        return _react2.default.createElement(
                            'div',
                            { className: 'alert alert-info' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Study abbreviations: Dose range finding study = DRF and Definitive study = Def. Note that only one dateset can be selected at one time. More information can be found on the',
                                _react2.default.createElement(
                                    'a',
                                    { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                                    ' Datasets page'
                                ),
                                '.'
                            )
                        );
                    };

                    EndpointHelpButtonWidget = function EndpointHelpButtonWidget() {
                        return _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: _this2,
                            headLevel: 'label',
                            title: 'More information on endpoints',
                            contentId: 'endpointHelp'
                        });
                    };

                    EndpointHelpText = function EndpointHelpText() {
                        if (!_this2.state.showEndpointHelpText) {
                            return null;
                        }
                        return _react2.default.createElement(
                            'div',
                            { className: 'alert alert-info' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Detailed recordings of each laboratory are grouped into corresponding higher level developmental defect phenotype groups. We created two types of developmental defect phenotypes, the general grouping and the granular grouping. See',
                                _react2.default.createElement(
                                    'a',
                                    { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                                    ' Datasets page'
                                ),
                                ' for more information.'
                            )
                        );
                    };
                    return _react2.default.createElement(
                        'div',
                        null,
                        this._renderSingleDatasetSelector(state, DatasetHelpButtonWidget, DatasetHelpText),
                        _react2.default.createElement('br', null),
                        this._renderFilterBy(state, EndpointHelpButtonWidget, EndpointHelpText),
                        this._renderMultipleEndpointSelector(state)
                    );

                case _shared.IntegrativeAnalysesTab:
                    DatasetHelpText = function DatasetHelpText() {
                        if (!_this2.state.showHelpText) {
                            return null;
                        }
                        return _react2.default.createElement(
                            'div',
                            { className: 'alert alert-info' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Study abbreviations: Dose range finding study = DRF and Definitive study = Def. Note: there is no limit to the number of datasets you can select. More information can be found on the',
                                _react2.default.createElement(
                                    'a',
                                    { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                                    ' Datasets page'
                                ),
                                '.'
                            )
                        );
                    };
                    DatasetHelpButtonWidget = function DatasetHelpButtonWidget() {
                        return _react2.default.createElement(_HelpButtonWidget2.default, {
                            stateHolder: _this2,
                            headLevel: 'label',
                            title: 'Click to toggle help-text'
                        });
                    };
                    return _react2.default.createElement(
                        'div',
                        null,
                        this._renderMultipleDatasetSelector(state, DatasetHelpButtonWidget, DatasetHelpText)
                    );
                default:
                    // Default action or other cases
                    return null;
            }
        }
    }]);

    return ReadoutWidget;
}(_BaseWidget3.default);

ReadoutWidget.propTypes = {
    stateHolder: _propTypes2.default.instanceOf(_react2.default.Component).isRequired,
    hideViability: _propTypes2.default.bool.isRequired,
    hideNonViability: _propTypes2.default.bool.isRequired,
    multiAssaySelector: _propTypes2.default.bool.isRequired,
    multiReadoutSelector: _propTypes2.default.bool.isRequired
};

exports.default = ReadoutWidget;

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _shared = __webpack_require__(11);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OntologyTypeWidget = function (_BaseWidget) {
    _inherits(OntologyTypeWidget, _BaseWidget);

    function OntologyTypeWidget() {
        _classCallCheck(this, OntologyTypeWidget);

        return _possibleConstructorReturn(this, (OntologyTypeWidget.__proto__ || Object.getPrototypeOf(OntologyTypeWidget)).apply(this, arguments));
    }

    _createClass(OntologyTypeWidget, [{
        key: 'render',
        value: function render() {
            var state = this.props.stateHolder.state;
            // console.log(state);
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    'Ontology Groupings: Filter endpoints by:'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'ontologyType',
                            onChange: this.handleRadioChange,
                            value: _shared.integrative_Granular,
                            checked: state.ontologyType === _shared.integrative_Granular
                        }),
                        'by Granular'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'ontologyType',
                            onChange: this.handleRadioChange,
                            value: _shared.integrative_General,
                            checked: state.ontologyType === _shared.integrative_General
                        }),
                        'by General'
                    )
                )
            );
        }
    }]);

    return OntologyTypeWidget;
}(_BaseWidget3.default);

exports.default = OntologyTypeWidget;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = $;

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _d2 = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Loading = __webpack_require__(86);

var _Loading2 = _interopRequireDefault(_Loading);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

var _plotly = __webpack_require__(1116);

var _plotly2 = _interopRequireDefault(_plotly);

var _shared = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import FileReaderInput from 'react-file-reader';

var SankeyPlot = function (_React$Component) {
    _inherits(SankeyPlot, _React$Component);

    function SankeyPlot(props) {
        _classCallCheck(this, SankeyPlot);

        var _this = _possibleConstructorReturn(this, (SankeyPlot.__proto__ || Object.getPrototypeOf(SankeyPlot)).call(this, props));

        _this.state = {
            // loadMetadata
            // sankeydataLoaded: false,
            // sankeydata: null,
            ontologydata: [],
            nodesData: [],
            scale: _lodash2.default.noop,
            error: null,
            labelsDict: {}
        };
        return _this;
    }

    _createClass(SankeyPlot, [{
        key: 'fetchSankeyData',
        value: function fetchSankeyData() {
            var _this2 = this;

            d3.json(_shared.URL_SANKEYDATA, function (d) {
                ////console.log('URL_SANKEYDATA');
                ////console.log(d);
                _this2.updateData(d);
            });
        }
    }, {
        key: 'updateData',
        value: function updateData(data) {
            var cells = this.props.cells,
                ontology = data.Seazit_ontology.filter(function (item) {
                return item.developmental_defect_grouping_general === cells.developmental_defect_grouping_general && item.protocol_source === cells.protocol_source;
            }),
                flowsData = data.Seazit_ontology_sankey_flow,
                nodesData = data.Seazit_ontology_sankey_nodes,
                plotData = void 0,
                filterDataFun = function filterDataFun(dataA, dataB) {
                // Filter dataA based on some condition
                var result = _lodash2.default.filter(dataA, function (a) {
                    return _lodash2.default.some(dataB, function (b) {
                        return _lodash2.default.isEqual(a.target_name, b.proposed_ontology_label) && _lodash2.default.isEqual(a.source_name, b.recording_name) || _lodash2.default.isEqual(a.target_name, b.developmental_defect_grouping_granular) && _lodash2.default.isEqual(a.source_name, b.proposed_ontology_label) || _lodash2.default.isEqual(a.target_name, b.developmental_defect_grouping_general) && _lodash2.default.isEqual(a.source_name, b.developmental_defect_grouping_granular);
                    });
                });
                return result;
            },
                joinDataFun = function joinDataFun(dataA, dataB) {
                var result = _lodash2.default.map(dataA, function (itemA) {
                    var matchedItem = _lodash2.default.find(dataB, { node_name: itemA.source_name });
                    if (matchedItem) {
                        return _lodash2.default.assign({}, itemA, matchedItem);
                    }
                    return itemA;
                });
                return result;
            },
                valueCountsFun = function valueCountsFun(data) {
                data.forEach(function (i) {
                    var count = data.filter(function (item) {
                        return item.target_id === i.source_id;
                    }).length;
                    i.value = count > 0 ? count : 1;
                });
                return data;
            };

            plotData = filterDataFun(flowsData, ontology);
            plotData = joinDataFun(plotData, nodesData);
            plotData = valueCountsFun(plotData);
            //console.log(plotData)

            this.renderPlot(plotData, nodesData);
        }
    }, {
        key: 'renderPlot',
        value: function renderPlot(links, nodes) {
            var _this3 = this;

            // console.log(links, nodes)
            //
            // if (this.refs[d.key] === undefined) {
            //     return;
            // }
            var ontologyType = this.props.cells.ontologyType == _shared.integrative_Granular ? 'granular' : 'general';
            var getStyledLabel = function getStyledLabel(node_name, node_level) {
                var style = {
                    'font-weight': 'bold',
                    'font-size': '15px',
                    'text-shadow': 'none',
                    color: node_name === _this3.props.cells.ontologyGroupName && node_level === ontologyType ? 'red' : 'inherit'
                };

                var styleString = Object.entries(style).map(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        key = _ref2[0],
                        value = _ref2[1];

                    return key + ': ' + value;
                }).join(';');
                return '<span style=\'' + styleString + '\'>' + node_name + '</span>';
            };

            var getNodeLevelLabel = function getNodeLevelLabel(node_level) {
                var style = {
                    'font-weight': 'bold',
                    'font-size': '15px',
                    'text-shadow': 'none'
                };
                var contentMap = {
                    recording: 'Laboratory Specific Recording Term:',
                    term: 'Phenotype Ontology Term:',
                    granular: 'Granular Phenotype Term:',
                    general: 'General Phenotype Term:'
                };

                var content = contentMap[node_level] || '';
                var styleString = Object.entries(style).map(function (_ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2),
                        key = _ref4[0],
                        value = _ref4[1];

                    return key + ': ' + value;
                }).join(';');
                return '<span style=\'' + styleString + '\'>' + content + '</span>';
            };

            var fig = {
                node_name: nodes.map(function (item) {
                    return getStyledLabel(item.node_name, item.node_level);
                }),
                node_hovertext: nodes.map(function (item) {
                    return getNodeLevelLabel(item.node_level);
                }),
                node_color: nodes.map(function (item) {
                    return item.node_color;
                }),
                source_id: links.map(function (item) {
                    return parseInt(item.source_id);
                }),
                target_id: links.map(function (item) {
                    return parseInt(item.target_id);
                }),
                source_name: links.map(function (item) {
                    return item.source_name;
                }),
                target_name: links.map(function (item) {
                    return item.target_name;
                }),
                value: links.map(function (item) {
                    return item.value;
                }),
                flow_color: links.map(function (item) {
                    return item.flow_color;
                })
            };

            var data = {
                type: 'sankey',
                orientation: 'h', // Horizontal orientation
                node: {
                    pad: 15,
                    thickness: 20,
                    line: {
                        color: 'black',
                        width: 0.5
                    },
                    label: fig.node_name,
                    color: fig.node_color,
                    customdata: fig.node_hovertext,
                    hovertemplate: '%{customdata}<br />%{label}'
                },

                link: {
                    source: fig.source_id,
                    target: fig.target_id,
                    color: fig.flow_color,
                    value: fig.value
                }
            };
            // Define the layout options for the Sankey plot
            var layout = {
                // title: ` Sankey Diagram of <span style='color: red;font-weight: bold;'>${this.props.cells.ontologyGroupName}</span>`,
                // i use width to be 2400 to avoid node label overlapping.
                autosize: true,
                font: {
                    size: 20
                },
                hoverlabel: {
                    font: {
                        size: 20
                    }
                }
            };

            // Now filteredNodes contains only the nodes relevant to your link data
            _plotly2.default.newPlot('SankeyPlot', [data], layout);
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'Relationship of zebrafish developmental phenotype terminologies starting with the laboratory specific reporting term, Zebrafish Phenotype ontology, granular and general developmental phenotype terms.'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    'The numbers included in the hover over boxes indicate the number of ontology terms associated with the altered phenotype. Red text indicates the final phenotype selected under Select developmental phenotype group.'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    'Background color refers to the hierarchical relationship of all zebrafish phenotype ontologies included in both DRF and Def studies and are described on the datasets page.'
                )
            );
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            // loadSankeydata(this);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchSankeyData();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _plotly2.default.purge('SankeyPlot');
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.error) {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert alert-warning' },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            this.state.error
                        )
                    )
                );
            }

            var colNum = Math.ceil(12 / this.props.cols);
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    { className: 'label-horizontal' },
                    '\xA0\xA0\xA0 Sankey Diagram',
                    _react2.default.createElement(_HelpButtonWidget2.default, {
                        stateHolder: this,
                        headLevel: 'h2',
                        title: 'More information on ontology and phenotype terms'
                    })
                ),
                this._renderHelpText(),
                _react2.default.createElement('br', null),
                _react2.default.createElement('div', { className: 'row  ', id: 'SankeyPlot' })
            );
        }
    }]);

    return SankeyPlot;
}(_react2.default.Component);

SankeyPlot.propTypes = {
    cells: _propTypes2.default.array.isRequired
};

exports.default = SankeyPlot;

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _reactDom = __webpack_require__(51);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _DoseResponse = __webpack_require__(176);

var _DoseResponse2 = _interopRequireDefault(_DoseResponse);

var _shared = __webpack_require__(11);

var _BootstrapModal = __webpack_require__(130);

var _BootstrapModal2 = _interopRequireDefault(_BootstrapModal);

var _BootstrapBodyPart = __webpack_require__(129);

var _RankedBarchartHandler = __webpack_require__(274);

var _RankedBarchartHandler2 = _interopRequireDefault(_RankedBarchartHandler);

var _d2 = __webpack_require__(275);

var _object = __webpack_require__(1120);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var renderPlot = function renderPlot(el, data, opts) {
    // stateless; outside react component
    // clear div if non-empty
    (0, _$2.default)(el).empty();
    //
    if (data.length === 0) {
        (0, _$2.default)(el).append('<div class="alert alert-info"><p>No BMC data are available.</p></div>');
        return;
    }
    var nonviabilityData = void 0,
        viabilityData = void 0;

    nonviabilityData = _lodash2.default.chain(data).map('minimimumNonViability').filter(function (d) {
        return d.med_pod_med !== null;
    }).compact().value();

    viabilityData = _lodash2.default.chain(data).map('minimimumViability').filter(function (d) {
        return d.mort_med_pod_med !== null;
    }).compact().value();

    // console.log("data", data)
    // console.log("nonviabilityData", nonviabilityData)
    // console.log("viabilityData", viabilityData)

    // viabilityData is black dot, NonviabilityData is colored dots.
    //console.log('data2', data, nonviabilityData, viabilityData);
    // set dimensions and margins
    var elWidth = Math.max(Math.floor((0, _$2.default)(el).innerWidth()), 800),
        margin = { top: 40, right: 100, bottom: 50, left: 300, footnote: 200 },
        width = elWidth - margin.left - margin.right,
        height = data.length * 20 - margin.top - margin.bottom + margin.footnote,
        footnoteHeight = 50,
        categoryWidth = 150,
        categoryPadding = 5,
        barStart = categoryWidth + categoryPadding * 2;
    // console.log(height)
    // console.log( height + margin.top + margin.bottom)
    //
    // console.log(height + margin.top - margin.bottom)

    var xScaleFunction = d3.scaleLog;

    //set the ranges
    var extent = d3.extent(_lodash2.default.compact(_lodash2.default.flattenDeep([_lodash2.default.map(nonviabilityData, function (d) {
        return [(0, _shared.pod_med_processed)(d.med_pod_med), (0, _shared.pod_med_processed)(d.min_pod_med), (0, _shared.pod_med_processed)(d.max_pod_med)];
    }), _lodash2.default.map(viabilityData, function (d) {
        return [(0, _shared.pod_med_processed)(d.mort_med_pod_med), (0, _shared.pod_med_processed)(d.mort_min_pod_med), (0, _shared.pod_med_processed)(d.mort_max_pod_med)];
    })]))),
        x = xScaleFunction().range([1, width - barStart]) // use 1 instead of 0 so there's a bar to click on
    .domain(extent).clamp(true),
        y = d3.scaleBand().range([0, height]).padding(0.1).domain(data.map(function (d) {
        return d.preferred_name;
    }));

    //
    // append plot
    var svg = d3.select(el).append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    var barG = svg.append('g').attr('transform', 'translate(' + barStart + ',0)');

    if (opts.isSelective) {
        // add mort_pod_med circle, color bar and dot.
        // console.log(nonviabilityData)
        barG.selectAll('.pod-circle').data(nonviabilityData).enter().append('circle').attr('class', 'pod-circle')
        // .attr('cx', (d) => x(pod_med_processed(d.med_pod_med)))
        .attr('cx', function (d) {
            return x((0, _shared.pod_med_processed)(d.mean_pod));
        }).attr('cy', function (d) {
            return y(d.preferred_name) + y.bandwidth() / 2;
        }).attr('r', 10).style('fill', function (d) {
            return _shared.CATEGORY_COLORS[d.use_category1];
        }).style('cursor', 'pointer').on('click', function (d) {
            (0, _shared.BMCHandleCellClick)(d, 'nonviabilityData');
        });
    } else {
        barG.selectAll('.pod-errorbar').data(nonviabilityData).enter().append('line').attr('class', 'pod-errorbar').attr('x1', function (d) {
            return x(d3.min([(0, _shared.pod_med_processed)(d.min_pod_med), (0, _shared.pod_med_processed)(d.med_pod_med)]));
        }).attr('x2', function (d) {
            return x(d3.max([(0, _shared.pod_med_processed)(d.med_pod_med), (0, _shared.pod_med_processed)(d.max_pod_med)]));
        }).attr('y1', function (d) {
            return y(d.preferred_name) + y.bandwidth() / 2;
        }).attr('y2', function (d) {
            return y(d.preferred_name) + y.bandwidth() / 2;
        }).style('stroke', function (d) {
            return _shared.CATEGORY_COLORS[d.use_category1];
        }).style('stroke-width', 8).style('pointer-events', 'none');

        // add mort_pod_med circle, color bar and dot.

        barG.selectAll('.pod-circle').data(nonviabilityData).enter().append('circle').attr('class', 'pod-circle').attr('cx', function (d) {
            return x((0, _shared.pod_med_processed)(d.med_pod_med));
        }).attr('cy', function (d) {
            return y(d.preferred_name) + y.bandwidth() / 2;
        }).attr('r', 10).style('fill', function (d) {
            return _shared.CATEGORY_COLORS[d.use_category1];
        }).style('cursor', 'pointer').on('click', function (d) {
            (0, _shared.BMCHandleCellClick)(d, 'nonviabilityData');
        });
    }
    // add pod_med error bars

    // add viabilityData error bars
    barG.selectAll('.mort_pod-errorbar').data(viabilityData).enter().append('line').attr('class', 'mort_pod-errorbar').attr('x1', function (d) {
        return x(d3.min([(0, _shared.pod_med_processed)(d.mort_min_pod_med), (0, _shared.pod_med_processed)(d.mort_med_pod_med)]));
    }).attr('x2', function (d) {
        return x(d3.max([(0, _shared.pod_med_processed)(d.mort_med_pod_med), (0, _shared.pod_med_processed)(d.mort_max_pod_med)]));
    }).attr('y1', function (d) {
        return y(d.preferred_name) + y.bandwidth() / 2;
    }).attr('y2', function (d) {
        return y(d.preferred_name) + y.bandwidth() / 2;
    }).style('stroke', 'black').style('stroke-width', 4).style('stroke-dasharray', '4, 2').style('pointer-events', 'none').style('opacity', 0.8);

    // add viabilityData circle
    barG.selectAll('.mort_pod-circle').data(viabilityData).enter().append('circle').attr('class', 'mort_pod-circle').attr('cx', function (d) {
        return x((0, _shared.pod_med_processed)(d.mort_med_pod_med));
    }).attr('cy', function (d) {
        return y(d.preferred_name) + y.bandwidth() / 2;
    }).attr('r', 7).style('fill', 'black').style('opacity', 0.8).style('cursor', 'pointer').on('click', function (d) {
        (0, _shared.BMCHandleCellClick)(d, 'viabilityData');
    });

    // add selectivity-ratio text
    if (opts.isSelective) {
        // axis label
        svg.append('text').attr('x', elWidth - margin.right - margin.left + 10).attr('y', -8).style('font-weight', 'bold').style('font-family', 'sans-serif').text('Specificity');

        svg.selectAll('.selectivity-text').data(nonviabilityData).enter().append('text').attr('x', elWidth - margin.right - margin.left + 24).attr('y', function (d) {
            return y(d.preferred_name) + y.bandwidth() / 2;
        }).attr('dy', '0.35em').style('font-family', 'sans-serif').text(function (d) {
            return d.med_mort_hit_confidence < 0.5 ? '\u2265 ' + (0, _shared.printFloat)(d.mean_selectivity) : (0, _shared.printFloat)(d.mean_selectivity);
        }).each(function (d) {
            if (d.med_mort_hit_confidence < 0.5) {
                // add footnote; adjust text so that numbers are aligned
                d3.select(this).attr('x', elWidth - margin.right - margin.left + 10).append('tspan').text('†').attr('baseline-shift', 'super').attr('font-size', '0.7em');
            }
        });
        var SELECTIVITY_FOOTNOTE = 'Specificity is estimated and true value may be higher; mortality BMC could not be calculated and was therefore estimated to equal the maximum tested dose.';
        // add footnote
        svg.append('text').attr('x', -margin.left + 10).attr('y', height + margin.top - margin.bottom + footnoteHeight)
        // .attr('y', height + margin.top - margin.bottom + 10)
        .attr('font-size', '1.3em').style('font-family', 'sans-serif').text('\u2020 ' + SELECTIVITY_FOOTNOTE);
    }

    // append category ids
    svg.selectAll('.category').data(data).enter().append('rect').attr('class', 'category').attr('x', categoryPadding).attr('width', categoryWidth).attr('y', function (d) {
        return y(d.preferred_name);
    }).attr('height', y.bandwidth()).style('fill', function (d) {
        return _shared.CATEGORY_COLORS[d.use_category1];
    });

    // append category label
    svg.selectAll('.category-text').data(data).enter().append('text').attr('x', categoryPadding + 2).attr('y', function (d) {
        return y(d.preferred_name) + y.bandwidth() / 2;
    }).attr('dy', '0.35em')
    // .attr('dy', '0.5em')
    .text(function (d) {
        return d.use_category1;
    }).style('fill', 'white');

    // add axes
    // svg.append('g').call(d3.axisLeft(y));
    // add axes
    svg.append('g').call(d3.axisLeft(y)).selectAll('text') // Select all text elements within the y-axis
    .style('font-size', '16px'); // Adjust the font size as needed

    var axisFn = opts.selectedAxis === _shared.AXIS_LOG10 ? (0, _d2.getLog10AxisFunction)(d3.axisTop, x) : d3.axisTop(x);

    barG.append('g').call(axisFn);

    // axis label
    barG.append('text').attr('transform', 'translate(' + (width - barStart) / 2 + ', -25)').style('text-anchor', 'middle').text('Benchmark concentration value (BMC) (µM)');

    // add legend
    var barLegend = svg.append('g').data([{ x: 10, y: -23 }]).attr('transform', 'translate(10, -23)').call(d3.drag().on('drag', function (d) {
        d.x += d3.event.dx;
        d.y += d3.event.dy;
        d3.select(this).attr('transform', 'translate(' + d.x + ',' + d.y + ')');
    }));

    barLegend.append('rect').attr('x', 0).attr('width', 140).attr('y', -15).attr('height', 35).style('fill', 'white').style('stroke', 'black').style('stroke-width', '2px').style('cursor', 'pointer').attr('title', 'Drag to reposition');

    var colors = _lodash2.default.values(_shared.CATEGORY_COLORS);

    barLegend.selectAll('.__').data([{ y: -8, sw: 4, da: '10, 0', color: colors[0] }, { y: -2, sw: 4, da: '10, 0', color: colors[9] }, { y: 10, sw: 3, da: '4, 2', color: 'black' }]).enter().append('line').attr('x1', 2).attr('x2', 36).attr('y1', function (d) {
        return d.y;
    }).attr('y2', function (d) {
        return d.y;
    }).style('stroke', function (d) {
        return d.color;
    }).style('stroke-width', function (d) {
        return d.sw;
    }).style('stroke-dasharray', function (d) {
        return d.da;
    }).style('opacity', 0.75);

    barLegend.selectAll('.__').data([{ x: 12, r: 7, y: -8, color: colors[0] }, { x: 25, r: 7, y: -2, color: colors[9] }, { x: 20, r: 5, y: 10, color: 'black' }]).enter().append('circle').attr('cx', function (d) {
        return d.x;
    }).attr('cy', function (d) {
        return d.y;
    }).attr('r', function (d) {
        return d.r;
    }).style('fill', function (d) {
        return d.color;
    }).style('opacity', 0.75);

    barLegend.append('text').attr('x', 38).attr('y', 0).text('non-mortality');

    barLegend.append('text').attr('x', 38).attr('y', 15).text('mortality');
};

var RankedBarChart = function (_React$Component) {
    _inherits(RankedBarChart, _React$Component);

    function RankedBarChart(props) {
        _classCallCheck(this, RankedBarChart);

        return _possibleConstructorReturn(this, (RankedBarChart.__proto__ || Object.getPrototypeOf(RankedBarChart)).call(this, props));
    }

    _createClass(RankedBarChart, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._renderPlot(this.props);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            this._renderPlot(nextProps);
            return false;
        }
    }, {
        key: '_renderPlot',
        value: function _renderPlot(props) {
            renderPlot(this.refs.bmd_svg, props.data, {
                isSelective: props.visualization === _shared.BMDVIZ_SELECTIVITY,
                selectedAxis: props.selectedAxis,
                selectivityList: props.selectivityList === _shared.BMDVIZ_SELECTIVITY
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', { id: 'BMC_heatmap01', ref: 'bmd_svg' });
        }
    }]);

    return RankedBarChart;
}(_react2.default.Component);

exports.default = RankedBarChart;

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(503);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _Loading = __webpack_require__(86);

var _Loading2 = _interopRequireDefault(_Loading);

var _Heatmap = __webpack_require__(507);

var _Heatmap2 = _interopRequireDefault(_Heatmap);

var _DevtoxHeatmap = __webpack_require__(508);

var _DevtoxHeatmap2 = _interopRequireDefault(_DevtoxHeatmap);

var _shared = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import Popup from 'reactjs-popup';


var HeatmapHandler = function (_React$Component) {
    _inherits(HeatmapHandler, _React$Component);

    function HeatmapHandler(props) {
        _classCallCheck(this, HeatmapHandler);

        var _this = _possibleConstructorReturn(this, (HeatmapHandler.__proto__ || Object.getPrototypeOf(HeatmapHandler)).call(this, props));

        _this.state = {
            data: null,
            scale: null,
            continuousColorScale: null,
            open: false,
            INTVIZ_HEATMAP_COLORS: [{
                key: 'dev tox',
                label: 'specific',
                fill: '#d62976'
            }, {
                key: 'general tox',
                label: 'non-specific',
                fill: '#f9d70b'
            }, {
                key: 'inconclusive',
                label: ' inconclusive, more tests are needed',
                fill: '#3BD6C6'
            }, {
                key: 'inactive',
                label: 'non-toxic ',
                fill: '#FFFFFF'
            }, {
                key: 'default',
                label: 'not evaluated',
                fill: '#C9C9C9'
            }],
            DEVTOX_HEATMAP_COLORS: [{
                key: 'dev tox',
                label: 'specific',
                fill: '#FFFFFF'
            }, {
                key: 'general tox',
                label: 'non-specific, non-toxic, inconclusive',

                fill: '#FFFFFF'
            }, {
                key: 'inconclusive',
                label: 'non-specific, non-toxic, inconclusive',

                fill: '#FFFFFF'
            }, {
                key: 'inactive',
                label: 'non-specific, non-toxic, inconclusive',
                fill: '#FFFFFF'
            }, {
                key: 'default',
                label: 'not evaluated',
                fill: '#C9C9C9'
            }]
        };
        return _this;
    }

    _createClass(HeatmapHandler, [{
        key: 'fetchIntegrativeData',
        value: function fetchIntegrativeData(url) {
            var _this2 = this;

            //console.log(url);
            d3.json(url, function (error, data) {
                if (error) {
                    var err = error.target.responseText.replace('["', '').replace('"]', '');
                    _this2.setState({
                        data: [],
                        error: err
                    });
                    return;
                }
                var domain = [1e-3, 1e3],
                    scale = d3.scaleLog().domain(domain).range([1, 0]),
                    continuousColorScale = function continuousColorScale(d) {
                    // console.log('d  and scale(d)')
                    // console.log(d)
                    // console.log(scale(d));
                    // console.log(d3.interpolateViridis(scale(d)));
                    return d3.interpolateViridis(scale(d));
                };
                //console.log("first render data", data)
                _this2.setState({
                    data: data,
                    scale: scale,
                    continuousColorScale: continuousColorScale
                });
            });
        }
    }, {
        key: '_getFilteredData',
        value: function _getFilteredData() {
            var getFillFunction = function getFillFunction(visualization, continuousColorScale, colorCategory) {
                switch (visualization) {
                    case _shared.INTVIZ_HEATMAP:
                        return function (data) {
                            var color;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = colorCategory[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var i = _step.value;

                                    if (data.final_dev_call === i['key']) {
                                        color = i['fill'];
                                        return color;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        };
                    case _shared.INTVIZ_DevtoxHEATMAP:
                        return function (data) {
                            switch (data.final_dev_call) {
                                // case 'dev tox':
                                //     return data.mean_pod
                                //         ? continuousColorScale(pod_med_processed(data.mean_pod))
                                //         : 'red';
                                case 'dev tox':
                                    return '#FFFFFF';
                                case 'general tox':
                                    return '#FFFFFF';
                                case 'inconclusive':
                                    return '#FFFFFF';
                                case 'inactive':
                                    return '#FFFFFF';
                                default:
                                    return '#FFFFFF';
                            }
                        };
                    default:
                        throw 'Unknown display type.';
                }
            };
            var getLegendData = function getLegendData(visualization, scale, colorScale, colorCategory) {
                switch (visualization) {
                    case _shared.INTVIZ_HEATMAP:
                        return {
                            values: colorCategory
                        };

                    // HEATMAP_BMC type is continuous, search that.
                    case _shared.INTVIZ_DevtoxHEATMAP:
                        return {
                            legendScale: scale,
                            values: colorCategory,
                            colorScaleFunction: colorScale
                        };
                    default:
                        throw 'Unknown display type.';
                }
            };

            var fillFunction = getFillFunction(this.props.visualization, this.state.continuousColorScale, this.state.INTVIZ_HEATMAP_COLORS),
                legendData = getLegendData(this.props.visualization, this.state.scale, this.state.continuousColorScale, this.state.INTVIZ_HEATMAP_COLORS);
            var data = this.state.data.integrative_activity_selectivity,
                ontologyGroup = this.props.ontologyGroup,
                ontologyType = this.props.ontologyType,
                labDataset = this.props.labDataset,
                selectivityOrder = ['dev tox', 'general tox', 'inconclusive', 'inactive'],
                ontologyGroupType = ontologyType === _shared.integrative_Granular ? 'developmental_defect_grouping_granular' : 'developmental_defect_grouping_general';
            //console.log('before plot')
            //console.log(this.props)
            //console.log(data)
            //console.log(ontologyGroup)
            //console.log(ontologyGroupType)
            // const a = _.uniq(_.map(data, 'developmental_defect_grouping_granular'));
            // const b = _.uniq(_.map(data, 'developmental_defect_grouping_general'));
            //
            // console.log('developmental_defect_grouping_general', b)
            // console.log('developmental_defect_grouping_granular', a)

            function transformDataItem(d, ontologyGroupType) {
                return _extends({}, d, {
                    x: d[ontologyGroupType] + ': ' + d.protocol_name_plot,
                    y: d.preferred_name,
                    ontologyGroupName: d[ontologyGroupType],
                    title: d[ontologyGroupType] + '+' + d.protocol_name_plot + '+' + d.preferred_name
                });
            }

            function createXGroups(ontologyGroup, labDataset) {
                return _lodash2.default.uniqBy(ontologyGroup.flatMap(function (k) {
                    return labDataset.map(function (item) {
                        return _extends({
                            x: k + ': ' + item.protocol_name_plot,
                            ontologyGroupName: k
                        }, item);
                    } // Include the rest of the data from labDataset
                    );
                }), 'x');
            }

            function createYGroups(data) {
                //console.log(data)
                return _lodash2.default.chain(data).map(function (item) {
                    return {
                        casrn: item.casrn,
                        dtxsid: item.dtxsid,
                        preferred_name: item.preferred_name,
                        use_category1: item.use_category1,
                        y: item.y
                    };
                }).uniqBy('y') // Assuming you want unique combinations of x, y, z
                .value();
            }

            function processHeatmapDataItem(result, selectivityOrder, sortByKey, fillFunction) {
                var endpoints = _lodash2.default.chain(result).map('endpoint_name').uniq().value();

                var devtoxEndpoints = _lodash2.default.chain(result).filter(function (i) {
                    return i.final_dev_call === 'dev tox';
                }).map('endpoint_name').uniq().value();

                var topFinal = _lodash2.default.chain(result).map('final_dev_call').uniq().filter(function (d) {
                    return _lodash2.default.includes(selectivityOrder, d);
                }).sort(function (a, b) {
                    return selectivityOrder.indexOf(a) - selectivityOrder.indexOf(b);
                }).first().value();

                var processedItem = _lodash2.default.chain(result).filter(function (i) {
                    return i.final_dev_call === topFinal;
                }).sortBy(sortByKey).first().value();

                processedItem.fill = fillFunction(processedItem);
                processedItem.endPointList = endpoints;
                processedItem.devtoxEndPointList = devtoxEndpoints;
                return processedItem;
            }

            function processHeatmapData(data, xgroups, ygroups, fillFunction, selectivityOrder, sortByKey) {
                var processedData = [];

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = xgroups[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var xItem = _step2.value;

                        var x = xItem.x;
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = ygroups[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var yItem = _step3.value;

                                var y = yItem.y;
                                var result = _lodash2.default.filter(data, { x: x, y: y });
                                if (result.length === 0) {
                                    processedData.push(_extends({}, yItem, xItem, {
                                        fill: '#C9C9C9'
                                    }));
                                } else {
                                    // //console.log(result)

                                    var processedItem = processHeatmapDataItem(result, selectivityOrder, sortByKey, fillFunction);
                                    // //console.log(processedItem)
                                    processedData.push(processedItem);
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return processedData;
            }

            // Main code

            data = _lodash2.default.chain(data).filter(function (item) {
                return ontologyGroup.includes(item[ontologyGroupType]);
            }).map(function (d) {
                return transformDataItem(d, ontologyGroupType);
            }).sortBy('med_pod_med').value();

            var xgroups = createXGroups(ontologyGroup, labDataset);
            var ygroups = createYGroups(data);
            // console.log(data, xgroups, ygroups)
            switch (this.props.visualization) {
                case _shared.INTVIZ_HEATMAP:
                    return {
                        data: processHeatmapData(data, xgroups, ygroups, fillFunction, selectivityOrder, 'mean_pod'),
                        legendData: legendData
                    };
                case _shared.INTVIZ_DevtoxHEATMAP:
                    return {
                        data: processHeatmapData(data, xgroups, ygroups, fillFunction, selectivityOrder, 'mean_pod'),
                        legendData: legendData
                    };
                default:
                    throw 'Error: Unknown display type.';
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchIntegrativeData(this.props.url);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.url !== this.props.url) {
                this.setState({ data: null }); // Reset data to trigger loading state

                this.fetchIntegrativeData(this.props.url);
            }
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }
            if (this.props.visualization === _shared.INTVIZ_HEATMAP) {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert alert-info' },
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'specific = a test substance produces quantifiable alteration(s) in phenotypes at a concentration lower than that which causes overt toxicity (i.e., mortality)'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'non-specific = a test substance produces both altered phenotypes and mortality at similar concentrations'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'non-toxic = no changes to phenotype or survival occurred at the concentrations evaluated'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'inconclusive = specificity couldn\u2019t be determined based on differences among plate replicates and requires more testing'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'not evaluated = a phenotype that was not assessed in a particular laboratory'
                        )
                    )
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    { className: 'alert alert-info' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'Benchmark concentration (BMC) of a selected endpoint is indicative of potency; darker shades indicative lower BMC value which is a more potent effect. Specificity is the fold change of the BMC values between the mortality and a certain altered phenotype. The fold change value is log10-transformed; higher specificity represents a more specific phenotypic effect compared to mortality. The higher the specificity, the larger the circle.'
                    )
                );
            }
        }
    }, {
        key: '_renderButtons',
        value: function _renderButtons(d) {
            // //console.log(d.data);
            var title = this.props.visualization === _shared.INTVIZ_HEATMAP ? 'More information on developmental toxicity classifications' : 'More information on BMC and specificity';

            var svgId = this.props.visualization === _shared.INTVIZ_HEATMAP ? 'IA_heatmap01' : 'IA_heatmap02';
            var csvfileName = 'IntegrativeAnalysesData.csv';
            var csvfileHeader = [{
                title: 'dataset name (long)',
                key: 'protocol_name_long'
            }, {
                title: 'dataset name (short)',
                key: 'protocol_name_plot'
            }, {
                title: 'dtxsid',
                key: 'dtxsid'
            }, {
                title: 'casrn',
                key: 'casrn'
            }, {
                title: 'test substance',
                key: 'preferred_name'
            }, {
                title: 'use category',
                key: 'use_category1'
            }, {
                title: 'selected phenotype term',
                key: 'ontologyGroupName'
            }, {
                title: 'n endpoints in selected phenotype term',
                key: 'endPointList',
                method: 'length'
            }, {
                title: 'n endpoints specific in selected phenotype term',
                key: 'devtoxEndPointList',
                method: 'length'
            }, {
                title: 'phenotype term bmc (microM)',
                key: 'mean_pod',
                method: 'processMedPodMed'
            }, {
                title: 'developmental toxicity classification',
                key: 'final_dev_call',
                method: 'map'
            }, {
                title: 'mortality bmc (microM)',
                key: 'mort_med_pod_med',
                method: 'processMedPodMed'
            }, {
                title: 'specificity',
                key: 'mean_selectivity'
            }, {
                title: 'lowest tested conc (microM)',
                method: 'processMedPodMed',
                key: 'min_lowest_conc'
            }, {
                title: 'highest tested conc (microM)',
                method: 'processMedPodMed',
                key: 'max_highest_conc'
            }];
            //console.log(d.data)
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    { className: 'label-horizontal label-normal' },
                    'Developmental Toxicity Heatmap',
                    ' ',
                    _react2.default.createElement(_HelpButtonWidget2.default, { stateHolder: this, headLevel: 'h2', title: title })
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'h4',
                        { className: 'label-normal' },
                        _react2.default.createElement('button', {
                            onClick: function onClick() {
                                return (0, _shared.exportCsv)(d.data, csvfileName, csvfileHeader);
                            },
                            className: 'fa fa-download pointer-button'
                        }),
                        _react2.default.createElement(
                            'span',
                            null,
                            ' Data'
                        ),
                        '\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0',
                        _react2.default.createElement('button', {
                            onClick: function onClick() {
                                return (0, _shared.svg_download_form)(svgId);
                            },
                            className: 'fa fa-camera pointer-button'
                        }),
                        _react2.default.createElement(
                            'span',
                            null,
                            ' Image'
                        )
                    )
                )
            );
        }
    }, {
        key: '_renderMain',
        value: function _renderMain(d) {
            // //console.log(this.props);

            if (this.props.visualization === _shared.INTVIZ_HEATMAP) {
                //console.log("heatmap", d.data)
                return _react2.default.createElement(_Heatmap2.default, {
                    data: d.data,
                    legendData: d.legendData,
                    ontologyType: this.props.ontologyType
                });
            } else {
                return _react2.default.createElement(_DevtoxHeatmap2.default, {
                    data: d.data,
                    legendData: d.legendData,
                    ontologyType: this.props.ontologyType
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.data) {
                return _react2.default.createElement(_Loading2.default, null);
            }
            var d = void 0;
            d = this._getFilteredData();
            // this is res, ult, with color name is fill data.
            if (d.data.length === 0) {
                return (0, _shared.renderNoDataAlert)();
            }

            return _react2.default.createElement(
                'div',
                null,
                this._renderButtons(d),
                this._renderHelpText(),
                this._renderMain(d)
            );
        }
    }]);

    return HeatmapHandler;
}(_react2.default.Component);

HeatmapHandler.propTypes = {
    assays: _propTypes2.default.array.isRequired,
    casrns: _propTypes2.default.array.isRequired,
    ontologyType: _propTypes2.default.number.isRequired,
    ontologyGroup: _propTypes2.default.array.isRequired,
    visualization: _propTypes2.default.number.isRequired,
    url: _propTypes2.default.string.isRequired,
    labDataset: _propTypes2.default.array.isRequired
};

exports.default = HeatmapHandler;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _Tooltip = __webpack_require__(169);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _BootstrapModal = __webpack_require__(130);

var _BootstrapModal2 = _interopRequireDefault(_BootstrapModal);

var _BootstrapBodyPart = __webpack_require__(129);

var _shared = __webpack_require__(11);

var _d2 = __webpack_require__(275);

var _DoseResponse = __webpack_require__(176);

var _DoseResponse2 = _interopRequireDefault(_DoseResponse);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Heatmap = function (_Component) {
    _inherits(Heatmap, _Component);

    function Heatmap(props) {
        _classCallCheck(this, Heatmap);

        var _this = _possibleConstructorReturn(this, (Heatmap.__proto__ || Object.getPrototypeOf(Heatmap)).call(this, props));

        _this.renderPlot = function (el, data, legendData) {
            (0, _$2.default)(el).empty();
            var margin = {
                top: 40,
                left: 10,
                bottom: 40,
                right: 40,
                axisLeft: 290,
                axisTop: 300,
                legend: 900
            },
                cellSize = 50,
                xMap = _lodash2.default.groupBy(data, 'x'),
                yMap = _lodash2.default.groupBy(data, 'y'),
                ontologyType = this.props.ontologyType,
                handleXLabelClick = function handleXLabelClick(label) {
                // console.log(label);
                var cells = xMap[label];
                var cell = {
                    developmental_defect_grouping_general: cells[0].developmental_defect_grouping_general,
                    ontologyGroupName: cells[0].ontologyGroupName,
                    protocol_source: cells[0].protocol_source,
                    ontologyType: ontologyType
                };
                if (cell.developmental_defect_grouping_general && cell.protocol_source) {
                    new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.sankeyPlotGraphBody, {
                        title: label.replace(/:/g, ' +'),
                        cells: cell
                    });
                }
            },

            // draw y-axis
            handleYLabelClick = function handleYLabelClick(label) {
                // console.log(label);

                var cells = yMap[label],
                    casrns = [].concat(_toConsumableArray(new Set(cells.map(function (item) {
                    return item.casrn;
                })))),
                    dtxsids = [].concat(_toConsumableArray(new Set(cells.map(function (item) {
                    return item.dtxsid;
                }))));

                new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.molecularGraphBody, {
                    title: dtxsids[0] + ' // ' + label + ' //  molecularGraph  ZWTBD',
                    dtxsid: dtxsids[0]
                });
            },
                mouseover = function mouseover(d) {
                tooltip.style('opacity', 1);
            },
                mousemove = function mousemove(d) {
                if (d.endPointList) {
                    tooltip.html('<span style="font-size: 15px; font-weight: bold;">\n                    ' + d.devtoxEndPointList.length + ' out of ' + d.endPointList.length + ' endpoints are significant\n                </span>').style('left', d3.event.pageX - 200 + 'px').style('top', d3.event.pageY - 30 + 'px').style('opacity', 1.0);
                }
            },
                mouseleave = function mouseleave(d) {
                tooltip.style('opacity', 0);
            },

            // xasix is column, yasix is row
            xasix = d3.map(data, function (d) {
                return d.x;
            }).keys().sort(),
                yasix = d3.map(data, function (d) {
                return d.y;
            }).keys().sort(),
                width = xasix.length * cellSize + margin.axisLeft + margin.left + margin.right + margin.legend,
                height = yasix.length * cellSize + margin.axisTop + margin.top + margin.bottom,
                chartHeight = height - (margin.top + margin.bottom + margin.axisTop),
                chartWidth = width - (margin.left + margin.right + margin.axisLeft + margin.legend),

            // how we get this 900,  check cellSize = 30.  30*30 = 900.
            square = d3.symbol().type(d3.symbolSquare).size(cellSize * cellSize),

            // Create the svg area

            svg = d3.select(el).append('svg').attr('width', Math.max(1000, width + margin.left + margin.right)).attr('height', Math.max(1000, height + margin.left + margin.right)).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
                tooltip = d3.select(el).append('div').attr('class', 'tooltip').style('opacity', 0.0);

            // addStripMask(svg);

            var axisLayer = svg.append('g').classed('axisLayer', true).attr('width', width).attr('height', height);

            // draw xy-axis
            var xScale = d3.scaleBand().domain(xasix).range([0, chartWidth]);
            var yScale = d3.scaleBand().domain(yasix).range([0, chartHeight]);

            var xAxis = d3.axisTop(xScale).tickSizeOuter(0);
            var yAxis = d3.axisLeft(yScale).tickSizeOuter(0);

            axisLayer.append('g').attr('transform', 'translate(' + (margin.left + margin.axisLeft) + ', ' + (margin.top + margin.axisTop) + ')').attr('class', 'axis y').call(yAxis).style('font-size', 15).selectAll('text');
            // .style('cursor', 'pointer')
            // .on('click', handleYLabelClick)

            axisLayer.append('g').attr('transform', 'translate(' + (margin.left + margin.axisLeft) + ', ' + (margin.top + margin.axisTop) + ')').attr('class', 'axis x').call(xAxis).style('font-size', 15).selectAll('text').attr('dx', '.8em').attr('dy', '.55em').attr('transform', 'rotate(-65)').style('text-anchor', 'start').style('cursor', 'pointer').on('click', handleXLabelClick);

            var chartLayer = svg.append('g').classed('chartLayer', true).attr('width', chartWidth).attr('height', chartHeight).attr('transform', 'translate(' + (margin.left + margin.axisLeft) + ', ' + (margin.top + margin.axisTop) + ')');

            chartLayer.append('rect').attr('x', xScale.range()[0]).attr('y', yScale.range()[0]).attr('width', xScale.range()[1]).attr('height', yScale.range()[1]).attr('fill', 'transparent').style('stroke', 'black').style('stroke-width', 2);

            chartLayer.selectAll('.square').data(data).enter().append('path').attr('class', 'square').attr('d', square).attr('fill', function (d) {
                return d.fill;
            }).attr('transform', function (d) {
                return 'translate(' + (xScale(d.x) + xScale.bandwidth() / 2) + ', ' + (yScale(d.y) + yScale.bandwidth() / 2) + ')';
            }).style('stroke', 'black').style('stroke-width', '0.8').style('cursor', 'pointer').on('mouseover', mouseover).on('mousemove', mousemove).on('mouseleave', mouseleave).on('click', _shared.integrativeHandleCellClick);

            // draw legend, this legend length, size is fixed.
            // 2 cases, discrete = activity,  continuous = BMC, different legned form.
            var legendLayer = svg.append('g').classed('legendLayer', true).attr('transform', 'translate(' + (width - margin.legend) + ',' + margin.top + ')');

            legendLayer.append('text').attr('className', 'legend-text').attr('x', 0).attr('y', 0).attr('transform', function (d, i) {
                return 'translate(25, ' + (margin.axisTop + (cellSize - 20) / 2) + ')';
            }).html('Developmental Toxicity Classification').style('font-size', 20);

            legendLayer.selectAll('.legendText') // Use a specific class for the selection
            .data(legendData.values).enter().append('text').attr('className', 'legend-text').attr('transform', function (d, i) {
                return 'translate(' + (15 + cellSize) + ', ' + (i * cellSize + margin.axisTop + (cellSize - 20) / 2 + cellSize) + ')';
            }).text(function (d) {
                return d.label;
            });
            legendLayer.selectAll('.legendRect') // Use a specific class for the selection
            .data(legendData.values).enter().append('rect').attr('width', cellSize - 20).attr('height', cellSize - 20).attr('fill', function (d) {
                return d.fill;
            }).attr('transform', function (d, i) {
                return 'translate(25, ' + (i * cellSize + margin.axisTop + cellSize) + ')';
            }).style('stroke', 'black').style('stroke-width', '1');
        };

        _this.state = {
            data: null
        };
        _this.handleResize = _this.handleResize.bind(_this);
        return _this;
    }

    _createClass(Heatmap, [{
        key: '_unrenderPlot',
        value: function _unrenderPlot() {
            if (this.refs.svg === undefined) {
                return;
            }
            window.removeEventListener('resize', this.handleResize);
            this.refs.svg.innerHTML = '';
        }
    }, {
        key: '_renderPlot',
        value: function _renderPlot() {
            if (this.refs.svg === undefined) {
                return;
            }
            this._unrenderPlot();
            // this is bootstrap plot svg
            this.renderPlot(this.refs.svg, this.props.data, this.props.legendData);
            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this._renderPlot();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._renderPlot();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this._renderPlot();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._unrenderPlot();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', { id: 'IA_heatmap01', ref: 'svg' });
        }
    }]);

    return Heatmap;
}(_react.Component);

Heatmap.propTypes = {
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        x: _propTypes2.default.string,
        y: _propTypes2.default.string,
        fill: _propTypes2.default.string
    })).isRequired,
    legendData: _propTypes2.default.shape({
        values: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            label: _propTypes2.default.string,
            fill: _propTypes2.default.string,
            chemical_casrn: _propTypes2.default.string,
            readout_id: _propTypes2.default.number,
            title: _propTypes2.default.string
        })),
        colorScaleFunction: _propTypes2.default.func,
        legendScale: _propTypes2.default.func
    }).isRequired,
    ontologyType: _propTypes2.default.number.isRequired
};

exports.default = Heatmap;

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _Tooltip = __webpack_require__(169);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _BootstrapModal = __webpack_require__(130);

var _BootstrapModal2 = _interopRequireDefault(_BootstrapModal);

var _BootstrapBodyPart = __webpack_require__(129);

var _d2 = __webpack_require__(275);

var _shared = __webpack_require__(11);

var _DoseResponseGridWidget = __webpack_require__(272);

var _DoseResponseGridWidget2 = _interopRequireDefault(_DoseResponseGridWidget);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DevtoxHeatmap = function (_Component) {
    _inherits(DevtoxHeatmap, _Component);

    function DevtoxHeatmap(props) {
        _classCallCheck(this, DevtoxHeatmap);

        var _this = _possibleConstructorReturn(this, (DevtoxHeatmap.__proto__ || Object.getPrototypeOf(DevtoxHeatmap)).call(this, props));

        _this.renderPlot = function (el, data, legendData) {
            (0, _$2.default)(el).empty();

            var margin = {
                top: 40,
                left: 10,
                bottom: 40,
                right: 40,
                axisLeft: 290,
                axisTop: 300,
                legend: 900
            },
                colorScaleFunction = legendData.colorScaleFunction,
                legendScale = legendData.legendScale,
                legendCirclesSizes = [0.5, 1.0, 1.5, 2.0, 2.5],
                cellSize = 50,
                legendCellSize = cellSize - 20,
                xMap = _lodash2.default.groupBy(data, 'x'),
                yMap = _lodash2.default.groupBy(data, 'y'),
                ontologyType = this.props.ontologyType,
                handleXLabelClick = function handleXLabelClick(label) {
                var cells = xMap[label];
                var cell = {
                    developmental_defect_grouping_general: cells[0].developmental_defect_grouping_general,
                    ontologyGroupName: cells[0].ontologyGroupName,
                    protocol_source: cells[0].protocol_source,
                    ontologyType: ontologyType
                };

                if (cell.developmental_defect_grouping_general && cell.protocol_source) {
                    new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.sankeyPlotGraphBody, {
                        title: label.replace(/:/g, ' +'),
                        cells: cell
                    });
                }
            },
                handleYLabelClick = function handleYLabelClick(label) {
                var cells = yMap[label],
                    casrns = [].concat(_toConsumableArray(new Set(cells.map(function (item) {
                    return item.casrn;
                })))),
                    dtxsids = [].concat(_toConsumableArray(new Set(cells.map(function (item) {
                    return item.dtxsid;
                }))));

                new _BootstrapModal2.default(_BootstrapBodyPart.Header, _BootstrapBodyPart.molecularGraphBody, {
                    title: dtxsids[0] + ' // ' + label + ' //  molecularGraph  ZWTBD',
                    dtxsid: dtxsids[0]
                });
            },
                mouseover = function mouseover(d) {
                tooltip.style('opacity', 1);
            },
                mousemove = function mousemove(d) {
                tooltip.html('<span style="font-size: 15px; font-weight: bold;">\n                Potency: ' + (0, _shared.printFloat)((0, _shared.pod_med_processed)(d.mean_pod)) + ' \u03BCM \n\n                Specificity: ' + (0, _shared.printFloat)(d.mean_selectivity) + '\n            </span>').style('left', d3.event.pageX - 200 + 'px').style('top', d3.event.pageY - 30 + 'px').style('opacity', 1.0);
            },
                mouseleave = function mouseleave(d) {
                tooltip.style('opacity', 0);
            },
                xasix = d3.map(data, function (d) {
                return d.x;
            }).keys().sort(),
                yasix = d3.map(data, function (d) {
                return d.y;
            }).keys().sort(),
                width = xasix.length * cellSize + margin.axisLeft + margin.left + margin.right + margin.legend,
                height = yasix.length * cellSize + margin.axisTop + margin.top + margin.bottom,
                chartHeight = height - (margin.top + margin.bottom + margin.axisTop),
                chartWidth = width - (margin.left + margin.right + margin.axisLeft + margin.legend),
                sizeDomain = [0, 2],
                size = d3.scaleSqrt().domain(sizeDomain).range([0, cellSize / 2]),
                square = d3.symbol().type(d3.symbolSquare).size(cellSize * cellSize),
                svg = d3.select(el).append('svg').attr('width', Math.max(1000, width + margin.left + margin.right)).attr('height', Math.max(1500, height + margin.left + margin.right)).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
                tooltip = d3.select(el).append('div').attr('class', 'tooltip').style('opacity', 0.0);

            // this.addStripMask(svg);
            // draw xy-axis
            var axisLayer = svg.append('g').attr('class', 'axisLayer')
            // .classed('axisLayer', true)
            .attr('width', width).attr('height', height);

            var xScale = d3.scaleBand().domain(xasix).range([0, chartWidth]);
            var yScale = d3.scaleBand().domain(yasix).range([0, chartHeight]);

            // //console.log(colorScaleFunction)
            // //console.log(legendScale)
            var xAxis = d3.axisTop(xScale).tickSizeOuter(0);
            var yAxis = d3.axisLeft(yScale).tickSizeOuter(0);
            axisLayer.append('g').attr('transform', 'translate(' + (margin.left + margin.axisLeft) + ', ' + (margin.top + margin.axisTop) + ')').attr('class', 'axis y').call(yAxis).style('font-size', 15).selectAll('text').style('cursor', 'pointer');
            // .on('click', handleYLabelClick)
            axisLayer.append('g').attr('transform', 'translate(' + (margin.left + margin.axisLeft) + ', ' + (margin.top + margin.axisTop) + ')').attr('class', 'axis x').call(xAxis).style('font-size', 15).selectAll('text').attr('dx', '.8em').attr('dy', '.55em').attr('transform', 'rotate(-65)').style('text-anchor', 'start').style('cursor', 'pointer').on('click', handleXLabelClick);

            var chartLayer = svg.append('g').classed('chartLayer', true).attr('width', chartWidth).attr('height', chartHeight).attr('transform', 'translate(' + (margin.left + margin.axisLeft) + ', ' + (margin.top + margin.axisTop) + ')');

            chartLayer.append('rect').attr('x', xScale.range()[0]).attr('y', yScale.range()[0]).attr('width', xScale.range()[1]).attr('height', yScale.range()[1]).attr('fill', 'transparent').style('stroke', 'black').style('stroke-width', 2);

            chartLayer.selectAll('.square').data(data)
            // .data(data.filter((d) => d.final_dev_call !== 'dev tox'))
            .enter().append('path').attr('class', 'square').attr('d', square).attr('fill', function (d) {
                return d.fill;
            }).attr('transform', function (d) {
                return 'translate(' + (xScale(d.x) + xScale.bandwidth() / 2) + ', ' + (yScale(d.y) + yScale.bandwidth() / 2) + ')';
            }).style('stroke', 'black').style('stroke-width', '0.8');

            var filteredData = data.filter(function (d) {
                return d.final_dev_call === 'dev tox';
            });

            var circles = chartLayer.selectAll('.circle').data(filteredData).enter().append('g').attr('class', 'cor').attr('transform', function (d) {
                return 'translate(' + (xScale(d.x) + xScale.bandwidth() / 2) + ', ' + (yScale(d.y) + yScale.bandwidth() / 2) + ')';
            });

            circles.append('circle').attr('class', 'circle').attr('r', function (d) {
                return size(Math.abs(d.mean_selectivity));
            }).attr('fill', function (d) {
                return colorScaleFunction((0, _shared.pod_med_processed)(d.mean_pod));
            }).style('opacity', 0.8).style('cursor', 'pointer').on('mouseover', mouseover).on('mousemove', mousemove).on('mouseleave', mouseleave).on('click', _shared.integrativeHandleCellClick);

            var legendLayer = svg.append('g').classed('legendLayer', true).attr('transform', 'translate(' + (width - margin.legend) + ',' + margin.top + ')');

            var legendCirclesWidth = 6 * cellSize,
                legend = legendLayer.append('defs').append('linearGradient').attr('id', 'gradient').attr('x1', '0%').attr('y1', '100%').attr('x2', '0%').attr('y2', '0%').attr('spreadMethod', 'pad'),
                legendHeight = 6 * cellSize;
            //console.log(legendScale);
            var ticks = legendScale.ticks();
            var maxIndex = ticks.length - 1; // Maximum index of ticks array

            //console.log(legendScale, ticks, maxIndex);
            legendScale.ticks().map(function (d, i) {
                var offset = i / maxIndex * 100; // Calculate offset as a percentage

                legend.append('stop')
                // .attr('offset', `${i}%`)
                .attr('offset', offset + '%') // Set offset based on index
                .attr('stop-color', colorScaleFunction(d)).attr('stop-opacity', 1);
            });
            // Append rectangle to display gradient
            //         legend
            legendLayer.append('rect').attr('width', legendCellSize).attr('height', legendHeight).style('fill', 'url(#gradient)')
            // .style('fill', 'url(#legend-gradient)')
            .style('stroke', 'black').attr('transform', 'translate(20,' + (margin.top + margin.axisTop) + ')');

            legendLayer.append('g').attr('class', 'axis y').attr('transform', 'translate(' + (20 + legendCellSize) + ',' + (margin.top + margin.axisTop) + ')').call((0, _d2.getLog10AxisFunction)(d3.axisRight, legendScale.copy().range([legendHeight, 0])));

            legendLayer.append('text').attr('class', 'legend-text').attr('x', 0).attr('y', 0).attr('transform', 'translate(20, ' + (margin.axisTop + legendCellSize / 2) + ')').text('BMC (µM)').style('font-size', 20);

            // this is white square part.
            legendLayer.append('rect').attr('x', 0).attr('y', 0).attr('width', legendCellSize).attr('height', legendCellSize).attr('transform', 'translate(' + 20 + ',\n                ' + (margin.top + margin.axisTop + legendHeight + legendCellSize * 1) + ')').attr('fill', 'transparent').style('stroke', 'black').style('stroke-width', '1');

            legendLayer.append('text').attr('class', 'legend-text').attr('x', 0).attr('y', 0).attr('transform', 'translate(' + (20 + cellSize) + ',\n                ' + (margin.top + margin.axisTop + legendHeight + legendCellSize + legendCellSize / 2) + ')').text('non-specific, non-toxic, inconclusive');

            // the reason I put 25/2 into this position transform, because square size is (25, 25),
            // make sure star is in center, make is position to be 25/2, 25/2

            // this is grey square part.
            legendLayer.append('rect').attr('x', 0).attr('y', 0).attr('width', legendCellSize).attr('height', legendCellSize).attr('transform', 'translate(' + 20 + ',\n                ' + (margin.top + margin.axisTop + legendHeight + legendCellSize * 2 + legendCellSize / 2) + ')').attr('mask', 'url(#stripeMask)').attr('fill', '#ccc');

            legendLayer.append('rect').attr('x', 0).attr('y', 0).attr('width', legendCellSize).attr('height', legendCellSize).attr('transform', 'translate(' + 20 + ',\n                ' + (margin.top + margin.axisTop + legendHeight + legendCellSize * 2 + legendCellSize / 2) + ')').attr('fill', 'transparent').style('stroke', 'black').style('stroke-width', '1');

            legendLayer.append('text').attr('class', 'legend-text').attr('x', 0).attr('y', 0).attr('transform', 'translate(' + (20 + cellSize) + ',\n                ' + (margin.top + margin.axisTop + legendHeight + legendCellSize * 2 + legendCellSize) + ')').text('not evaluated');
            //
            legendLayer.append('text').attr('class', 'legend-text').attr('x', 0).attr('y', 0).attr('transform', 'translate(20,\n                ' + (margin.top + margin.axisTop + legendHeight + legendCellSize * 5) + ')').text('specificity').style('font-size', 20);

            var legendCircles = legendLayer.append('g').classed('legendCircles', true);
            var spaceBetweenCircles = 10;
            legendCircles.selectAll('circle').data(legendCirclesSizes).enter().append('circle').attr('r', function (d) {
                return size(Math.abs(d));
            }).attr('fill', 'none').attr('cx', function (d, i) {
                return i * (cellSize + spaceBetweenCircles) + 30;
            }).attr('cy', margin.top + margin.axisTop + legendHeight + legendCellSize * 6).style('stroke', 'black').style('stroke-width', '1');

            legendCircles.selectAll('text').data(legendCirclesSizes).enter().append('text').attr('class', 'legend-text').attr('x', function (d, i) {
                return i * (cellSize + spaceBetweenCircles) + 20;
            }).attr('y', margin.top + margin.axisTop + legendHeight + legendCellSize * 8) // Adjusted y-coordinate
            // .attr('text-anchor', 'middle') // Center the text horizontally
            .attr('dominant-baseline', 'middle') // Center the text vertically
            .text(function (d) {
                return d.toFixed(1);
            });
        };

        _this.state = {
            data: null
        };
        _this.handleResize = _this.handleResize.bind(_this);
        return _this;
    }

    _createClass(DevtoxHeatmap, [{
        key: '_unrenderPlot',
        value: function _unrenderPlot() {
            if (this.refs.svg === undefined) {
                return;
            }
            window.removeEventListener('resize', this.handleResize);
            this.refs.svg.innerHTML = '';
        }
    }, {
        key: '_renderPlot',
        value: function _renderPlot() {
            if (this.refs.svg === undefined) {
                return;
            }
            this._unrenderPlot();
            // this is bootstrap plot svg

            this.renderPlot(this.refs.svg, this.props.data, this.props.legendData);

            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this._renderPlot();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._renderPlot();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this._renderPlot();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._unrenderPlot();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', { id: 'IA_heatmap02', ref: 'svg' });
        }
    }]);

    return DevtoxHeatmap;
}(_react.Component);

DevtoxHeatmap.propTypes = {
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        x: _propTypes2.default.string,
        y: _propTypes2.default.string,
        fill: _propTypes2.default.string
    })).isRequired,
    legendData: _propTypes2.default.shape({
        values: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            label: _propTypes2.default.string,
            fill: _propTypes2.default.string,
            chemical_casrn: _propTypes2.default.string,
            readout_id: _propTypes2.default.number,
            title: _propTypes2.default.string
        })),
        colorScaleFunction: _propTypes2.default.func,
        legendScale: _propTypes2.default.func
    }).isRequired,
    ontologyType: _propTypes2.default.number.isRequired
};

exports.default = DevtoxHeatmap;

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

var _lodash = __webpack_require__(16);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseWidget2 = __webpack_require__(23);

var _BaseWidget3 = _interopRequireDefault(_BaseWidget2);

var _shared = __webpack_require__(11);

var _HelpButtonWidget = __webpack_require__(18);

var _HelpButtonWidget2 = _interopRequireDefault(_HelpButtonWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChemicalWidget = function (_BaseWidget) {
    _inherits(ChemicalWidget, _BaseWidget);

    /*
    ChemicalWidget requires the following state properties:
        - chemList (enum)
        - chemicalFilterBy (enum)
        - chemicals (list of str)
        - categories (list of str)
    */

    function ChemicalWidget(props) {
        _classCallCheck(this, ChemicalWidget);

        var _this = _possibleConstructorReturn(this, (ChemicalWidget.__proto__ || Object.getPrototypeOf(ChemicalWidget)).call(this, props));

        _this.state = {
            showHelpText: false
        };
        _this.handleChemlistChange = _this.handleChemlistChange.bind(_this);
        _this.handleCategoryChange = _this.handleCategoryChange.bind(_this);
        return _this;
    }

    _createClass(ChemicalWidget, [{
        key: 'handleChemlistChange',
        value: function handleChemlistChange(e) {
            var d = {},
                state = this.props.stateHolder.state,
                value = parseInt(e.target.value);

            d[e.target.name] = value;

            // also update chemicals based on chemfilters
            d['chemicals'] = this._getSelectedChemicals(state.tbl_substances, state.categories, value);

            this.props.stateHolder.setState(d);
        }
    }, {
        key: 'handleCategoryChange',
        value: function handleCategoryChange(e) {
            var d = {},
                vals = (0, _$2.default)(e.target).val(),
                state = this.props.stateHolder.state;
            d[e.target.name] = vals;
            // also update chemicals based on chemfilters
            // d['casrn'] =  _.chain(state.Seazit_chemical_info)
            d['chemicals'] = _lodash2.default.chain(state.Seazit_chemical_info).filter(function (r) {
                return _lodash2.default.includes(vals, r.use_category1);
            }).map('casrn').uniq().value();
            this.props.stateHolder.setState(d);
        }
    }, {
        key: '_renderHelpText',
        value: function _renderHelpText() {
            if (!this.state.showHelpText) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'alert alert-info' },
                _react2.default.createElement(
                    'p',
                    null,
                    'More information on use categories and test substance name can be found on',
                    ' ',
                    _react2.default.createElement(
                        'a',
                        { href: (0, _shared.loadBaseUrl)('/seazit/dataset/') },
                        'Datasets page'
                    ),
                    '.'
                )
            );
        }
    }, {
        key: '_renderFilterBy',
        value: function _renderFilterBy(state) {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    { className: 'label-horizontal' },
                    'Filter test substance by:',
                    _react2.default.createElement(_HelpButtonWidget2.default, {
                        stateHolder: this,
                        headLevel: 'label',
                        title: 'More information on use categories and test substance names'
                    })
                ),
                this._renderHelpText(),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'chemicalFilterBy',
                            onChange: this.handleRadioChange,
                            value: _shared.CHEMFILTER_CATEGORY,
                            checked: state.chemicalFilterBy === _shared.CHEMFILTER_CATEGORY
                        }),
                        'Use category'
                    ),
                    _react2.default.createElement(
                        'span',
                        { style: { paddingLeft: '0.5em', paddingRight: '0.5em' } },
                        '|'
                    ),
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            name: 'chemicalFilterBy',
                            onChange: this.handleRadioChange,
                            value: _shared.CHEMFILTER_CHEMICIAL,
                            checked: state.chemicalFilterBy === _shared.CHEMFILTER_CHEMICIAL
                        }),
                        'Name (CASRN)'
                    )
                )
            );
        }
    }, {
        key: '_renderSelector',
        value: function _renderSelector(state) {
            var opts = void 0;
            if (state.chemicalFilterBy === _shared.CHEMFILTER_CHEMICIAL) {
                opts = _lodash2.default.chain(state.Seazit_chemical_info).filter(function (r) {
                    return r.use_category1 !== 'Vehicle Control';
                }) // Filter out data with use_category1 equal to 'Vehicle Control'
                .groupBy('preferred_name').values().map(function (r) {
                    return r[0];
                }).sortBy('preferred_name').map(function (r) {
                    return {
                        // category: 'Chemical Names',
                        category: r.use_category1,
                        key: r.casrn,
                        label: r.preferred_name + ' (' + r.casrn + ')'
                    };
                }).groupBy('category').value();
                return (0, _shared.renderSelectMultiOptgroupWidget)('chemicals', 'chemical', opts, state.chemicals, this.handleSelectMultiChange);
            } else {
                opts = _lodash2.default.chain(state.Seazit_chemical_info).filter(function (r) {
                    return r.use_category1 !== 'Vehicle Control';
                }) // Filter out data with use_category1 equal to 'Vehicle Control'
                .groupBy('use_category1').values().map(function (r) {
                    return r[0];
                }).sortBy('use_category1')
                // .uniq()
                .map(function (r) {
                    return {
                        key: r.use_category1,
                        label: r.use_category1
                    };
                })
                // .sortBy('key')
                .value();
                return (0, _shared.renderSelectMultiWidget)('categories', 'category', opts, state.categories, this.handleCategoryChange);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var state = this.props.stateHolder.state;
            return _react2.default.createElement(
                'div',
                { className: 'clearfix' },
                this._renderFilterBy(state),
                this._renderSelector(state)
            );
        }
    }]);

    return ChemicalWidget;
}(_BaseWidget3.default);

exports.default = ChemicalWidget;

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Plotly = __webpack_require__(128);

var _Plotly2 = _interopRequireDefault(_Plotly);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlotlyWrapper = function (_React$Component) {
    _inherits(PlotlyWrapper, _React$Component);

    function PlotlyWrapper() {
        _classCallCheck(this, PlotlyWrapper);

        return _possibleConstructorReturn(this, (PlotlyWrapper.__proto__ || Object.getPrototypeOf(PlotlyWrapper)).apply(this, arguments));
    }

    _createClass(PlotlyWrapper, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', { ref: 'plot' });
        }
    }, {
        key: 'renderPlotly',
        value: function renderPlotly(data, layout) {
            if (this.refs.plot && this.refs.plot.children.length > 0) {
                _Plotly2.default.update(this.refs.plot, data, layout);
            } else {
                _Plotly2.default.newPlot(this.refs.plot, data, layout);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _Plotly2.default.purge(this.refs.plot);
        }
    }]);

    return PlotlyWrapper;
}(_react2.default.Component);

exports.default = PlotlyWrapper;

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Plotly = __webpack_require__(128);

var _Plotly2 = _interopRequireDefault(_Plotly);

var _d = __webpack_require__(21);

var d3 = _interopRequireWildcard(_d);

var _PlotlyWrapper2 = __webpack_require__(510);

var _PlotlyWrapper3 = _interopRequireDefault(_PlotlyWrapper2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BmdChemicalPca = function (_PlotlyWrapper) {
    _inherits(BmdChemicalPca, _PlotlyWrapper);

    function BmdChemicalPca(props) {
        _classCallCheck(this, BmdChemicalPca);

        var _this = _possibleConstructorReturn(this, (BmdChemicalPca.__proto__ || Object.getPrototypeOf(BmdChemicalPca)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(BmdChemicalPca, [{
        key: '_getUrl',
        value: function _getUrl(bmdType) {
            return '/neurotox/api/' + bmdType + '/pca_chemical/?format=json';
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            var _this2 = this;

            var url = this._getUrl(nextProps.bmdType);
            d3.json(url, function (d) {
                _Plotly2.default.purge(_this2.refs.plot);
                _this2.renderPlotly(d.data, d.layout);
            });
            return false;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            var url = this._getUrl(this.props.bmdType);
            d3.json(url, function (d) {
                _this3.renderPlotly(d.data, d.layout);
            });
        }
    }]);

    return BmdChemicalPca;
}(_PlotlyWrapper3.default);

exports.default = BmdChemicalPca;

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
module.exports = __webpack_require__(716);


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(297);

var _iframe = __webpack_require__(715);

window.apps = {
    resizeIframe: _iframe.resizeIframe
};

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resizeIframe = undefined;

var _$ = __webpack_require__(41);

var _$2 = _interopRequireDefault(_$);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resizeIframe = function resizeIframe(iframe) {
    var yPadding = 25,
        duration = 250,
        resizeCheck = 5000;

    iframe.onload = function () {
        var iframeDoc = iframe.contentWindow.document,
            resizer = function resizer() {
            window.setTimeout(function () {
                iframe.height = iframeDoc.body.clientHeight + yPadding;
            }, duration);
        };

        // set height of iframe container to inner content
        iframe.height = iframeDoc.body.clientHeight + yPadding;

        // whenever an input changes, trigger resize
        (0, _$2.default)(iframeDoc.body).on('change', resizer);

        // whenever a nav tab is clicked (bootstrap3), trigger resize
        (0, _$2.default)(iframeDoc.body).on('click', '.nav-tabs', resizer);

        // whenever a nav tab is clicked (niehs careers), trigger resize
        (0, _$2.default)(iframeDoc.body).on('click', '.treeview', resizer);

        // check every few seconds and resize as needed
        setInterval(resizer, resizeCheck);
    };
};

exports.resizeIframe = resizeIframe;

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(297);

__webpack_require__(717);

var _seazit = __webpack_require__(1009);

var seazit = _interopRequireWildcard(_seazit);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

window.apps.seazit = seazit;

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _d = __webpack_require__(21);

_d.selection.prototype.moveToFront = function () {
    return this.each(function () {
        this.parentNode.appendChild(this);
    });
};

Number.prototype.toCustomString = function () {
    if (this > 1e6) {
        return this.toExponential(2).toUpperCase();
    } else if (this > 0.001) {
        return this.toLocaleString();
    } else {
        return this.toExponential(2).toUpperCase();
    }
};

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loading = function (_React$Component) {
    _inherits(Loading, _React$Component);

    function Loading() {
        _classCallCheck(this, Loading);

        return _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).apply(this, arguments));
    }

    _createClass(Loading, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "b",
                    null,
                    "Loading... "
                ),
                _react2.default.createElement("i", { className: "fa fa-cog fa-spin fa-fw" })
            );
        }
    }]);

    return Loading;
}(_react2.default.Component);

exports.default = Loading;

/***/ })

},[512]);


// WEBPACK FOOTER //
// main.044e903ae289fd87717e.js